unit Unit1;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, WEBLib.ExtCtrls, Vcl.StdCtrls,
  WEBLib.StdCtrls, XData.Web.Connection, XData.Web.Client, WEBLib.REST, strutils,
  WEBLib.DBCtrls, WEBLib.Storage, Data.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, WEBLib.DB, WEBLib.Grids, dateutils, WEBLib.ComCtrls, DB;

type
  TForm1 = class(TForm)
    Container1: THTMLContainer;
    Container2: THTMLContainer;
    labelonlinestatus: TLabel;
    WClient: TXDataWebClient;
    AuthConnection: TXDataWebConnection;
    WebHttpRequest1: THttpRequest;
    lblAnmeldung: TLabel;
    WebLocalStorage1: TLocalStorage;
    lblchecklogin: TLabel;
    xdsCadiaServerSettings: TXDataWebDataSet;
    xdsCadiaServerSettingsLS_MANDANT: TStringField;
    xdsCadiaServerSettingsLS_HTTPS: TBooleanField;
    xdsCadiaServerSettingsLS_PORT: TIntegerField;
    xdsCadiaServerSettingsLS_XDATA: TBooleanField;
    xdsCadiaServerSettingsLS_REMOTEDB: TBooleanField;
    xdsCadiaServerSettingsLS_JWT: TBooleanField;
    xdsCadiaServerSettingsLS_SUPERSECRETKEY: TStringField;
    xdsCadiaServerSettingsLS_DBBENUTZER: TStringField;
    xdsCadiaServerSettingsLS_DBPASSWORT: TStringField;
    xdsCadiaServerSettingsLS_CB_Personalnummer: TIntegerField;
    xdsCadiaServerSettingsLS_CB_LoginName: TStringField;
    xdsCadiaServerSettingsLS_CB_LoginPassword: TStringField;
    xdsPersonal: TXDataWebDataSet;
    xdsPersonalPersonalnummer: TIntegerField;
    xdsPersonalNachname: TStringField;
    xdsPersonalVorname: TStringField;
    xdsPersonalSchreibzeichen: TStringField;
    xdsPersonalLoginName: TStringField;
    xdsPersonalPassword: TStringField;
    xdsPersonalEnabled: TBooleanField;
    xdsPersonalEmail: TStringField;
    xdsPersonalFarbe: TIntegerField;
    xdsPersonalPersonalGUID: TStringField;
    xdsPersonalRechteCadiaWEB: TStringField;
    xdsPersonalStundensatzIntern: TFloatField;
    Container3: THTMLContainer;
    xdsMA: TXDataWebDataSet;
    Container4: THTMLContainer;
    xdsMAPersonalnummer: TIntegerField;
    xdsMANachname: TStringField;
    xdsMAVorname: TStringField;
    Container5: THTMLContainer;
    panelfunktionen: TPanel;
    btnAnmelden: TButton;
    btnPauseBeginn: TButton;
    btnPauseEnde: TButton;
    btnAbmelden: TButton;
    btnObjektBeginn: TButton;
    btnObjektEnde: TButton;
    btnErneutAnmelden: TButton;
    btnKontaktBeginn: TButton;
    btnKontaktEnde: TButton;
    btnAuftragBeginn: TButton;
    btnAuftragEnde: TButton;
    btnProduktionBeginn: TButton;
    btnProduktionEnde: TButton;
    btnPauseVorgabe: TButton;
    xdsSingleArbeitszeit: TXDataWebDataSet;
    xdsSingleArbeitszeitID: TStringField;
    xdsSingleArbeitszeitPersonalnummer: TIntegerField;
    xdsSingleArbeitszeitDatum: TDateTimeField;
    xdsSingleArbeitszeitEintragsArt: TIntegerField;
    xdsSingleArbeitszeitSollPause: TDateTimeField;
    sourceSingleArbeitszeit: TDataSource;
    xdsScan: TXDataWebDataSet;
    xdsScanPersonalnummer: TIntegerField;
    xdsScanScanDatumZeit: TDateTimeField;
    xdsScanDatum: TDateTimeField;
    xdsScanScanArt: TIntegerField;
    xdsScanObjektreferenz: TStringField;
    xdsScanScanBegin: TDateTimeField;
    xdsScanScanEnde: TDateTimeField;
    xdsScanausgewertet: TBooleanField;
    xdsScanAMS: TFloatField;
    xdsScanStundenArt: TStringField;
    xdsScanFAID: TXDataWebEntityField;
    xdsScanID: TStringField;
    xdsScanKundennummer: TStringField;
    xdsScanAuftrag: TStringField;
    xdsScanPAuftrag: TStringField;
    xdsScanArbeitArt: TStringField;
    xdsScanInfos: TStringField;
    xdsScanDauerMinuten: TFloatField;
    xdsScanKalkStundensatz: TFloatField;
    xdsScanKalkKosten: TFloatField;
    sourceScan: TDataSource;
    xdsPauseFix: TXDataWebDataSet;
    xdsPauseFixFAID: TXDataWebEntityField;
    xdsPauseFixID: TStringField;
    xdsPauseFixPersonalnummer: TIntegerField;
    xdsPauseFixScanDatumZeit: TDateTimeField;
    xdsPauseFixDatum: TDateTimeField;
    xdsPauseFixScanArt: TIntegerField;
    xdsPauseFixObjektreferenz: TStringField;
    xdsPauseFixScanBegin: TDateTimeField;
    xdsPauseFixScanEnde: TDateTimeField;
    xdsPauseFixausgewertet: TBooleanField;
    xdsPauseFixAMS: TFloatField;
    xdsPauseFixStundenArt: TStringField;
    xdsPauseFixKundennummer: TStringField;
    xdsPauseFixAuftrag: TStringField;
    xdsPauseFixPAuftrag: TStringField;
    xdsPauseFixArbeitArt: TStringField;
    xdsPauseFixInfos: TStringField;
    xdsPauseFixDauerMinuten: TFloatField;
    xdsPauseFixKalkStundensatz: TFloatField;
    xdsPauseFixKalkKosten: TFloatField;
    xdsStundenart: TXDataWebDataSet;
    xdsStundenartStundenArt: TStringField;
    sourceStundenart: TDataSource;
    TC: TTableControl;
    panelstundenart: TPanel;
    lblauswahlobjekt: TLabel;
    btnObjektOK: TButton;
    btnObjektAbbrechen: TButton;
    lookupstundenart: TComboBox;
    panelArbeitsart: TPanel;
    lblauswahlinfo: TLabel;
    radioarbeitsart: TRadioGroup;
    btnOK: TButton;
    btnAbbrechen: TButton;
    lblstatus: TLabel;
    xdsPZEEinstellungen: TXDataWebDataSet;
    xdsPZEEinstellungenZuordnungObjekt: TIntegerField;
    xdsPZEEinstellungenZuordnungKontakt: TIntegerField;
    xdsPZEEinstellungenZuordnungAuftrag: TIntegerField;
    xdsPZEEinstellungenZuordnungProduktion: TIntegerField;
    xdsPZEEinstellungenAuswahlNurKontaktnummer: TIntegerField;
    xdsPZEEinstellungenPauseVorgabe: TIntegerField;
    xdsPZEEinstellungenCadiaPZEWebModus: TIntegerField;
    LabelPZEFunktion: TLabel;
    ContainerMitarbeiterausweis: THTMLContainer;
    edtSuchbegriff: TEdit;
    LabelScanMitarbeiterausweis: TLabel;
    ContainerLabelMitarbeiterAuswahl: THTMLContainer;
    labelMitarbeiterauswahl: TLabel;
    WebTimer1: TTimer;
    xdsMARechteCadiaWEB: TStringField;
    ContainerModus: THTMLContainer;
    ContainerLetzteAktion: THTMLContainer;
    LabelLetzteAktion: TLabel;
    ContainerStatus: THTMLContainer;
    ContainerMitarbeiter: THTMLContainer;
    LabelMitarbeiter: TLabel;
    ContainerTable: THTMLContainer;
    WebProgressBar1: TProgressBar;
    ContainerProgress: THTMLContainer;
    xdsMAEintrittsdatum: TDateTimeField;
    xdsMAAustrittsdatum: TDateTimeField;
    WClientServerZeit: TXDataWebClient;
    ContainerZusatz: THTMLContainer;
    LabelZeitabweichung: TLabel;
    LabelScanAlternativ: TLabel;
    xdsStundenartSTDNR: TIntegerField;
    xdsCheckObjekt: TXDataWebDataSet;
    xdsCheckObjektObjektReferenz: TStringField;
    xdsCheckObjektKurzbezeichnung: TStringField;
    xdsCheckObjektBezeichnung: TStringField;
    xdsCheckObjektObjektnummer: TStringField;
    xdsCheckAuftrag: TXDataWebDataSet;
    xdsCheckAuftragNummerkomplett: TStringField;
    xdsCheckAuftragAuftragsbezeichnung: TStringField;
    xdsCheckProduktion: TXDataWebDataSet;
    xdsCheckProduktionNummerkomplett: TStringField;
    xdsCheckProduktionAuftragsbezeichnung: TStringField;
    xdsCheckKontakt: TXDataWebDataSet;
    xdsCheckKontaktKundennummer: TStringField;
    xdsCheckKontaktNachname: TStringField;
    xdsCheckKontaktVorname: TStringField;
    lblCadiaKundennummer: TLabel;
    ScanTimer: TTimer;
    procedure WebFormCreate(Sender: TObject);
    procedure AuthConnectionConnect(Sender: TObject);
    procedure WebFormBeforeUnload(Sender: TObject; var AMessage: string);
    procedure WebHttpRequest1Response(Sender: TObject; AResponse: string);
    procedure WebFormShow(Sender: TObject);
    procedure xdsCadiaServerSettingsAfterOpen(DataSet: TDataSet);
    procedure xdsPersonalAfterOpen(DataSet: TDataSet);
    procedure xdsMAAfterOpen(DataSet: TDataSet);
    procedure xdsSingleArbeitszeitAfterOpen(DataSet: TDataSet);
    procedure xdsStundenartAfterOpen(DataSet: TDataSet);
    procedure xdsScanAfterOpen(DataSet: TDataSet);
    procedure btnAuftragEndeClick(Sender: TObject);
    procedure btnKontaktEndeClick(Sender: TObject);
    procedure btnPauseEndeClick(Sender: TObject);
    procedure btnObjektEndeClick(Sender: TObject);
    procedure btnProduktionEndeClick(Sender: TObject);
    procedure btnAnmeldenClick(Sender: TObject);
    procedure xdsScanNewRecord(DataSet: TDataSet);
    procedure xdsScanAfterPost(DataSet: TDataSet);
    procedure xdsScanAfterApplyUpdates(Sender: TDataSet; Info: TResolveResults);
    procedure btnPauseVorgabeClick(Sender: TObject);
    procedure xdsPauseFixAfterOpen(DataSet: TDataSet);
    procedure xdsPauseFixAfterPost(DataSet: TDataSet);
    procedure xdsPauseFixAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure btnPauseBeginnClick(Sender: TObject);
    procedure btnObjektBeginnClick(Sender: TObject);
    procedure btnKontaktBeginnClick(Sender: TObject);
    procedure btnAuftragBeginnClick(Sender: TObject);
    procedure btnErneutAnmeldenClick(Sender: TObject);
    procedure btnProduktionBeginnClick(Sender: TObject);
    procedure btnObjektOKClick(Sender: TObject);
    procedure btnOKClick(Sender: TObject);
    procedure btnAbbrechenClick(Sender: TObject);
    procedure xdsPZEEinstellungenAfterOpen(DataSet: TDataSet);
    procedure WebTimer1Timer(Sender: TObject);
    procedure setcontrols;
    procedure edtSuchbegriffChange(Sender: TObject);
    procedure btnAbmeldenClick(Sender: TObject);
    procedure xdsCheckObjektAfterOpen(DataSet: TDataSet);
    procedure WebFormKeyPress(Sender: TObject; var Key: Char);
    procedure xdsCheckAuftragAfterOpen(DataSet: TDataSet);
    procedure xdsCheckProduktionAfterOpen(DataSet: TDataSet);
    procedure xdsCheckKontaktAfterOpen(DataSet: TDataSet);
    procedure ScanTimerTimer(Sender: TObject);
    procedure edtSuchbegriffKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
  private
    { Private-Deklarationen }
    FScanInProgress: Boolean;
  public
    { Public-Deklarationen }
    type
      TRechteCadiaWebR = Record
        Zugelassen:boolean;
        Kontakte:boolean;
        Artikel:boolean;
        OffeneAngebote:boolean;
        OffeneAuftraege:boolean;
        OffeneLieferscheine:boolean;
        Termine:boolean;
        NurPersTermine:boolean;
        Emails:boolean;
        BelegePositionen:boolean;
        Anrufe:boolean;
        Zeiterfassung:boolean;
        Einkaufspreise:boolean;
        Verkaufspreise:boolean;
        Mitteilungen:boolean;
        Inventur:boolean;
    End;
    var RCW:TRechteCadiaWebR;
    var RCWLIST:TStringList;
    PZE_Personalnummer:string;
    webverlassen:string;
    webverlassennichtfragen:boolean;
    btnProMa:TButton;
    procedure btnProMaclick(Sender:TObject);
    procedure RCWLISTtoRECORD;
    procedure RCWleeren;
    procedure AppOnlineChange(Sender:TObject; AStatus: TOnlineStatus);
    procedure Tokenholen(Username, Password: string);
    function XorStr(const Text: string; Key: Integer): string;
    function StripSonderzeichen(alterstring:string):string;
    function CleanString(S: string): string;
    procedure showstatus;
    procedure kontaktsuche1;
    procedure kontaktsuche2;
    procedure LetztenScanEintragBeenden;
    procedure ProcessBarcode(ACode:string);
  protected procedure LoadDFMValues; override; end;
const
  Versionslabel1='©2023-2026 Cadia Software GmbH Version ';
  Versionslabel2='1.2.0';
  Versionslabel3='23.01.2026';
  Versionslabel4=' <a href="https://www.cadia.de" target="_blank">(Webseite)</a>';
  CadiaAppKey='123713501';
  CadiaAppKeyServerLizenz='123458420';
var
  Form1: TForm1;
  Versionslabel:string;
  CadiaKundennummer:string;
  BenutzerAngemeldet:Boolean;
  BenutzerLoginName:string;
  BenutzerPasswort:string;
  BenutzerPersonalnummer:string;
  BenutzerNachname:string;
  BenutzerVorname:string;
  BenutzerSchreibzeichen:string;
  BenutzerEmail:string;
  BenutzerFarbe:integer;
  BenutzerID:string;
  BenutzerStundensatzIntern:double;
  TextAbsenderzeile:string;
  xdataDATASERVER:string;
  xdataconnectionstring:string;
  xdataauthconnection:string;
  downloadconnection:string;
  xdatausername:string;
  xdatapassword:string;
  Merkerkontaktnummer:string;
  MerkerArtikelnummer:string;
  LizenzOK:boolean;
  vtoken:string;
  ajahr, amonat, atag,astunde,aminute,asekunde,ams:word;
  scannereinstellung:string;
  PZE_AutoObjektnummer:string;
  PZE_AutoAuftragnummer:string;
  PZE_Objekt_erlaubt:integer;
  PZE_Auftrag_erlaubt:integer;
  ftjahr,ftmonat,fttag,ftstunde,ftminute,ftsekunde,ftms:word;
  fjjahr,fjmonat,fjtag,fjstunde,fjminute,fjsekunde,fjms:word;
  datumohnezeit:string;
  mytempdatumzeit:TDateTime;
  myScanArt:integer;
  myDoApply:integer;
  myObjektReferenz:string;
  myKontaktReferenz:string;
  myAuftragReferenz:string;
  myProduktionReferenz:string;
  myInfos:string;
  myArbeitArt:string;
  myStundenart:string;
  myObjStundenart:string;
  myPauseSoll:TDateTime;
  myPauseVorgabe:integer;
  PZEModus:integer;
  PZE_LetzteAktionText:string;
  PZE_AktuellerMitarbeiterText:string;
  TimerStartZeit:TDateTime;
  SERVERDATUMUHRZEIT:TDateTime;
  ZeitAbweichungSek:int64;
  myObjRef:string;
  myStdRef:string;
  KuerzelAuftrag:string;
  myAuftragRef:string;
  myProdRef:string;
  myKontaktRef:string;
  //ScanArten
  // 1=Anmelden
  // 2=Pause
  // 3=Pause Ende
  // 4=Objekt
  // 5=Objekt Ende
  // 9=Abmelden
  // 14=Kontakt
  // 15=Kontak Ende
  // 24=Auftrag
  // 25=AuftragEnde
  // 34=Produktion
  // 35=ProduktionEnde
implementation
  uses unit2, unit_Objektsuche, unit_Kontaktnummersuche, unit_Kontaktsuche, unit_AuftragSuche, unit_ProduktionSuche;
{$R *.dfm}

function TForm1.CleanString(S: string): string;
var
  I: Integer;
  Allowed: string;
begin
  Allowed := 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  Result := '';
  for I := 1 to Length(S) do
    if Pos(S[I], Allowed) > 0 then
      Result := Result + S[I];
end;

procedure TForm1.setcontrols;
var
  myelement:TJSHTMLElement;
begin
  if BenutzerAngemeldet then
  begin
    lblAnmeldung.Caption:='User: '+BenutzerPersonalnummer;
  end
  else
  begin
    lblAnmeldung.Caption:='No User';
  end;
  LabelLetzteAktion.ElementClassName:='h6 center text-info';
  LabelLetzteAktion.Caption:=PZE_LetzteAktionText;
  if PZEModus=0 then LabelPZEFunktion.Caption:='Die Zeiterfassung über CadiaPZEWeb ist nicht aktiviert';
  if PZEModus=1 then LabelPZEFunktion.Caption:='Scan-Modus '+ FormatDateTime('DDD DD.MM.YYYY',date);
  if PZEModus=2 then LabelPZEFunktion.Caption:='Multi-Modus '+ FormatDateTime('DDD DD.MM.YYYY',date);



  if PZE_Personalnummer='' then
  begin
    WebProgressbar1.Visible:=false;
    PZE_AktuellerMitarbeiterText:='keine Mitarbeiter gewählt';
    LabelMitarbeiter.Caption:=PZE_AktuellerMitarbeiterText;
    edtSuchbegriff.Text:='';
    edtSuchbegriff.Visible:=true;
    LabelMitarbeiter.Visible:=false;
    if PZEModus=2 then labelmitarbeiterauswahl.Visible:=true;
    if PZEModus=1 then labelmitarbeiterauswahl.Visible:=false;
    LabelScanAlternativ.Visible:=false;
    LabelScanMitarbeiterausweis.Visible:=true;
    lblstatus.Visible:=false;
    panelfunktionen.Visible:=false;
    panelArbeitsart.Visible:=false;
    myelement:=Container4.ElementHandle;
    tc.Visible:=false;
    container4.HTML.text:='';
    if PZEModus=2 then
    begin
      xdsma.First;
      while not xdsma.eof do
      begin
        RCWlist.text:=xdsMArechtecadiaweb.asstring;
        RCWLISTtoRECORD;
        if ((xdsMAAustrittsdatum.IsNull) OR (xdsMAAustrittsdatum.asstring='')) AND (RCW.Zeiterfassung=true) then
        begin
          btnProMa:=TButton.Create(self);
          btnProMa.ElementClassName:='btn btn-sm btn-info m-1';
          btnProMa.HeightStyle:=ssauto;
          btnProMa.WidthStyle:=ssAbsolute;
          btnProMa.Width:=250;
          btnProMa.tag:=xdsMAPersonalnummer.Asinteger;
          btnProMa.Caption:=xdsMAPersonalnummer.AsString+' '+xdsMANachname.asstring+' '+xdsMAVorname.asstring;
          btnProMa.OnClick:=@btnProMaClick;
          btnProMa.ParentElement:=myelement;
        end;
        xdsma.Next;

      end;
      container4.visible:=true;
    end;
    if PZEModus=0 then
    begin
      labelmitarbeiterauswahl.Visible:=false;
      LabelScanMitarbeiterausweis.Visible:=false;
      LabelScanAlternativ.Visible:=false;
      edtsuchbegriff.Visible:=false;
    end;
  end
  else
  begin

    if xdsMA.Locate('Personalnummer',PZE_Personalnummer,[])=true then
    begin
      RCWlist.text:=xdsMArechtecadiaweb.asstring;
      RCWleeren;
      RCWLISTtoRECORD;
    end;
    container4.HTML.Text:='';
    LabelMitarbeiter.Visible:=true;
    edtSuchbegriff.Visible:=false;
    LabelScanMitarbeiterausweis.Visible:=false;
    if PZEModus=1 then
    begin
      LabelScanAlternativ.Visible:=true;
      edtSuchbegriff.Visible:=true;
      panelfunktionen.Visible:=false;
    end;
    labelmitarbeiterauswahl.Visible:=false;
    LabelLetzteAktion.Caption:=PZE_LetzteAktionText;
    PZE_AktuellerMitarbeiterText:=xdsmapersonalnummer.asstring+' '+xdsmanachname.asstring+' '+xdsMAVorname.asstring;
    LabelMitarbeiter.Caption:=PZE_AktuellerMitarbeiterText;
    lblstatus.Visible:=true;
    tc.Visible:=true;
  end;
  edtSuchbegriff.Text:='';
  if edtsuchbegriff.visible then edtsuchbegriff.SetFocus;

end;

procedure TForm1.showstatus;
begin
  xdsscan.Close;
  xdsstundenart.Close;
  xdsstundenart.load;
end;

procedure TForm1.btnAbbrechenClick(Sender: TObject);
begin
  panelArbeitsart.Visible:=false;
  showstatus;
end;

procedure TForm1.btnAbmeldenClick(Sender: TObject);
begin
  myDoApply:=0;
  mytempdatumzeit:=date+time;
  decodedatetime(mytempdatumzeit,ftjahr,ftmonat,fttag,ftstunde,ftminute,ftsekunde,ftms);
  myScanArt:=9;
  xdsscan.Last;
  xdsscan.Edit;
  xdsScanScanEnde.AsDateTime:=encodetime(ftstunde,ftminute,0,0);
  xdsscan.Post;
  myDoApply:=1;
  xdsscan.Append;
end;

procedure TForm1.btnAnmeldenClick(Sender: TObject);
begin
  mytempdatumzeit:=date+time;
  decodedatetime(mytempdatumzeit,ftjahr,ftmonat,fttag,ftstunde,ftminute,ftsekunde,ftms);
  mydoapply:=1;
  myscanart:=1;
  xdsSCAN.Append;
end;

procedure TForm1.btnAuftragBeginnClick(Sender: TObject);
var
  LFrm:TfrmAuftragSuche;
    procedure AfterCreate(AForm:TObject);
    var
      LForm:TfrmAuftragSuche;
    begin
      LForm:=(AForm as TfrmAuftragSuche);
      lform.Auftragnummer:='';
    end;

    procedure AfterShowmodal(Avalue:TModalResult);
    begin
      if lfrm.Auftragnummer<>'' then
      begin
        myAuftragReferenz:=lfrm.Auftragnummer;
        myInfos:=trim(lfrm.LUAuftragsbezeichnung);
        myDoApply:=0;
        myScanArt:=24;
        panelfunktionen.Visible:=false;
        panelArbeitsart.Visible:=true;
        lblauswahlinfo.Caption:=myAuftragReferenz+' '+myinfos;

      end;
      if lfrm.Auftragnummer='' then
      begin
        LabelLetzteAktion.Caption:='Der Vorgang wird abgebrochen, da Sie keinen Auftrag ausgewählt haben';
        LabelLetzteAktion.ElementClassName:='h4 center text-danger';
      end;

    end;

  begin
  TimerStartZeit:=Date+time;
  LFrm:=TfrmAuftragSuche.CreateNew(@AfterCreate);
 // LFrm.Popup:=true;
  LFrm.ShowModal(@AfterShowmodal);

end;

procedure TForm1.btnAuftragEndeClick(Sender: TObject);
begin
  myDoApply:=0;
  mytempdatumzeit:=date+time;
  decodedatetime(mytempdatumzeit,ftjahr,ftmonat,fttag,ftstunde,ftminute,ftsekunde,ftms);
  myScanArt:=25;
  xdsscan.Last;
  xdsscan.Edit;
  xdsScanScanEnde.AsDateTime:=encodetime(ftstunde,ftminute,0,0);
  xdsScanDauerMinuten.AsFloat:=Minutesbetween(xdsScanScanBegin.AsDateTime,xdsScanScanEnde.AsDateTime);
  xdsScanKalkStundensatz.AsFloat:=BenutzerStundensatzIntern;

  try
    xdsScanKalkKosten.AsFloat:=xdsScanKalkStundensatz.AsFloat/60*xdsScanDauerMinuten.AsFloat;
  except

  end;

  xdsscan.Post;
  myDoApply:=1;
  xdsscan.Append;
end;

procedure TForm1.btnErneutAnmeldenClick(Sender: TObject);
begin
  myDoApply:=0;
  mytempdatumzeit:=date+time;
  decodedatetime(mytempdatumzeit,ftjahr,ftmonat,fttag,ftstunde,ftminute,ftsekunde,ftms);
  myScanArt:=3;
  xdsscan.Last;
  xdsscan.Edit;
  xdsScanScanEnde.AsDateTime:=encodetime(ftstunde,ftminute,0,0);
  xdsScanScanArt.AsInteger:=2;
  xdsscan.Post;
  myDoApply:=1;
  xdsscan.Append;
end;

procedure TForm1.btnKontaktBeginnClick(Sender: TObject);
begin
  TimerStartZeit:=Date+time;
  if xdsPZEEinstellungenAuswahlNurKontaktnummer.AsInteger=0 then kontaktsuche1;
  if xdsPZEEinstellungenAuswahlNurKontaktnummer.AsInteger=1 then kontaktsuche2;
end;

procedure TForm1.btnKontaktEndeClick(Sender: TObject);
begin
  myDoApply:=0;
  mytempdatumzeit:=date+time;
  decodedatetime(mytempdatumzeit,ftjahr,ftmonat,fttag,ftstunde,ftminute,ftsekunde,ftms);
  myScanArt:=15;
  xdsscan.Last;
  xdsscan.Edit;
  xdsScanScanEnde.AsDateTime:=encodetime(ftstunde,ftminute,0,0);
  xdsScanDauerMinuten.AsFloat:=Minutesbetween(xdsScanScanBegin.AsDateTime,xdsScanScanEnde.AsDateTime);
  xdsScanKalkStundensatz.AsFloat:=BenutzerStundensatzIntern;

  try
    xdsScanKalkKosten.AsFloat:=xdsScanKalkStundensatz.AsFloat/60*xdsScanDauerMinuten.AsFloat;
  except

  end;

  xdsscan.Post;
  myDoApply:=1;
  xdsscan.Append;
end;

procedure TForm1.btnObjektBeginnClick(Sender: TObject);
var
  LFrm:TfrmObjektsuche;
    procedure AfterCreate(AForm:TObject);
    var
      LForm:TfrmObjektsuche;
    begin
      LForm:=(AForm as TfrmObjektsuche);
      lform.Objektreferenz:='';
    end;

    procedure AfterShowmodal(Avalue:TModalResult);
    begin
      if lfrm.Objektreferenz<>'' then
      begin
        myobjektreferenz:=lfrm.Objektreferenz;
        myinfos:=trim(lfrm.luObjektnummer+' '+lfrm.luObjektkurzbezeichnung);
        myDoApply:=0;
        mytempdatumzeit:=date+time;
        decodedatetime(mytempdatumzeit,ftjahr,ftmonat,fttag,ftstunde,ftminute,ftsekunde,ftms);
        myScanArt:=4;
        panelfunktionen.Visible:=false;
        panelstundenart.Visible:=true;
        lookupstundenart.text:='[-]';
        lblauswahlobjekt.Caption:=myobjektreferenz+' '+myinfos;

      end;
      if lfrm.Objektreferenz='' then
      begin
        LabelLetzteAktion.Caption:='Der Vorgang wird abgebrochen, da Sie kein Objekt ausgewählt haben';
        LabelLetzteAktion.ElementClassName:='h4 center text-danger';
      end;

    end;

  begin
  TimerStartZeit:=Date+time;
  LFrm:=TfrmObjektsuche.CreateNew(@AfterCreate);
 // LFrm.Popup:=true;
  LFrm.ShowModal(@AfterShowmodal);

end;

procedure TForm1.btnObjektEndeClick(Sender: TObject);
begin
  myDoApply:=0;
  mytempdatumzeit:=date+time;
  decodedatetime(mytempdatumzeit,ftjahr,ftmonat,fttag,ftstunde,ftminute,ftsekunde,ftms);
  myScanArt:=5;
  xdsscan.Last;
  xdsscan.Edit;
  xdsScanScanEnde.AsDateTime:=encodetime(ftstunde,ftminute,0,0);
  xdsScanDauerMinuten.AsFloat:=Minutesbetween(xdsScanScanBegin.AsDateTime,xdsScanScanEnde.AsDateTime);
  xdsscan.Post;
  myDoApply:=1;
  xdsscan.Append;
end;

procedure TForm1.btnObjektOKClick(Sender: TObject);
begin
  myObjStundenart:='[-]';
  panelstundenart.Visible:=false;
  mytempdatumzeit:=date+time;
  myArbeitArt:='[-]';
  myobjstundenart:=lookupstundenart.text;
  decodedatetime(mytempdatumzeit,ftjahr,ftmonat,fttag,ftstunde,ftminute,ftsekunde,ftms);
  xdsscan.Last;
  xdsscan.Edit;
  xdsScanScanEnde.AsDateTime:=encodetime(ftstunde,ftminute,0,0);
  xdsscan.Post;
  myDoApply:=1;
  xdsscan.Append;
end;

procedure TForm1.btnOKClick(Sender: TObject);
begin
  panelArbeitsart.Visible:=false;
  mytempdatumzeit:=date+time;
  myArbeitArt:='[-]';
  if radioarbeitsart.ItemIndex=1 then myArbeitArt:='Arbeitszeit';
  if radioarbeitsart.ItemIndex=2 then myArbeitArt:='Fahrzeit';
  decodedatetime(mytempdatumzeit,ftjahr,ftmonat,fttag,ftstunde,ftminute,ftsekunde,ftms);
  xdsscan.Last;
  xdsscan.Edit;
  xdsScanScanEnde.AsDateTime:=encodetime(ftstunde,ftminute,0,0);
  xdsscan.Post;
  myDoApply:=1;
  xdsscan.Append;
end;

procedure TForm1.btnPauseBeginnClick(Sender: TObject);
begin
  myDoApply:=0;
  mytempdatumzeit:=date+time;
  decodedatetime(mytempdatumzeit,ftjahr,ftmonat,fttag,ftstunde,ftminute,ftsekunde,ftms);
  myScanArt:=2;
  xdsscan.Last;
  xdsscan.Edit;
  xdsScanScanEnde.AsDateTime:=encodetime(ftstunde,ftminute,0,0);
  xdsscan.Post;
  myDoApply:=1;
  myInfos:='Pause';
  myPauseVorgabe:=0;
  xdsscan.Append;
end;

procedure TForm1.btnPauseEndeClick(Sender: TObject);
begin
  myDoApply:=0;
  mytempdatumzeit:=date+time;
  decodedatetime(mytempdatumzeit,ftjahr,ftmonat,fttag,ftstunde,ftminute,ftsekunde,ftms);
  myScanArt:=3;
  xdsscan.Last;
  xdsscan.Edit;
  xdsScanScanEnde.AsDateTime:=encodetime(ftstunde,ftminute,0,0);
  xdsScanDauerMinuten.AsFloat:=Minutesbetween(xdsScanScanBegin.AsDateTime,xdsScanScanEnde.AsDateTime);
  xdsscan.Post;
  myDoApply:=1;
  xdsscan.Append;
end;

procedure TForm1.btnPauseVorgabeClick(Sender: TObject);
begin
  xdsPauseFix.Load;
end;

procedure TForm1.btnProduktionBeginnClick(Sender: TObject);
var
  LFrm:TfrmProduktionSuche;
    procedure AfterCreate(AForm:TObject);
    var
      LForm:TfrmProduktionSuche;
    begin
      LForm:=(AForm as TfrmProduktionSuche);
      lform.Produktionnummer:='';
    end;

    procedure AfterShowmodal(Avalue:TModalResult);
    begin
      if lfrm.Produktionnummer<>'' then
      begin
        myProduktionReferenz:=lfrm.Produktionnummer;
        myInfos:=trim(lfrm.LUAuftragsbezeichnung);
        myDoApply:=0;
        myScanArt:=34;
        mytempdatumzeit:=date+time;
        myArbeitArt:='[-]';
        decodedatetime(mytempdatumzeit,ftjahr,ftmonat,fttag,ftstunde,ftminute,ftsekunde,ftms);
        xdsscan.Last;
        xdsscan.Edit;
        xdsScanScanEnde.AsDateTime:=encodetime(ftstunde,ftminute,0,0);
        xdsscan.Post;
        myDoApply:=1;
        xdsscan.Append;

      end;
      if lfrm.Produktionnummer='' then
      begin
        LabelLetzteAktion.Caption:='Der Vorgang wird abgebrochen, da Sie keinen Produktions-Auftrag ausgewählt haben';
        LabelLetzteAktion.ElementClassName:='h4 center text-danger';
      end;

    end;

  begin
  TimerStartZeit:=Date+time;
  LFrm:=TfrmProduktionSuche.CreateNew(@AfterCreate);
 // LFrm.Popup:=true;
  LFrm.ShowModal(@AfterShowmodal);

end;

procedure TForm1.btnProduktionEndeClick(Sender: TObject);
begin
  myDoApply:=0;
  mytempdatumzeit:=date+time;
  decodedatetime(mytempdatumzeit,ftjahr,ftmonat,fttag,ftstunde,ftminute,ftsekunde,ftms);
  myScanArt:=35;
  xdsscan.Last;
  xdsscan.Edit;
  xdsScanScanEnde.AsDateTime:=encodetime(ftstunde,ftminute,0,0);
  xdsScanDauerMinuten.AsFloat:=Minutesbetween(xdsScanScanBegin.AsDateTime,xdsScanScanEnde.AsDateTime);
  xdsScanKalkStundensatz.AsFloat:=BenutzerStundensatzIntern;

  try
    xdsScanKalkKosten.AsFloat:=xdsScanKalkStundensatz.AsFloat/60*xdsScanDauerMinuten.AsFloat;
  except

  end;

  xdsscan.Post;
  myDoApply:=1;
  xdsscan.Append;
end;

procedure TForm1.btnProMaclick(Sender: TObject);
begin
  TimerStartZeit:=Date+time;
  webtimer1.Enabled:=true;
  PZE_Personalnummer:=inttostr((sender as TButton).Tag);
  PZE_LetzteAktionText:=PZE_Personalnummer+' ausgewählt';
  xdsstundenart.Close;

  xdsstundenart.load;
end;

procedure TForm1.edtSuchbegriffChange(Sender: TObject);
begin
  FScanInProgress := True;

  // Timer neu starten
  ScanTimer.Enabled := False;
  ScanTimer.Enabled := True;
end;

procedure TForm1.edtSuchbegriffKeyDown(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  if Key = 13 then // ENTER
  begin
    ScanTimer.Enabled := False;
    FScanInProgress := False;

    ProcessBarcode(edtSuchbegriff.Text);

    edtSuchbegriff.Text := '';
    Key := 0; // ENTER unterdrücken
  end;
end;

procedure TForm1.Tokenholen(Username, Password: string);
  procedure OnResponse(Response:TXDataClientResponse);
  begin
    vtoken:=string(TJSObject(response.Result)['value']);
    if xdataconnectionstring<>'' then
    begin
      dm2.XDataWebConnection1.url:=xdataconnectionstring;
      dm2.xdatawebconnection1.Connected:=true;
    end;
  end;
begin
  labelonlinestatus.Caption:='hole token';
  WClient.RawInvoke('ILoginService.Login',[Username,Password],@OnResponse);
end;

function TForm1.XorStr(const Text: string; Key: Integer): string;
var
  i: Integer;
begin
  SetLength(Result, Length(Text));
  for i:=1 to Length(Text) do
  begin
    if Text[i] > #31 then
      Result[i] := Chr(Ord(Text[i]) xor Key)
    else
      Result[i] := Text[i];
  end;
end;

function TForm1.StripSonderzeichen(alterstring:string):string;
var
  neustring:string;
begin
  result:='';
  neustring:=trim(alterstring);
  neustring:=stringreplace(neustring,'.','_',[rfreplaceall]);
  neustring:=stringreplace(neustring,'\','_',[rfreplaceall]);
  neustring:=stringreplace(neustring,'/','_',[rfreplaceall]);
  neustring:=stringreplace(neustring,':','_',[rfreplaceall]);
  neustring:=stringreplace(neustring,'*','_',[rfreplaceall]);
  neustring:=stringreplace(neustring,'*','_',[rfreplaceall]);
  neustring:=stringreplace(neustring,'"','_',[rfreplaceall]);
  neustring:=stringreplace(neustring,'~','_',[rfreplaceall]);
  neustring:=stringreplace(neustring,'<','_',[rfreplaceall]);
  neustring:=stringreplace(neustring,'>','_',[rfreplaceall]);
  neustring:=stringreplace(neustring,'|','_',[rfreplaceall]);
  neustring:=stringreplace(neustring,'{','_',[rfreplaceall]);
  neustring:=stringreplace(neustring,'}','_',[rfreplaceall]);
  neustring:=stringreplace(neustring,'[','_',[rfreplaceall]);
  neustring:=stringreplace(neustring,']','_',[rfreplaceall]);
  neustring:=stringreplace(neustring,' ','_',[rfreplaceall]);
  neustring:=stringreplace(neustring,'&','_',[rfreplaceall]);
  result:=neustring;
end;

procedure TForm1.AppOnlineChange(Sender:TObject; AStatus: TOnlineStatus);
begin
  if (Application.IsOnline) then labelonlinestatus.Caption:='online' else labelonlinestatus.Caption:='offline';
end;

procedure TForm1.RCWLISTtoRECORD;
begin

  if RCWLIST.Values['Zugelassen']<>'' then RCW.Zugelassen:=strtobool(RCWLIST.Values['Zugelassen']) else RCW.Zugelassen:=TRUE;
  if RCWLIST.Values['Kontakte']<>'' then RCW.Kontakte:=strtobool(RCWLIST.Values['Kontakte']) else RCW.Kontakte:=TRUE;
  if RCWLIST.Values['Artikel']<>'' then RCW.Artikel:=strtobool(RCWLIST.Values['Artikel']) else RCW.Artikel:=TRUE;
  if RCWLIST.Values['OffeneAngebote']<>'' then RCW.OffeneAngebote:=strtobool(RCWLIST.Values['OffeneAngebote']) else RCW.OffeneAngebote:=TRUE;
  if RCWLIST.Values['OffeneAuftraege']<>'' then RCW.OffeneAuftraege:=strtobool(RCWLIST.Values['OffeneAuftraege']) else RCW.OffeneAuftraege:=TRUE;
  if RCWLIST.Values['OffeneLieferscheine']<>'' then RCW.OffeneLieferscheine:=strtobool(RCWLIST.Values['OffeneLieferscheine']) else RCW.OffeneLieferscheine:=TRUE;
  if RCWLIST.Values['Termine']<>'' then RCW.Termine:=strtobool(RCWLIST.Values['Termine']) else RCW.Termine:=TRUE;
  if RCWLIST.Values['NurPersTermine']<>'' then RCW.NurPersTermine:=strtobool(RCWLIST.Values['NurPersTermine']) else RCW.NurPersTermine:=FALSE;
  if RCWLIST.Values['Emails']<>'' then RCW.Emails:=strtobool(RCWLIST.Values['Emails']) else RCW.Emails:=TRUE;
  if RCWLIST.Values['BelegePositionen']<>'' then RCW.BelegePositionen:=strtobool(RCWLIST.Values['BelegePositionen']) else RCW.BelegePositionen:=TRUE;
  if RCWLIST.Values['Anrufe']<>'' then RCW.Anrufe:=strtobool(RCWLIST.Values['Anrufe']) else RCW.Anrufe:=TRUE;
  if RCWLIST.Values['Zeiterfassung']<>'' then RCW.Zeiterfassung:=strtobool(RCWLIST.Values['Zeiterfassung']) else RCW.Zeiterfassung:=TRUE;
  if RCWLIST.Values['Einkaufspreise']<>'' then RCW.Einkaufspreise:=strtobool(RCWLIST.Values['Einkaufspreise']) else RCW.Einkaufspreise:=TRUE;
  if RCWLIST.Values['Verkaufspreise']<>'' then RCW.Verkaufspreise:=strtobool(RCWLIST.Values['Verkaufspreise']) else RCW.Verkaufspreise:=TRUE;
  if RCWLIST.Values['Mitteilungen']<>'' then RCW.Mitteilungen:=strtobool(RCWLIST.Values['Mitteilungen']) else RCW.Mitteilungen:=TRUE;
  if RCWLIST.Values['Inventur']<>'' then RCW.Inventur:=strtobool(RCWLIST.Values['Inventur']) else RCW.Inventur:=TRUE;
end;

procedure TForm1.ScanTimerTimer(Sender: TObject);
begin
  ScanTimer.Enabled:=false;
  if not FScanInProgress then exit;
  FScanInProgress:=False;
  if edtSuchbegriff.text<>'' then
  begin
    ProcessBarcode(edtSuchbegriff.text);
    //edtsuchbegriff.text:='';
  end;
end;

procedure TForm1.AuthConnectionConnect(Sender: TObject);
begin
  Tokenholen(xdatausername,xdatapassword);
end;

procedure TForm1.RCWleeren;
begin
  RCW.Zugelassen:=True;
  RCW.Kontakte:=True;
  RCW.Artikel:=True;
  RCW.OffeneAngebote:=True;
  RCW.OffeneAuftraege:=True;
  RCW.OffeneLieferscheine:=True;
  RCW.Termine:=True;
  RCW.NurPersTermine:=false;
  RCW.Emails:=True;
  RCW.BelegePositionen:=True;
  RCW.Anrufe:=True;
  RCW.Zeiterfassung:=True;
  RCW.Einkaufspreise:=True;
  RCW.Verkaufspreise:=True;
  RCW.Mitteilungen:=True;
  RCW.Inventur:=True;
end;

procedure TForm1.WebFormBeforeUnload(Sender: TObject; var AMessage: string);
begin
  if webverlassennichtfragen=false then AMessage:=webverlassen;
end;

procedure TForm1.WebFormCreate(Sender: TObject);
begin
  RCWLIST:=TStringList.Create;
  RCWLIST.NameValueSeparator:='|';
  PZE_Objekt_erlaubt:=0;
  PZE_Auftrag_erlaubt:=0;
  PZE_LetzteAktionText:='Programm startet';
end;

procedure TForm1.WebFormKeyPress(Sender: TObject; var Key: Char);
begin
if key=#10 then key:=#0;
if key=#13 then key:=#0;
end;

procedure TForm1.WebFormShow(Sender: TObject);
var
  myelement:TJSHTMLElement;
begin
  CadiaKundennummer:='';
  PZE_Personalnummer:='';
  lblstatus.Caption:='';
  LabelMitarbeiter.Caption:='';
  webverlassennichtfragen:=false;
  webverlassen:='CadiaPZEWeb verlassen?';
  lblchecklogin.Caption:='';
  BenutzerStundensatzIntern:=0;
  LizenzOK:=false;
  panelArbeitsart.Visible:=false;
  panelstundenart.Visible:=false;
  panelfunktionen.Visible:=false;
  tc.Visible:=false;
  application.OnOnlineChange:=AppOnlineChange;
  Versionslabel:=Versionslabel1+Versionslabel2+' vom '+Versionslabel3+Versionslabel4;
  Container1.html.text:='<nav class="navbar m-1 rounded bg-info"><h4>CadiaPZEWeb</h4><small>'+Versionslabel+'</small></nav>';
  myelement:=Container1.ElementHandle;
  container2.ParentElement:=myelement;
  container3.ParentElement:=myelement;
  ContainerModus.ParentElement:=myelement;
  ContainerLetzteAktion.ParentElement:=myelement;
  ContainerProgress.ParentElement:=myelement;
  containerMitarbeiterausweis.ParentElement:=myelement;
  containerLabelMitarbeiterAuswahl.ParentElement:=myelement;
  ContainerMitarbeiter.ParentElement:=myelement;
  ContainerStatus.ParentElement:=myelement;
  container4.ParentElement:=myelement;
  container5.ParentElement:=myelement;
  ContainerZusatz.ParentElement:=myelement;
  containertable.ParentElement:=myelement;

  myelement:=Container2.ElementHandle;
  lblCadiaKundennummer.ParentElement:=myelement;
  lblchecklogin.ParentElement:=myelement;
  lblAnmeldung.ParentElement:=myelement;
  labelonlinestatus.ParentElement:=myelement;
  LabelZeitabweichung.ParentElement:=myelement;

  myelement:=ContainerModus.ElementHandle;
  LabelPZEFunktion.ParentElement:=myelement;

  myelement:=ContainerLetzteAktion.ElementHandle;
  LabelLetzteAktion.ParentElement:=myelement;

  myelement:=ContainerProgress.ElementHandle;
  WebProgressBar1.ParentElement:=myelement;

  myelement:=containerMitarbeiterausweis.ElementHandle;
  LabelScanMitarbeiterausweis.ParentElement:=myelement;
  LabelScanAlternativ.ParentElement:=myelement;
  edtSuchbegriff.ParentElement:=myelement;
  myelement:=container5.ElementHandle;

  myelement:=containerStatus.ElementHandle;
  lblstatus.ParentElement:=myelement;
  myelement:=ContainerMitarbeiter.ElementHandle;
  LabelMitarbeiter.ParentElement:=myelement;
  myelement:=containerLabelMitarbeiterAuswahl.ElementHandle;
  labelMitarbeiterauswahl.ParentElement:=myelement;
  myelement:=Container5.ElementHandle;
  panelfunktionen.ParentElement:=myelement;
  panelstundenart.ParentElement:=containerzusatz.ElementHandle;
  panelArbeitsart.ParentElement:=containerzusatz.ElementHandle;
  tc.ParentElement:=containertable.ElementHandle;
  tc.Visible:=true;
  WebHttpRequest1.Execute;
end;

procedure TForm1.WebHttpRequest1Response(Sender: TObject; AResponse: string);
var
  RStringList:TStringList;
  s:string;
begin
  if aresponse='' then
  begin
    LabelLetzteAktion.Caption:='Die Konfigurationsdatei ist nicht vorhanden oder fehlerhaft';
    LabelLetzteAktion.ElementClassName:='h4 center text-danger';
    exit;
  end;
  if aresponse<>'' then
  begin
    RStringList:=TStringList.Create;
    RStringList.Text:=aresponse;
    s:= XorStr(RStringList.Strings[0],25);
    xdataDATASERVER:=trim(ReplaceStr(s,'DATASERVER=',''));
    if RightStr(xdataDATASERVER,1)<>'/' then xdataDATASERVER:=xdataDATASERVER+'/';
    xdataconnectionstring:=xdataDATASERVER+'cadiaserver/xdata';
    downloadconnection:=xdataDATASERVER+'cadiaserver/filedownload?FileName=';
    xdataauthconnection:=xdataDATASERVER+'cadiaserverauth';
    s:= XorStr(RStringList.Strings[1],25);
    xdatausername:=trim(ReplaceStr(s,'USERNAME=',''));
    s:= XorStr(RStringList.Strings[2],25);
    xdatapassword:=trim(ReplaceStr(s,'PASSWORD=',''));
    AuthConnection.Connected:=false;
    AuthConnection.URL:=xdataauthconnection;
    authconnection.Connected:=true;

  end;

end;

procedure TForm1.WebTimer1Timer(Sender: TObject);
var
  timerJetztZeit:TDateTime;
  myseconds:Integer;
begin
  timerJetztZeit:=date+time;
  myseconds:=SecondsBetween(timerJetztZeit,timerstartzeit);
  WebProgressbar1.Visible:=true;
  WebProgressBar1.Position:=myseconds;
  if myseconds>15 then
  begin
    WebTimer1.Enabled:=false;
    PZE_Personalnummer:='';
    if PZE_LetzteAktionText='Sie haben sich erfolgreich von der Arbeit abgemeldet.' then PZE_LetzteAktionText:='Programm wartet';
    setcontrols;
  end;
end;

procedure TForm1.xdsCadiaServerSettingsAfterOpen(DataSet: TDataSet);
  procedure OnResponse(Response:TXDataClientResponse);
  var
    mydownload:string;
  begin
    mydownload:=string(TJSObject(response.Result)['value']);
    TryStrToDateTime(mydownload,SERVERDATUMUHRZEIT);
    if SERVERDATUMUHRZEIT>EncodeDate(2020,1,1) then
    begin
      ZeitAbweichungSek:=SecondsBetween(date+time,SERVERDATUMUHRZEIT);
      LabelZeitabweichung.Caption:='Zeitabweichung Sek: '+inttostr(ZeitAbweichungSek);
    end;
    xdspersonal.Close;
    xdspersonal.QueryString:='$filter=LoginName eq '''+BenutzerLoginName+'''';
    XDsPersonal.Load;
  end;
begin
  BenutzerLoginName:=XorStr(xdsCadiaServerSettingsLS_CB_LoginName.AsString,25);
  BenutzerPasswort:=XorStr(xdsCadiaServerSettingsLS_CB_LoginPassword.AsString,25);
  BenutzerPersonalnummer:=xdsCadiaServerSettingsLS_CB_Personalnummer.AsString;

  WClientServerZeit.RawInvoke('IServerService.GetServerzeit',[],@OnResponse);


end;

procedure TForm1.xdsCheckAuftragAfterOpen(DataSet: TDataSet);
begin
  if xdsCheckAuftrag.RecordCount>0 then
  begin
    if xdsCheckAuftragNummerkomplett.AsString=myAuftragRef then
    begin
      LetztenScanEintragBeenden;
      myAuftragReferenz:=xdsCheckAuftragNummerkomplett.asstring;
      myInfos:=trim(xdsCheckAuftragAuftragsbezeichnung.asstring);
      myStundenart:='[-]';
      myArbeitArt:='[-]';
      myDoApply:=0;
      myScanArt:=24;
      myProduktionReferenz:='';
      myKontaktReferenz:='';
      mytempdatumzeit:=date+time;
      decodedatetime(mytempdatumzeit,ftjahr,ftmonat,fttag,ftstunde,ftminute,ftsekunde,ftms);
      xdsscan.Last;
      myDoApply:=0;
      xdsscan.Edit;
      xdsScanScanEnde.AsDateTime:=encodetime(ftstunde,ftminute,0,0);
      xdsscan.Post;
      mydoapply:=1;
      xdsscan.Append;
    end;
  end;
end;

procedure TForm1.xdsCheckKontaktAfterOpen(DataSet: TDataSet);
begin
  if xdsCheckKontakt.RecordCount>0 then
  begin
    if xdsCheckKontaktKundennummer.AsString=myKontaktRef then
    begin
      LetztenScanEintragBeenden;
      myKontaktReferenz:=xdsCheckKontaktKundennummer.asstring;
      myInfos:=trim(xdsCheckKontaktVorname.asstring+' '+xdsCheckKontaktNachname.AsString);
      myStundenart:='[-]';
      myArbeitArt:='[-]';
      myDoApply:=0;
      myScanArt:=14;
      myAuftragReferenz:='';
      myProduktionReferenz:='';
      mytempdatumzeit:=date+time;
      decodedatetime(mytempdatumzeit,ftjahr,ftmonat,fttag,ftstunde,ftminute,ftsekunde,ftms);
      xdsscan.Last;
      myDoApply:=0;
      xdsscan.Edit;
      xdsScanScanEnde.AsDateTime:=encodetime(ftstunde,ftminute,0,0);
      xdsscan.Post;
      mydoapply:=1;
      xdsscan.Append;
    end;
  end;
end;

procedure TForm1.xdsCheckObjektAfterOpen(DataSet: TDataSet);
begin

  if xdsCheckObjekt.RecordCount>0 then
  begin
    if xdsCheckObjektObjektReferenz.AsString=myObjRef then
    begin
      LetztenScanEintragBeenden;
      myObjektReferenz:=xdsCheckObjektObjektReferenz.AsString;
      myinfos:=trim(xdsCheckObjektObjektnummer.asstring+' '+xdsCheckObjektKurzbezeichnung.asstring);
      myarbeitart:='[-]';
      myProduktionReferenz:='';
      myAuftragReferenz:='';
      myKontaktReferenz:='';
      myscanart:=4;
      mytempdatumzeit:=date+time;
      decodedatetime(mytempdatumzeit,ftjahr,ftmonat,fttag,ftstunde,ftminute,ftsekunde,ftms);
      xdsscan.Last;
      myDoApply:=0;
      xdsscan.Edit;
      xdsScanScanEnde.AsDateTime:=encodetime(ftstunde,ftminute,0,0);
      xdsscan.Post;
      mydoapply:=1;
      xdsscan.Append;
    end;
  end;
end;

procedure TForm1.xdsCheckProduktionAfterOpen(DataSet: TDataSet);
begin
  if xdsCheckProduktion.RecordCount>0 then
  begin
    if xdsCheckProduktionNummerkomplett.AsString=myProdRef then
    begin
      LetztenScanEintragBeenden;
      myProduktionReferenz:=xdsCheckProduktionNummerkomplett.asstring;
      myInfos:=trim(xdsCheckProduktionAuftragsbezeichnung.asstring);
      myStundenart:='[-]';
      myArbeitArt:='[-]';
      myDoApply:=0;
      myScanArt:=34;
      myAuftragReferenz:='';
      myKontaktReferenz:='';
      mytempdatumzeit:=date+time;
      decodedatetime(mytempdatumzeit,ftjahr,ftmonat,fttag,ftstunde,ftminute,ftsekunde,ftms);
      xdsscan.Last;
      myDoApply:=0;
      xdsscan.Edit;
      xdsScanScanEnde.AsDateTime:=encodetime(ftstunde,ftminute,0,0);
      xdsscan.Post;
      mydoapply:=1;
      xdsscan.Append;
    end;
  end;
end;

procedure TForm1.xdsMAAfterOpen(DataSet: TDataSet);
begin
  setcontrols;
end;

procedure TForm1.xdsPauseFixAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
  var
  i:integer;
begin
  for i := 0 to High(info.Records) do
  begin
    if info.Records[i].Error<>'' then showmessage(info.Records[i].Error);
  end;
  showstatus;

end;

procedure TForm1.xdsPauseFixAfterOpen(DataSet: TDataSet);
begin
  myDoApply:=0;
  mytempdatumzeit:=date+time;
  decodedatetime(mytempdatumzeit,ftjahr,ftmonat,fttag,ftstunde,ftminute,ftsekunde,ftms);
  xdsPauseFix.Last;
  xdsPauseFix.Edit;
  xdsPauseFixScanEnde.AsDateTime:=encodetime(ftstunde,ftminute,0,0);
  xdsPauseFix.Post;
  xdsPauseFix.Append;

  xdsPauseFixFAID.Value:=xdsSingleArbeitszeit.CurrentData;
  xdsPauseFixPersonalnummer.AsString:=Benutzerpersonalnummer;
  xdsPauseFixScanDatumZeit.AsDateTime:=mytempdatumzeit;
  xdsPauseFixDatum.AsDateTime:=encodedate(ftjahr,ftmonat,fttag);
  xdsPauseFixScanArt.AsInteger:=2;
  xdsPauseFixScanBegin.AsDateTime:=encodetime(ftstunde,ftminute,0,0);
  xdsPauseFixausgewertet.AsBoolean:=false;
  xdsPauseFixAMS.AsFloat:=ftms;
  xdsPauseFixObjektreferenz.AsString:='';
  xdsPauseFixKundennummer.AsString:='';
  xdsPauseFixAuftrag.AsString:='';
  xdsPauseFixPAuftrag.AsString:='';
  xdsPauseFixStundenArt.AsString:='[-]';
  xdsPauseFixArbeitArt.AsString:='[-]';
  xdsPauseFixDauerMinuten.AsFloat:=0;
  xdsPauseFixInfos.AsString:='Pause';
  xdsPauseFixKalkStundensatz.AsFloat:=0;
  xdsPauseFixKalkKosten.AsFloat:=0;
  xdsPauseFixScanEnde.AsDateTime:=encodetime(ftstunde,ftminute,0,0)+myPauseSoll;
  xdsPauseFixDauerMinuten.AsFloat:=Minutesbetween(xdsPauseFixScanBegin.AsDateTime,xdsPauseFixScanEnde.AsDateTime);
  myDoApply:=0;
  xdsPauseFix.Post;
  xdsPauseFix.Append;
  xdsPauseFixFAID.Value:=xdsSingleArbeitszeit.CurrentData;
  xdsPauseFixPersonalnummer.AsString:=Benutzerpersonalnummer;
  xdsPauseFixScanDatumZeit.AsDateTime:=mytempdatumzeit+myPauseSoll;
  xdsPauseFixDatum.AsDateTime:=encodedate(ftjahr,ftmonat,fttag);
  xdsPauseFixScanArt.AsInteger:=3;
  xdsPauseFixScanBegin.AsDateTime:=encodetime(ftstunde,ftminute,0,0)+myPauseSoll;
  xdsPauseFixausgewertet.AsBoolean:=false;
  xdsPauseFixAMS.AsFloat:=ftms+1;
  xdsPauseFixObjektreferenz.AsString:='';
  xdsPauseFixKundennummer.AsString:='';
  xdsPauseFixAuftrag.AsString:='';
  xdsPauseFixPAuftrag.AsString:='';
  xdsPauseFixStundenArt.AsString:='[-]';
  xdsPauseFixArbeitArt.AsString:='[-]';
  xdsPauseFixDauerMinuten.AsFloat:=0;
  xdsPauseFixInfos.AsString:='';
  xdsPauseFixKalkStundensatz.AsFloat:=0;
  xdsPauseFixKalkKosten.AsFloat:=0;
  xdsPauseFixDauerMinuten.AsFloat:=0;
  myDoApply:=1;
  xdsPauseFix.Post;

end;

procedure TForm1.xdsPauseFixAfterPost(DataSet: TDataSet);
begin
  if myDoApply=1 then xdsPauseFix.ApplyUpdates;
end;

procedure TForm1.xdsPersonalAfterOpen(DataSet: TDataSet);
var
  mylocalstorage:TLocalStorage;
  logbuchurl:string;
begin
  lblCadiaKundennummer.Caption:=CadiaKundennummer;
  if xdspersonal.RecordCount<1 then
  begin
    lblchecklogin.Caption:='Anmeldung ist fehlgeschlagen, bitte versuchen Sie es erneut mit den richtigen Eingaben';
    xdspersonal.Close;
    exit;
  end;
  xdspersonal.First;

    if (XDsPersonalPassword.AsString=BenutzerPasswort) AND (XDsPersonalLoginName.AsString=BenutzerLoginName) then
    begin
      if XDsPersonalEnabled.AsBoolean=true then
      begin
        BenutzerAngemeldet:=true;
        BenutzerNachname:=XDsPersonalNachname.AsString;
        BenutzerVorname:=XDsPersonalVorname.AsString;
        BenutzerSchreibzeichen:=XDsPersonalSchreibzeichen.AsString;
        BenutzerEmail:=XDsPersonalEmail.AsString;
        BenutzerID:=XDsPersonalPersonalGUID.AsString;
        RCWlist.text:=xdspersonalrechtecadiaweb.asstring;
        RCWleeren;
        RCWLISTtoRECORD;
        mylocalstorage:=Tlocalstorage.Create;
        mylocalstorage.SetValue('CadiaWEBBenutzer',BenutzerLoginName);
        if scannereinstellung='' then scannereinstellung:='11111111111';
        mylocalstorage.SetValue('CadiaWEBScanner',scannereinstellung);
        mylocalstorage.Free;
        lblchecklogin.Caption:='Anmeldung erfolgreich';


        //(Kundennummer:string;AppKey:string;UserName:string;UserID:string;Absenderzeile:string;Versiondate:string):string;
        logbuchurl:='https://cadia-software.net/cadiaautoserver/xdata/InformationService/cwlogbuch?Kundennummer='+dm2.tableSYSDATCadiaKundennummer.AsString+'&AppKey='+CadiaAppKey+'&UserName='+BenutzerNachname;
        logbuchurl:=logbuchurl+'&UserID='+BenutzerID;
        //logbuchurl:=logbuchurl+'&Absenderzeile='+Leftstr(dm2.tableSYSDATAbsenderzeile.asstring,70);
        if textabsenderzeile='' then TextAbsenderzeile:='unbekannt';

        logbuchurl:=logbuchurl+'&Absenderzeile='+TextAbsenderzeile;
        logbuchurl:=logbuchurl+'&Versiondate='+Versionslabel3;
        logbuchurl:=logbuchurl+'&Versionnumber='+Versionslabel2;
        dm2.WebHttpRequestLogbuch.URL:=logbuchurl;

        dm2.WebHttpRequestLogbuch.Execute;
        xdsPZEEinstellungen.Load;
      end
      else
      begin
        lblchecklogin.Caption:='Dieser Benutzer ist nicht zugelassen';
      end;
    end
    else
    begin
      lblchecklogin.Caption:='Anmeldung ist fehlgeschlagen, bitte versuchen Sie es erneut mit den richtigen Eingaben';
    end;
end;

procedure TForm1.xdsPZEEinstellungenAfterOpen(DataSet: TDataSet);
begin
  PZE_Objekt_erlaubt:=0;
  PZE_Auftrag_erlaubt:=0;
  PZEModus:=xdsPZEEinstellungenCadiaPZEWebModus.AsInteger;
  if xdsPZEEinstellungenZuordnungObjekt.AsInteger=1 then PZE_Objekt_erlaubt:=1;
  if xdsPZEEinstellungenZuordnungAuftrag.AsInteger=1 then PZE_Auftrag_erlaubt:=1;
  xdsma.Close;
  xdsMA.Load;
end;

procedure TForm1.xdsScanAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
  var
  i:integer;
begin
  for i := 0 to High(info.Records) do
  begin
    if info.Records[i].Error<>'' then showmessage(info.Records[i].Error);
  end;
  xdsscan.Last;
  if xdsScanScanArt.AsInteger<>9 then
  begin
    showstatus;
  end
  else
  begin
    PZE_LetzteAktionText:='Sie haben sich erfolgreich von der Arbeit abgemeldet.';
    PZE_Personalnummer:='';
    setcontrols;
  end;
end;

procedure TForm1.xdsScanAfterOpen(DataSet: TDataSet);
var
  i:integer;
  infostext:string;
begin
  xdsscan.First;
  tc.RowCount:=xdsscan.RecordCount+1;
  tc.ColCount:=6;
  i:=0;
  tc.Cells[0,i]:='DatumZeit';
  tc.Cells[1,i]:='Beginn';
  tc.Cells[2,i]:='Ende';
  tc.Cells[3,i]:='Minuten';
  tc.Cells[4,i]:='Infos';

  while not xdsscan.eof do
  begin
    inc(i);
    tc.Cells[0,i]:=formatdatetime('DD.MM.YYYY hh:mm:ss', xdsScanScanDatumZeit.asdatetime);
    tc.Cells[1,i]:=formatdatetime('hh:mm:ss', xdsScanScanBegin.asdatetime);
    tc.Cells[2,i]:=formatdatetime('hh:mm:ss', xdsScanScanEnde.asdatetime);
    tc.Cells[3,i]:=xdsScanDauerMinuten.asstring;
    infostext:='';
    if xdsScanScanArt.AsInteger=2 then
    begin
      infostext:='Pause';
    end;
    if xdsScanScanArt.AsInteger=4 then
    begin
      infostext:='Objekt: '+xdsScanObjektreferenz.AsString+' '+xdsScanInfos.AsString+ ' ('+xdsScanStundenArt.asstring+')';
    end;
    if xdsScanScanArt.AsInteger=5 then
    begin
      infostext:='';
    end;
    if xdsScanScanArt.AsInteger=9 then
    begin
      infostext:='abgemeldet';
    end;
    if xdsScanScanArt.AsInteger=14 then
    begin
      infostext:='Kontakt: '+xdsScanKundennummer.AsString+' '+xdsScanInfos.AsString+ ' ('+xdsScanArbeitArt.asstring+')';
    end;
    if xdsScanScanArt.AsInteger=15 then
    begin
      infostext:='';
    end;
    if xdsScanScanArt.AsInteger=24 then
    begin
      infostext:='Auftrag: '+xdsScanAuftrag.AsString+' '+xdsScanInfos.AsString+ ' ('+xdsScanArbeitArt.asstring+')';
    end;
    if xdsScanScanArt.AsInteger=25 then
    begin
      infostext:='';
    end;
    if xdsScanScanArt.AsInteger=34 then
    begin
      infostext:='Produktion: '+xdsScanPAuftrag.AsString+' '+xdsScanInfos.AsString+ ' ('+xdsScanArbeitArt.asstring+')';
    end;
    if xdsScanScanArt.AsInteger=35 then
    begin
      infostext:='';
    end;

    tc.Cells[4,i]:=infostext;

    xdsscan.Next;
  end;

  decodedatetime(date+time,fjjahr,fjmonat,fjtag,fjstunde,fjminute,fjsekunde,fjms);
  xdsscan.last;
  panelArbeitsart.Visible:=false;
  panelstundenart.Visible:=false;
  panelfunktionen.Visible:=true;
  btnanmelden.Visible:=false;
  btnabmelden.Visible:=false;
  btnPauseBeginn.Visible:=false;
  btnpauseende.Visible:=false;
  btnPauseVorgabe.Visible:=false;
  btnobjektbeginn.Visible:=false;
  btnobjektende.Visible:=false;
  btnErneutAnmelden.Visible:=false;
  btnKontaktBeginn.Visible:=false;
  btnKontaktEnde.Visible:=false;
  btnAuftragBeginn.Visible:=false;
  btnAuftragEnde.visible:=false;
  btnProduktionBeginn.Visible:=false;
  btnProduktionEnde.Visible:=false;
  if xdsScanScanArt.AsString='' then
  begin
    btnAnmelden.Visible:=true;
    lblstatus.Caption:='Sie haben sich heute noch nicht angemeldet';
    if PZEModus=1 then btnAnmeldenClick(nil);

  end;
  if xdsScanScanArt.AsInteger=1 then
  begin
    btnabmelden.visible:=true;
    btnPauseBeginn.visible:=true;
    btnObjektBeginn.visible:=true;
    btnKontaktBeginn.Visible:=true;
    btnAuftragBeginn.Visible:=true;
    btnProduktionBeginn.Visible:=true;
    lblstatus.Caption:='Sie sind in der Zeiterfassung angemeldet';
  end;

  if xdsScanScanArt.AsInteger=2 then
  begin
    btnPauseEnde.Visible:=true;
    lblstatus.Caption:='Sie sind momentan in einer Pause';
  end;

  if xdsScanScanArt.AsInteger=3 then
  begin
    btnabmelden.visible:=true;
    btnPauseBeginn.visible:=true;
    btnObjektBeginn.visible:=true;
    btnKontaktBeginn.Visible:=true;
    btnAuftragBeginn.Visible:=true;
    btnProduktionBeginn.Visible:=true;
    lblstatus.Caption:='Pause beendet';
  end;

  if xdsScanScanArt.AsInteger=4 then
  begin
    btnObjektEnde.visible:=true;
    lblstatus.Caption:='Objekt: '+xdsSCANObjektreferenz.AsString+' '+xdsSCANInfos.asstring+ ' ('+xdsScanStundenArt.asstring+')';
  end;

  if xdsScanScanArt.AsInteger=5 then
  begin
    btnabmelden.visible:=true;
    btnPauseBeginn.visible:=true;
    btnObjektBeginn.visible:=true;
    btnKontaktBeginn.Visible:=true;
    btnAuftragBeginn.Visible:=true;
    btnProduktionBeginn.Visible:=true;
    lblstatus.Caption:='Objekt beendet';
  end;

  if xdsScanScanArt.AsInteger=14 then
  begin
    lblstatus.Caption:='Kontakt: '+xdsSCANKundennummer.AsString+' ('+xdsSCANArbeitArt.asstring+') '+xdsSCANInfos.asstring;
    btnKontaktEnde.Visible:=true;
  end;

  if xdsScanScanArt.AsInteger=15 then
  begin
    lblstatus.Caption:='Kontakt beendet';
    btnabmelden.visible:=true;
    btnPauseBeginn.visible:=true;
    btnObjektBeginn.visible:=true;
    btnKontaktBeginn.Visible:=true;
    btnAuftragBeginn.Visible:=true;
    btnProduktionBeginn.Visible:=true;
  end;

  if xdsScanScanArt.AsInteger=24 then
  begin
    lblstatus.Caption:='Auftrag: '+xdsScanAuftrag.AsString+' ('+xdsSCANArbeitArt.asstring+') '+xdsSCANInfos.asstring;
    btnAuftragEnde.Visible:=true;
  end;

  if xdsScanScanArt.AsInteger=25 then
  begin
    lblstatus.Caption:='Auftrag beendet';
    btnabmelden.visible:=true;
    btnPauseBeginn.visible:=true;
    btnObjektBeginn.visible:=true;
    btnKontaktBeginn.Visible:=true;
    btnAuftragBeginn.Visible:=true;
    btnProduktionBeginn.Visible:=true;
  end;

  if xdsScanScanArt.AsInteger=34 then
  begin
    lblstatus.Caption:='Produktion: '+xdsScanPAuftrag.AsString+' '+xdsSCANInfos.asstring;
    btnProduktionEnde.Visible:=true;
  end;

  if xdsScanScanArt.AsInteger=35 then
  begin
    lblstatus.Caption:='Produktion beendet';
    btnabmelden.visible:=true;
    btnPauseBeginn.visible:=true;
    btnObjektBeginn.visible:=true;
    btnKontaktBeginn.Visible:=true;
    btnAuftragBeginn.Visible:=true;
    btnProduktionBeginn.Visible:=true;
  end;

  if xdsScanScanArt.AsInteger=9 then
  begin
    lblstatus.Caption:='Sie haben sich für heute bereits abgemeldet';
    btnErneutAnmelden.Visible:=true;
    if PZEModus=1 then btnErneutAnmeldenClick(nil);
  end;
  if xdsPZEEinstellungenZuordnungObjekt.AsInteger<>1 then btnObjektBeginn.Visible:=false;
  if xdsPZEEinstellungenZuordnungKontakt.AsInteger<>1 then btnKontaktBeginn.Visible:=false;
  if xdsPZEEinstellungenZuordnungAuftrag.AsInteger<>1 then btnAuftragBeginn.Visible:=false;
  if xdsPZEEinstellungenZuordnungProduktion.AsInteger<>1 then btnProduktionBeginn.Visible:=false;
  if xdsPZEEinstellungenPauseVorgabe.AsInteger=1 then btnPauseVorgabe.Visible:=btnPauseBeginn.Visible;

  if xdsScanScanBegin.Asdatetime>encodetime(fjstunde,fjminute,0,0) then
  begin
    btnanmelden.visible:=false;
    btnPauseBeginn.visible:=false;
    btnPauseEnde.visible:=false;
    btnObjektBeginn.visible:=false;
    btnObjektEnde.visible:=false;
    btnabmelden.visible:=false;
    btnErneutAnmelden.Visible:=false;
    btnKontaktBeginn.Visible:=false;
    btnKontaktEnde.Visible:=false;
    btnProduktionBeginn.Visible:=false;
    btnProduktionEnde.Visible:=false;
    btnAuftragBeginn.Visible:=false;
    btnAuftragEnde.Visible:=false;
    btnPauseVorgabe.Visible:=false;
    lblstatus.Caption:='Sie sind noch in einer Pause';
  end;
  //automatisch von bisheriger Tätigkeit abmelden w/Herkunft aus Auftrag

  if (PZE_AutoObjektnummer<>'') OR (PZE_AutoAuftragnummer<>'') then
  begin
     if xdsScanScanArt.AsInteger=24 then btnAuftragEndeClick(nil);
     if xdsscanscanart.AsInteger=14 then btnKontaktEndeClick(nil);
     if xdsscanscanart.AsInteger=2 then btnPauseEndeClick(nil);
     if xdsscanscanart.AsInteger=4 then btnObjektEndeClick(nil);
     if xdsScanScanArt.AsInteger=34 then btnProduktionEndeClick(nil);
  end;
  setcontrols;
end;

procedure TForm1.xdsScanAfterPost(DataSet: TDataSet);
begin
  if myDoApply=1 then xdsScan.ApplyUpdates;
end;

procedure TForm1.xdsScanNewRecord(DataSet: TDataSet);
begin
  xdsScanFAID.Value:=xdsSingleArbeitszeit.CurrentData;
  xdsSCANPersonalnummer.AsString:=PZE_Personalnummer;
  xdsScanScanDatumZeit.AsDateTime:=date+time;
  decodedatetime(date+time,ftjahr,ftmonat,fttag,ftstunde,ftminute,ftsekunde,ftms);
  xdsSCANDatum.AsDateTime:=encodedate(ftjahr,ftmonat,fttag);
  xdsSCANScanArt.AsInteger:=myScanArt;
  xdsSCANScanBegin.AsDateTime:=encodetime(ftstunde,ftminute,0,0);
  xdsScanausgewertet.AsBoolean:=false;
  xdsScanAMS.AsFloat:=ftms;
  xdsScanObjektreferenz.AsString:=myObjektReferenz;
  xdsScanKundennummer.AsString:=myKontaktReferenz;
  xdsScanAuftrag.AsString:=myAuftragReferenz;
  xdsScanPAuftrag.AsString:=myProduktionReferenz;
  if myObjStundenart<>'[-]' then
  begin
    xdsScanStundenArt.AsString:=myObjStundenart;
  end
  else
  begin
    xdsScanStundenArt.AsString:=mystundenart;
  end;
  xdsScanArbeitArt.AsString:=myArbeitArt;
  xdsScanDauerMinuten.AsFloat:=0;
  xdsScanInfos.AsString:=myInfos;
  xdsScanKalkStundensatz.AsFloat:=0;
  xdsScanKalkKosten.AsFloat:=0;
  myObjektReferenz:='';
  myKontaktReferenz:='';
  myArbeitArt:='[-]';
  myProduktionReferenz:='';
  myAuftragReferenz:='';
  mystundenart:='[-]';
  myInfos:='';

  xdsscan.Post;
end;

procedure TForm1.xdsSingleArbeitszeitAfterOpen(DataSet: TDataSet);
begin
  if xdsSingleArbeitszeit.RecordCount<1 then
  begin
    LabelLetzteAktion.Caption:='CadiaPZE scheint für Sie nicht eingerichtet zu sein, sprechen Sie bitte Ihren Administrator an';
    LabelLetzteAktion.ElementClassName:='h4 center text-danger';
  end
  else
  begin
    myPauseSoll:=xdsSingleArbeitszeitSollPause.AsDateTime;
    btnPauseVorgabe.Caption:='Pause FIX '+formatdatetime('hh:mm',myPauseSoll);
    xdsPauseFix.Close;
    xdsPauseFix.QueryString:='$filter=FAID eq '+ xdsSingleArbeitszeitID.AsString+' &$orderby=ScanDatumZeit,ams';
    xdsScan.Close;
    xdsscan.QueryString:='$filter=FAID eq '+ xdsSingleArbeitszeitID.AsString+' &$orderby=ScanDatumZeit,ams';
    xdsscan.load;
  end;
end;

procedure TForm1.xdsStundenartAfterOpen(DataSet: TDataSet);
begin
  if PZEModus=2 then
  begin
    lookupstundenart.Items.Clear;
    xdsStundenart.First;
    while not xdsstundenart.eof do
    begin
      lookupstundenart.Items.Add(xdsStundenartStundenArt.asstring);
      xdsstundenart.Next;
    end;
  end;

  xdsSingleArbeitszeit.Close;
  xdssingleArbeitszeit.QueryString:='$filter=(EintragsArt eq 0) AND (Personalnummer eq '+PZE_Personalnummer+') AND (Datum eq '+formatdatetime('yyyy-mm-dd',date)+')';
  xdsSingleArbeitszeit.load;
end;

procedure TForm1.kontaktsuche1;
var
  LFrm:TfrmKontaktsuche;
    procedure AfterCreate(AForm:TObject);
    var
      LForm:TfrmKontaktsuche;
    begin
      LForm:=(AForm as TfrmKontaktsuche);
      lform.Kontaktnummer:='';
      lform.weiterzuEinzelkontakt:=false;
    end;

    procedure AfterShowmodal(Avalue:TModalResult);
    begin
      if lfrm.Kontaktnummer<>'' then
      begin
        myKontaktReferenz:=lfrm.kontaktnummer;
        myInfos:=trim(lfrm.LUVorname+' '+lfrm.LUNachname);
        myDoApply:=0;
        myScanArt:=14;
        panelfunktionen.Visible:=false;
        panelArbeitsart.Visible:=true;
        lblauswahlinfo.Caption:=mykontaktreferenz+' '+myinfos;

      end;
      if lfrm.kontaktnummer='' then
      begin
        LabelLetzteAktion.Caption:='Der Vorgang wird abgebrochen, da Sie keinen Kontakt ausgewählt haben';
        LabelLetzteAktion.ElementClassName:='h4 center text-danger';
      end;

    end;

  begin
  LFrm:=TfrmKontaktsuche.CreateNew(@AfterCreate);
 // LFrm.Popup:=true;
  LFrm.ShowModal(@AfterShowmodal);

  end;

procedure TForm1.kontaktsuche2;
var
  LFrm:TfrmKontaktNummerSuche;
    procedure AfterCreate(AForm:TObject);
    var
      LForm:TfrmKontaktNummerSuche;
    begin
      LForm:=(AForm as TfrmKontaktNummerSuche);
      lform.Kontaktnummer:='';
      lform.weiterzuEinzelkontakt:=false;
    end;

    procedure AfterShowmodal(Avalue:TModalResult);
    begin
      if lfrm.Kontaktnummer<>'' then
      begin
        myKontaktReferenz:=lfrm.kontaktnummer;
        myInfos:=trim(lfrm.LUVorname+' '+lfrm.LUNachname);
        myDoApply:=0;
        myScanArt:=14;
        panelfunktionen.Visible:=false;
        panelArbeitsart.Visible:=true;
        lblauswahlinfo.Caption:=mykontaktreferenz+' '+myinfos;

      end;
      if lfrm.kontaktnummer='' then
      begin
        LabelLetzteAktion.Caption:='Der Vorgang wird abgebrochen, da Sie keinen Kontakt ausgewählt haben';
        LabelLetzteAktion.ElementClassName:='h4 center text-danger';
      end;

    end;

  begin
  LFrm:=TfrmKontaktNummerSuche.CreateNew(@AfterCreate);
 // LFrm.Popup:=true;
  LFrm.ShowModal(@AfterShowmodal);

  end;

  procedure TForm1.LetztenScanEintragBeenden;
  begin
    xdsscan.Last;
    if xdsScanScanArt.AsInteger=4 then
    begin
      myDoApply:=0;
      mytempdatumzeit:=date+time;
      decodedatetime(mytempdatumzeit,ftjahr,ftmonat,fttag,ftstunde,ftminute,ftsekunde,ftms);
      xdsscan.Edit;
      xdsScanScanEnde.AsDateTime:=encodetime(ftstunde,ftminute,0,0);
      xdsScanDauerMinuten.AsFloat:=Minutesbetween(xdsScanScanBegin.AsDateTime,xdsScanScanEnde.AsDateTime);
      xdsscan.Post;
      myScanArt:=5;
      myDoApply:=0;
      xdsscan.Append;
    end;
    if xdsScanScanArt.AsInteger=14 then
    begin
      myDoApply:=0;
      mytempdatumzeit:=date+time;
      decodedatetime(mytempdatumzeit,ftjahr,ftmonat,fttag,ftstunde,ftminute,ftsekunde,ftms);
      xdsscan.Edit;
      xdsScanScanEnde.AsDateTime:=encodetime(ftstunde,ftminute,0,0);
      xdsScanDauerMinuten.AsFloat:=Minutesbetween(xdsScanScanBegin.AsDateTime,xdsScanScanEnde.AsDateTime);
      xdsscan.Post;
      myScanArt:=15;
      myDoApply:=0;
      xdsscan.Append;
    end;
    if xdsScanScanArt.AsInteger=24 then
    begin
      myDoApply:=0;
      mytempdatumzeit:=date+time;
      decodedatetime(mytempdatumzeit,ftjahr,ftmonat,fttag,ftstunde,ftminute,ftsekunde,ftms);
      xdsscan.Edit;
      xdsScanScanEnde.AsDateTime:=encodetime(ftstunde,ftminute,0,0);
      xdsScanDauerMinuten.AsFloat:=Minutesbetween(xdsScanScanBegin.AsDateTime,xdsScanScanEnde.AsDateTime);
      xdsscan.Post;
      myScanArt:=25;
      myDoApply:=0;
      xdsscan.Append;
    end;
    if xdsScanScanArt.AsInteger=34 then
    begin
      myDoApply:=0;
      mytempdatumzeit:=date+time;
      decodedatetime(mytempdatumzeit,ftjahr,ftmonat,fttag,ftstunde,ftminute,ftsekunde,ftms);
      xdsscan.Edit;
      xdsScanScanEnde.AsDateTime:=encodetime(ftstunde,ftminute,0,0);
      xdsScanDauerMinuten.AsFloat:=Minutesbetween(xdsScanScanBegin.AsDateTime,xdsScanScanEnde.AsDateTime);
      xdsscan.Post;
      myScanArt:=35;
      myDoApply:=0;
      xdsscan.Append;
    end;
    if xdsScanScanArt.AsInteger=2 then
    begin
      myDoApply:=0;
      mytempdatumzeit:=date+time;
      decodedatetime(mytempdatumzeit,ftjahr,ftmonat,fttag,ftstunde,ftminute,ftsekunde,ftms);
      xdsscan.Edit;
      xdsScanScanEnde.AsDateTime:=encodetime(ftstunde,ftminute,0,0);
      xdsScanDauerMinuten.AsFloat:=Minutesbetween(xdsScanScanBegin.AsDateTime,xdsScanScanEnde.AsDateTime);
      xdsscan.Post;
      myScanArt:=3;
      myDoApply:=0;
      xdsscan.Append;
    end;
  end;

  procedure TForm1.ProcessBarcode(ACode:string);
var
  mytempsuchtext:string;
  scanresult:string;
  myList:TStringList;
begin
  scanresult:='';

  mytempsuchtext:=cleanstring(ACode);
  mytempsuchtext:=lowercase(mytempsuchtext);
  if length(mytempsuchtext)>3 then
  begin
    //Personalnummer wurde gescannt--Ablauf beginnt
    if leftstr(mytempsuchtext,3)='pnr' then
    begin
      scanresult:=replacestr(mytempsuchtext,'pnr','');
      if xdsma.Locate('Personalnummer',scanresult,[])=true then
      begin
        RCWlist.text:=xdsMArechtecadiaweb.asstring;
        RCWLISTtoRECORD;
        if RCW.Zeiterfassung=true then
        begin
          PZE_Personalnummer:=scanresult;
          PZE_LetzteAktionText:=PZE_Personalnummer+' gescannt';
          xdsstundenart.Close;
          TimerStartZeit:=Date+time;
          webtimer1.Enabled:=true;
          xdsstundenart.load;
        end
        else
        begin
          LabelLetzteAktion.Caption:='Sie sind nicht für die Zeiterfassung zugelassen, sprechen Sie Ihren Administrator an';
          LabelLetzteAktion.ElementClassName:='h4 center text-danger';
          PZE_Personalnummer:='';
        end;
      end;
    end;

    if (PZE_Personalnummer<>'') and (length(mytempsuchtext)>3) then
    begin
      //Aktion wurde gescannt
      if leftstr(mytempsuchtext,3)='akt' then
      begin
        scanresult:=replacestr(mytempsuchtext,'akt','');
        if scanresult='pausebeginn' then
        begin
          LetztenScanEintragBeenden;
          btnPauseBeginnClick(nil);
        end;
        if scanresult='pauseende' then
        begin
          btnPauseEndeclick(nil);
        end;
        if scanresult='pausevorgabe' then
        begin
          LetztenScanEintragBeenden;
          btnPauseVorgabeClick(nil);
        end;
        if scanresult='abmelden' then
        begin
          LetztenScanEintragBeenden;
          btnAbmeldenclick(nil);
        end;
      end;

      //Objekt wurde gescannt
      if (leftstr(mytempsuchtext,3)='obj') then
      begin
        myObjStundenart:='[-]';
        scanresult:=replacestr(mytempsuchtext,'obj','');
        if Pos('std',scanresult)>0 then
        begin
          myObjRef:=leftstr(scanresult,pos('std',scanresult)-1);
          myStdRef:=rightstr(scanresult,length(scanresult)-(pos('std',scanresult)+2));

          if xdsStundenart.Locate('STDNR',myStdRef,[])=True then
          begin
            myObjStundenart:=xdsStundenartStundenArt.AsString;
          end
          else
          begin
            mystundenart:='[-]';
          end;
        end
        else
        begin
          myObjRef:=scanresult;
        end;
        xdsCheckObjekt.Close;
        xdscheckObjekt.QueryString:='$filter=Objektreferenz eq '+myObjRef;
        xdscheckObjekt.Load;
      end;
      //Objektablauf beendet

      //Auftrag wurde gescannt
      if (leftstr(mytempsuchtext,1)=lowercase(KuerzelAuftrag)) AND (Pos('.',mytempsuchtext)=4) then
      begin
        myAuftragRef:=uppercase(trim(mytempsuchtext));
        xdsCheckAuftrag.Close;
        xdscheckAuftrag.QueryString:='$filter=Nummerkomplett eq '+quotedstr(myAuftragRef);
        xdscheckAuftrag.Load;
      end;

      //Produktion wurde gescannt
      if (leftstr(mytempsuchtext,1)='p') AND (Pos('.',mytempsuchtext)=4) then
      begin
        myProdRef:=uppercase(trim(mytempsuchtext));
        xdsCheckProduktion.Close;
        xdscheckProduktion.QueryString:='$filter=Nummerkomplett eq '+quotedstr(myProdRef);
        xdscheckProduktion.Load;
      end;

      //Kontakt wurde gescannt
      if (leftstr(mytempsuchtext,1)<>'p') AND (leftstr(mytempsuchtext,1)<>lowercase(KuerzelAuftrag)) AND (leftstr(mytempsuchtext,3)<>'obj') AND (leftstr(mytempsuchtext,3)<>'akt') AND (leftstr(mytempsuchtext,3)<>'pnr') AND (Pos('.',mytempsuchtext)=0) then
      begin
        myKontaktRef:=uppercase(trim(mytempsuchtext));
        xdsCheckKontakt.Close;
        xdscheckKontakt.QueryString:='$filter=Kundennummer eq '+quotedstr(myKontaktRef);
        xdscheckKontakt.Load;
      end;
    end;
  end;
  //edtSuchbegriff.Text:='';


  end;
procedure TForm1.LoadDFMValues;
begin
  inherited LoadDFMValues;

  labelonlinestatus := TLabel.Create(Self);
  lblAnmeldung := TLabel.Create(Self);
  lblchecklogin := TLabel.Create(Self);
  lblstatus := TLabel.Create(Self);
  LabelPZEFunktion := TLabel.Create(Self);
  LabelScanMitarbeiterausweis := TLabel.Create(Self);
  labelMitarbeiterauswahl := TLabel.Create(Self);
  LabelLetzteAktion := TLabel.Create(Self);
  LabelMitarbeiter := TLabel.Create(Self);
  LabelZeitabweichung := TLabel.Create(Self);
  LabelScanAlternativ := TLabel.Create(Self);
  lblCadiaKundennummer := TLabel.Create(Self);
  Container1 := THTMLContainer.Create(Self);
  Container2 := THTMLContainer.Create(Self);
  Container3 := THTMLContainer.Create(Self);
  Container4 := THTMLContainer.Create(Self);
  Container5 := THTMLContainer.Create(Self);
  panelfunktionen := TPanel.Create(Self);
  btnAnmelden := TButton.Create(Self);
  btnPauseBeginn := TButton.Create(Self);
  btnPauseEnde := TButton.Create(Self);
  btnAbmelden := TButton.Create(Self);
  btnObjektBeginn := TButton.Create(Self);
  btnObjektEnde := TButton.Create(Self);
  btnErneutAnmelden := TButton.Create(Self);
  btnKontaktBeginn := TButton.Create(Self);
  btnKontaktEnde := TButton.Create(Self);
  btnAuftragBeginn := TButton.Create(Self);
  btnAuftragEnde := TButton.Create(Self);
  btnProduktionBeginn := TButton.Create(Self);
  btnProduktionEnde := TButton.Create(Self);
  btnPauseVorgabe := TButton.Create(Self);
  TC := TTableControl.Create(Self);
  panelstundenart := TPanel.Create(Self);
  lblauswahlobjekt := TLabel.Create(Self);
  btnObjektOK := TButton.Create(Self);
  btnObjektAbbrechen := TButton.Create(Self);
  lookupstundenart := TComboBox.Create(Self);
  panelArbeitsart := TPanel.Create(Self);
  lblauswahlinfo := TLabel.Create(Self);
  radioarbeitsart := TRadioGroup.Create(Self);
  btnOK := TButton.Create(Self);
  btnAbbrechen := TButton.Create(Self);
  ContainerMitarbeiterausweis := THTMLContainer.Create(Self);
  edtSuchbegriff := TEdit.Create(Self);
  ContainerLabelMitarbeiterAuswahl := THTMLContainer.Create(Self);
  ContainerModus := THTMLContainer.Create(Self);
  ContainerLetzteAktion := THTMLContainer.Create(Self);
  ContainerStatus := THTMLContainer.Create(Self);
  ContainerMitarbeiter := THTMLContainer.Create(Self);
  ContainerTable := THTMLContainer.Create(Self);
  WebProgressBar1 := TProgressBar.Create(Self);
  ContainerProgress := THTMLContainer.Create(Self);
  ContainerZusatz := THTMLContainer.Create(Self);
  WClient := TXDataWebClient.Create(Self);
  AuthConnection := TXDataWebConnection.Create(Self);
  WebHttpRequest1 := THttpRequest.Create(Self);
  WebLocalStorage1 := TLocalStorage.Create(Self);
  xdsCadiaServerSettings := TXDataWebDataSet.Create(Self);
  xdsCadiaServerSettingsLS_MANDANT := TStringField.Create(Self);
  xdsCadiaServerSettingsLS_HTTPS := TBooleanField.Create(Self);
  xdsCadiaServerSettingsLS_PORT := TIntegerField.Create(Self);
  xdsCadiaServerSettingsLS_XDATA := TBooleanField.Create(Self);
  xdsCadiaServerSettingsLS_REMOTEDB := TBooleanField.Create(Self);
  xdsCadiaServerSettingsLS_JWT := TBooleanField.Create(Self);
  xdsCadiaServerSettingsLS_SUPERSECRETKEY := TStringField.Create(Self);
  xdsCadiaServerSettingsLS_DBBENUTZER := TStringField.Create(Self);
  xdsCadiaServerSettingsLS_DBPASSWORT := TStringField.Create(Self);
  xdsCadiaServerSettingsLS_CB_Personalnummer := TIntegerField.Create(Self);
  xdsCadiaServerSettingsLS_CB_LoginName := TStringField.Create(Self);
  xdsCadiaServerSettingsLS_CB_LoginPassword := TStringField.Create(Self);
  xdsPersonal := TXDataWebDataSet.Create(Self);
  xdsPersonalPersonalnummer := TIntegerField.Create(Self);
  xdsPersonalNachname := TStringField.Create(Self);
  xdsPersonalVorname := TStringField.Create(Self);
  xdsPersonalSchreibzeichen := TStringField.Create(Self);
  xdsPersonalLoginName := TStringField.Create(Self);
  xdsPersonalPassword := TStringField.Create(Self);
  xdsPersonalEnabled := TBooleanField.Create(Self);
  xdsPersonalEmail := TStringField.Create(Self);
  xdsPersonalFarbe := TIntegerField.Create(Self);
  xdsPersonalPersonalGUID := TStringField.Create(Self);
  xdsPersonalRechteCadiaWEB := TStringField.Create(Self);
  xdsPersonalStundensatzIntern := TFloatField.Create(Self);
  xdsMA := TXDataWebDataSet.Create(Self);
  xdsMAPersonalnummer := TIntegerField.Create(Self);
  xdsMANachname := TStringField.Create(Self);
  xdsMAVorname := TStringField.Create(Self);
  xdsMARechteCadiaWEB := TStringField.Create(Self);
  xdsMAEintrittsdatum := TDateTimeField.Create(Self);
  xdsMAAustrittsdatum := TDateTimeField.Create(Self);
  xdsSingleArbeitszeit := TXDataWebDataSet.Create(Self);
  xdsSingleArbeitszeitID := TStringField.Create(Self);
  xdsSingleArbeitszeitPersonalnummer := TIntegerField.Create(Self);
  xdsSingleArbeitszeitDatum := TDateTimeField.Create(Self);
  xdsSingleArbeitszeitEintragsArt := TIntegerField.Create(Self);
  xdsSingleArbeitszeitSollPause := TDateTimeField.Create(Self);
  sourceSingleArbeitszeit := TDataSource.Create(Self);
  xdsScan := TXDataWebDataSet.Create(Self);
  xdsScanPersonalnummer := TIntegerField.Create(Self);
  xdsScanScanDatumZeit := TDateTimeField.Create(Self);
  xdsScanDatum := TDateTimeField.Create(Self);
  xdsScanScanArt := TIntegerField.Create(Self);
  xdsScanObjektreferenz := TStringField.Create(Self);
  xdsScanScanBegin := TDateTimeField.Create(Self);
  xdsScanScanEnde := TDateTimeField.Create(Self);
  xdsScanausgewertet := TBooleanField.Create(Self);
  xdsScanAMS := TFloatField.Create(Self);
  xdsScanStundenArt := TStringField.Create(Self);
  xdsScanFAID := TXDataWebEntityField.Create(Self);
  xdsScanID := TStringField.Create(Self);
  xdsScanKundennummer := TStringField.Create(Self);
  xdsScanAuftrag := TStringField.Create(Self);
  xdsScanPAuftrag := TStringField.Create(Self);
  xdsScanArbeitArt := TStringField.Create(Self);
  xdsScanInfos := TStringField.Create(Self);
  xdsScanDauerMinuten := TFloatField.Create(Self);
  xdsScanKalkStundensatz := TFloatField.Create(Self);
  xdsScanKalkKosten := TFloatField.Create(Self);
  sourceScan := TDataSource.Create(Self);
  xdsPauseFix := TXDataWebDataSet.Create(Self);
  xdsPauseFixFAID := TXDataWebEntityField.Create(Self);
  xdsPauseFixID := TStringField.Create(Self);
  xdsPauseFixPersonalnummer := TIntegerField.Create(Self);
  xdsPauseFixScanDatumZeit := TDateTimeField.Create(Self);
  xdsPauseFixDatum := TDateTimeField.Create(Self);
  xdsPauseFixScanArt := TIntegerField.Create(Self);
  xdsPauseFixObjektreferenz := TStringField.Create(Self);
  xdsPauseFixScanBegin := TDateTimeField.Create(Self);
  xdsPauseFixScanEnde := TDateTimeField.Create(Self);
  xdsPauseFixausgewertet := TBooleanField.Create(Self);
  xdsPauseFixAMS := TFloatField.Create(Self);
  xdsPauseFixStundenArt := TStringField.Create(Self);
  xdsPauseFixKundennummer := TStringField.Create(Self);
  xdsPauseFixAuftrag := TStringField.Create(Self);
  xdsPauseFixPAuftrag := TStringField.Create(Self);
  xdsPauseFixArbeitArt := TStringField.Create(Self);
  xdsPauseFixInfos := TStringField.Create(Self);
  xdsPauseFixDauerMinuten := TFloatField.Create(Self);
  xdsPauseFixKalkStundensatz := TFloatField.Create(Self);
  xdsPauseFixKalkKosten := TFloatField.Create(Self);
  xdsStundenart := TXDataWebDataSet.Create(Self);
  xdsStundenartStundenArt := TStringField.Create(Self);
  xdsStundenartSTDNR := TIntegerField.Create(Self);
  sourceStundenart := TDataSource.Create(Self);
  xdsPZEEinstellungen := TXDataWebDataSet.Create(Self);
  xdsPZEEinstellungenZuordnungObjekt := TIntegerField.Create(Self);
  xdsPZEEinstellungenZuordnungKontakt := TIntegerField.Create(Self);
  xdsPZEEinstellungenZuordnungAuftrag := TIntegerField.Create(Self);
  xdsPZEEinstellungenZuordnungProduktion := TIntegerField.Create(Self);
  xdsPZEEinstellungenAuswahlNurKontaktnummer := TIntegerField.Create(Self);
  xdsPZEEinstellungenPauseVorgabe := TIntegerField.Create(Self);
  xdsPZEEinstellungenCadiaPZEWebModus := TIntegerField.Create(Self);
  WebTimer1 := TTimer.Create(Self);
  WClientServerZeit := TXDataWebClient.Create(Self);
  xdsCheckObjekt := TXDataWebDataSet.Create(Self);
  xdsCheckObjektObjektReferenz := TStringField.Create(Self);
  xdsCheckObjektKurzbezeichnung := TStringField.Create(Self);
  xdsCheckObjektBezeichnung := TStringField.Create(Self);
  xdsCheckObjektObjektnummer := TStringField.Create(Self);
  xdsCheckAuftrag := TXDataWebDataSet.Create(Self);
  xdsCheckAuftragNummerkomplett := TStringField.Create(Self);
  xdsCheckAuftragAuftragsbezeichnung := TStringField.Create(Self);
  xdsCheckProduktion := TXDataWebDataSet.Create(Self);
  xdsCheckProduktionNummerkomplett := TStringField.Create(Self);
  xdsCheckProduktionAuftragsbezeichnung := TStringField.Create(Self);
  xdsCheckKontakt := TXDataWebDataSet.Create(Self);
  xdsCheckKontaktKundennummer := TStringField.Create(Self);
  xdsCheckKontaktNachname := TStringField.Create(Self);
  xdsCheckKontaktVorname := TStringField.Create(Self);
  ScanTimer := TTimer.Create(Self);

  labelonlinestatus.BeforeLoadDFMValues;
  lblAnmeldung.BeforeLoadDFMValues;
  lblchecklogin.BeforeLoadDFMValues;
  lblstatus.BeforeLoadDFMValues;
  LabelPZEFunktion.BeforeLoadDFMValues;
  LabelScanMitarbeiterausweis.BeforeLoadDFMValues;
  labelMitarbeiterauswahl.BeforeLoadDFMValues;
  LabelLetzteAktion.BeforeLoadDFMValues;
  LabelMitarbeiter.BeforeLoadDFMValues;
  LabelZeitabweichung.BeforeLoadDFMValues;
  LabelScanAlternativ.BeforeLoadDFMValues;
  lblCadiaKundennummer.BeforeLoadDFMValues;
  Container1.BeforeLoadDFMValues;
  Container2.BeforeLoadDFMValues;
  Container3.BeforeLoadDFMValues;
  Container4.BeforeLoadDFMValues;
  Container5.BeforeLoadDFMValues;
  panelfunktionen.BeforeLoadDFMValues;
  btnAnmelden.BeforeLoadDFMValues;
  btnPauseBeginn.BeforeLoadDFMValues;
  btnPauseEnde.BeforeLoadDFMValues;
  btnAbmelden.BeforeLoadDFMValues;
  btnObjektBeginn.BeforeLoadDFMValues;
  btnObjektEnde.BeforeLoadDFMValues;
  btnErneutAnmelden.BeforeLoadDFMValues;
  btnKontaktBeginn.BeforeLoadDFMValues;
  btnKontaktEnde.BeforeLoadDFMValues;
  btnAuftragBeginn.BeforeLoadDFMValues;
  btnAuftragEnde.BeforeLoadDFMValues;
  btnProduktionBeginn.BeforeLoadDFMValues;
  btnProduktionEnde.BeforeLoadDFMValues;
  btnPauseVorgabe.BeforeLoadDFMValues;
  TC.BeforeLoadDFMValues;
  panelstundenart.BeforeLoadDFMValues;
  lblauswahlobjekt.BeforeLoadDFMValues;
  btnObjektOK.BeforeLoadDFMValues;
  btnObjektAbbrechen.BeforeLoadDFMValues;
  lookupstundenart.BeforeLoadDFMValues;
  panelArbeitsart.BeforeLoadDFMValues;
  lblauswahlinfo.BeforeLoadDFMValues;
  radioarbeitsart.BeforeLoadDFMValues;
  btnOK.BeforeLoadDFMValues;
  btnAbbrechen.BeforeLoadDFMValues;
  ContainerMitarbeiterausweis.BeforeLoadDFMValues;
  edtSuchbegriff.BeforeLoadDFMValues;
  ContainerLabelMitarbeiterAuswahl.BeforeLoadDFMValues;
  ContainerModus.BeforeLoadDFMValues;
  ContainerLetzteAktion.BeforeLoadDFMValues;
  ContainerStatus.BeforeLoadDFMValues;
  ContainerMitarbeiter.BeforeLoadDFMValues;
  ContainerTable.BeforeLoadDFMValues;
  WebProgressBar1.BeforeLoadDFMValues;
  ContainerProgress.BeforeLoadDFMValues;
  ContainerZusatz.BeforeLoadDFMValues;
  WClient.BeforeLoadDFMValues;
  AuthConnection.BeforeLoadDFMValues;
  WebHttpRequest1.BeforeLoadDFMValues;
  WebLocalStorage1.BeforeLoadDFMValues;
  xdsCadiaServerSettings.BeforeLoadDFMValues;
  xdsCadiaServerSettingsLS_MANDANT.BeforeLoadDFMValues;
  xdsCadiaServerSettingsLS_HTTPS.BeforeLoadDFMValues;
  xdsCadiaServerSettingsLS_PORT.BeforeLoadDFMValues;
  xdsCadiaServerSettingsLS_XDATA.BeforeLoadDFMValues;
  xdsCadiaServerSettingsLS_REMOTEDB.BeforeLoadDFMValues;
  xdsCadiaServerSettingsLS_JWT.BeforeLoadDFMValues;
  xdsCadiaServerSettingsLS_SUPERSECRETKEY.BeforeLoadDFMValues;
  xdsCadiaServerSettingsLS_DBBENUTZER.BeforeLoadDFMValues;
  xdsCadiaServerSettingsLS_DBPASSWORT.BeforeLoadDFMValues;
  xdsCadiaServerSettingsLS_CB_Personalnummer.BeforeLoadDFMValues;
  xdsCadiaServerSettingsLS_CB_LoginName.BeforeLoadDFMValues;
  xdsCadiaServerSettingsLS_CB_LoginPassword.BeforeLoadDFMValues;
  xdsPersonal.BeforeLoadDFMValues;
  xdsPersonalPersonalnummer.BeforeLoadDFMValues;
  xdsPersonalNachname.BeforeLoadDFMValues;
  xdsPersonalVorname.BeforeLoadDFMValues;
  xdsPersonalSchreibzeichen.BeforeLoadDFMValues;
  xdsPersonalLoginName.BeforeLoadDFMValues;
  xdsPersonalPassword.BeforeLoadDFMValues;
  xdsPersonalEnabled.BeforeLoadDFMValues;
  xdsPersonalEmail.BeforeLoadDFMValues;
  xdsPersonalFarbe.BeforeLoadDFMValues;
  xdsPersonalPersonalGUID.BeforeLoadDFMValues;
  xdsPersonalRechteCadiaWEB.BeforeLoadDFMValues;
  xdsPersonalStundensatzIntern.BeforeLoadDFMValues;
  xdsMA.BeforeLoadDFMValues;
  xdsMAPersonalnummer.BeforeLoadDFMValues;
  xdsMANachname.BeforeLoadDFMValues;
  xdsMAVorname.BeforeLoadDFMValues;
  xdsMARechteCadiaWEB.BeforeLoadDFMValues;
  xdsMAEintrittsdatum.BeforeLoadDFMValues;
  xdsMAAustrittsdatum.BeforeLoadDFMValues;
  xdsSingleArbeitszeit.BeforeLoadDFMValues;
  xdsSingleArbeitszeitID.BeforeLoadDFMValues;
  xdsSingleArbeitszeitPersonalnummer.BeforeLoadDFMValues;
  xdsSingleArbeitszeitDatum.BeforeLoadDFMValues;
  xdsSingleArbeitszeitEintragsArt.BeforeLoadDFMValues;
  xdsSingleArbeitszeitSollPause.BeforeLoadDFMValues;
  sourceSingleArbeitszeit.BeforeLoadDFMValues;
  xdsScan.BeforeLoadDFMValues;
  xdsScanPersonalnummer.BeforeLoadDFMValues;
  xdsScanScanDatumZeit.BeforeLoadDFMValues;
  xdsScanDatum.BeforeLoadDFMValues;
  xdsScanScanArt.BeforeLoadDFMValues;
  xdsScanObjektreferenz.BeforeLoadDFMValues;
  xdsScanScanBegin.BeforeLoadDFMValues;
  xdsScanScanEnde.BeforeLoadDFMValues;
  xdsScanausgewertet.BeforeLoadDFMValues;
  xdsScanAMS.BeforeLoadDFMValues;
  xdsScanStundenArt.BeforeLoadDFMValues;
  xdsScanFAID.BeforeLoadDFMValues;
  xdsScanID.BeforeLoadDFMValues;
  xdsScanKundennummer.BeforeLoadDFMValues;
  xdsScanAuftrag.BeforeLoadDFMValues;
  xdsScanPAuftrag.BeforeLoadDFMValues;
  xdsScanArbeitArt.BeforeLoadDFMValues;
  xdsScanInfos.BeforeLoadDFMValues;
  xdsScanDauerMinuten.BeforeLoadDFMValues;
  xdsScanKalkStundensatz.BeforeLoadDFMValues;
  xdsScanKalkKosten.BeforeLoadDFMValues;
  sourceScan.BeforeLoadDFMValues;
  xdsPauseFix.BeforeLoadDFMValues;
  xdsPauseFixFAID.BeforeLoadDFMValues;
  xdsPauseFixID.BeforeLoadDFMValues;
  xdsPauseFixPersonalnummer.BeforeLoadDFMValues;
  xdsPauseFixScanDatumZeit.BeforeLoadDFMValues;
  xdsPauseFixDatum.BeforeLoadDFMValues;
  xdsPauseFixScanArt.BeforeLoadDFMValues;
  xdsPauseFixObjektreferenz.BeforeLoadDFMValues;
  xdsPauseFixScanBegin.BeforeLoadDFMValues;
  xdsPauseFixScanEnde.BeforeLoadDFMValues;
  xdsPauseFixausgewertet.BeforeLoadDFMValues;
  xdsPauseFixAMS.BeforeLoadDFMValues;
  xdsPauseFixStundenArt.BeforeLoadDFMValues;
  xdsPauseFixKundennummer.BeforeLoadDFMValues;
  xdsPauseFixAuftrag.BeforeLoadDFMValues;
  xdsPauseFixPAuftrag.BeforeLoadDFMValues;
  xdsPauseFixArbeitArt.BeforeLoadDFMValues;
  xdsPauseFixInfos.BeforeLoadDFMValues;
  xdsPauseFixDauerMinuten.BeforeLoadDFMValues;
  xdsPauseFixKalkStundensatz.BeforeLoadDFMValues;
  xdsPauseFixKalkKosten.BeforeLoadDFMValues;
  xdsStundenart.BeforeLoadDFMValues;
  xdsStundenartStundenArt.BeforeLoadDFMValues;
  xdsStundenartSTDNR.BeforeLoadDFMValues;
  sourceStundenart.BeforeLoadDFMValues;
  xdsPZEEinstellungen.BeforeLoadDFMValues;
  xdsPZEEinstellungenZuordnungObjekt.BeforeLoadDFMValues;
  xdsPZEEinstellungenZuordnungKontakt.BeforeLoadDFMValues;
  xdsPZEEinstellungenZuordnungAuftrag.BeforeLoadDFMValues;
  xdsPZEEinstellungenZuordnungProduktion.BeforeLoadDFMValues;
  xdsPZEEinstellungenAuswahlNurKontaktnummer.BeforeLoadDFMValues;
  xdsPZEEinstellungenPauseVorgabe.BeforeLoadDFMValues;
  xdsPZEEinstellungenCadiaPZEWebModus.BeforeLoadDFMValues;
  WebTimer1.BeforeLoadDFMValues;
  WClientServerZeit.BeforeLoadDFMValues;
  xdsCheckObjekt.BeforeLoadDFMValues;
  xdsCheckObjektObjektReferenz.BeforeLoadDFMValues;
  xdsCheckObjektKurzbezeichnung.BeforeLoadDFMValues;
  xdsCheckObjektBezeichnung.BeforeLoadDFMValues;
  xdsCheckObjektObjektnummer.BeforeLoadDFMValues;
  xdsCheckAuftrag.BeforeLoadDFMValues;
  xdsCheckAuftragNummerkomplett.BeforeLoadDFMValues;
  xdsCheckAuftragAuftragsbezeichnung.BeforeLoadDFMValues;
  xdsCheckProduktion.BeforeLoadDFMValues;
  xdsCheckProduktionNummerkomplett.BeforeLoadDFMValues;
  xdsCheckProduktionAuftragsbezeichnung.BeforeLoadDFMValues;
  xdsCheckKontakt.BeforeLoadDFMValues;
  xdsCheckKontaktKundennummer.BeforeLoadDFMValues;
  xdsCheckKontaktNachname.BeforeLoadDFMValues;
  xdsCheckKontaktVorname.BeforeLoadDFMValues;
  ScanTimer.BeforeLoadDFMValues;
  try
    Name := 'Form1';
    Width := 817;
    Height := 694;
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    SetEvent(Self, 'OnBeforeUnload', 'WebFormBeforeUnload');
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnKeyPress', 'WebFormKeyPress');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    labelonlinestatus.SetParentComponent(Self);
    labelonlinestatus.Name := 'labelonlinestatus';
    labelonlinestatus.Left := 0;
    labelonlinestatus.Top := 493;
    labelonlinestatus.Width := 89;
    labelonlinestatus.Height := 15;
    labelonlinestatus.Caption := 'labelonlinestatus';
    labelonlinestatus.ElementClassName := 'h6 small m-2';
    labelonlinestatus.ElementFont := efCSS;
    labelonlinestatus.HeightStyle := ssAuto;
    labelonlinestatus.HeightPercent := 100.000000000000000000;
    labelonlinestatus.WidthPercent := 100.000000000000000000;
    lblAnmeldung.SetParentComponent(Self);
    lblAnmeldung.Name := 'lblAnmeldung';
    lblAnmeldung.Left := -1;
    lblAnmeldung.Top := 458;
    lblAnmeldung.Width := 76;
    lblAnmeldung.Height := 15;
    lblAnmeldung.Margins.Top := 0;
    lblAnmeldung.Margins.Bottom := 0;
    lblAnmeldung.Caption := 'lblAnmeldung';
    lblAnmeldung.ElementClassName := 'h6 small m-2';
    lblAnmeldung.ElementFont := efCSS;
    lblAnmeldung.ElementPosition := epIgnore;
    lblAnmeldung.HeightStyle := ssAuto;
    lblAnmeldung.HeightPercent := 100.000000000000000000;
    lblAnmeldung.WidthPercent := 100.000000000000000000;
    lblchecklogin.SetParentComponent(Self);
    lblchecklogin.Name := 'lblchecklogin';
    lblchecklogin.Left := 0;
    lblchecklogin.Top := 428;
    lblchecklogin.Width := 71;
    lblchecklogin.Height := 15;
    lblchecklogin.Caption := 'lblchecklogin';
    lblchecklogin.ElementClassName := 'h6 small m-2 text-danger';
    lblchecklogin.ElementFont := efCSS;
    lblchecklogin.HeightStyle := ssAuto;
    lblchecklogin.HeightPercent := 100.000000000000000000;
    lblchecklogin.WordWrap := True;
    lblchecklogin.WidthStyle := ssAuto;
    lblchecklogin.WidthPercent := 100.000000000000000000;
    lblstatus.SetParentComponent(Self);
    lblstatus.Name := 'lblstatus';
    lblstatus.Left := 8;
    lblstatus.Top := 264;
    lblstatus.Width := 44;
    lblstatus.Height := 15;
    lblstatus.Caption := 'lblstatus';
    lblstatus.ElementClassName := 'h6 text-primary m-1';
    lblstatus.ElementFont := efCSS;
    lblstatus.ElementPosition := epIgnore;
    lblstatus.HeightStyle := ssAuto;
    lblstatus.HeightPercent := 100.000000000000000000;
    lblstatus.WidthStyle := ssAuto;
    lblstatus.WidthPercent := 100.000000000000000000;
    LabelPZEFunktion.SetParentComponent(Self);
    LabelPZEFunktion.Name := 'LabelPZEFunktion';
    LabelPZEFunktion.Left := 8;
    LabelPZEFunktion.Top := 285;
    LabelPZEFunktion.Width := 95;
    LabelPZEFunktion.Height := 15;
    LabelPZEFunktion.Caption := 'LabelPZEFunktion';
    LabelPZEFunktion.ElementClassName := 'h4 center';
    LabelPZEFunktion.ElementFont := efCSS;
    LabelPZEFunktion.HeightStyle := ssAuto;
    LabelPZEFunktion.HeightPercent := 100.000000000000000000;
    LabelPZEFunktion.WordWrap := True;
    LabelPZEFunktion.WidthStyle := ssAuto;
    LabelPZEFunktion.WidthPercent := 100.000000000000000000;
    LabelScanMitarbeiterausweis.SetParentComponent(Self);
    LabelScanMitarbeiterausweis.Name := 'LabelScanMitarbeiterausweis';
    LabelScanMitarbeiterausweis.Left := 511;
    LabelScanMitarbeiterausweis.Top := 377;
    LabelScanMitarbeiterausweis.Width := 195;
    LabelScanMitarbeiterausweis.Height := 15;
    LabelScanMitarbeiterausweis.Caption := 'Scannen Sie Ihren Mitarbeiterausweis';
    LabelScanMitarbeiterausweis.ElementClassName := 'h6 m-3';
    LabelScanMitarbeiterausweis.ElementFont := efCSS;
    LabelScanMitarbeiterausweis.ElementPosition := epIgnore;
    LabelScanMitarbeiterausweis.HeightStyle := ssAuto;
    LabelScanMitarbeiterausweis.HeightPercent := 100.000000000000000000;
    LabelScanMitarbeiterausweis.WidthPercent := 100.000000000000000000;
    labelMitarbeiterauswahl.SetParentComponent(Self);
    labelMitarbeiterauswahl.Name := 'labelMitarbeiterauswahl';
    labelMitarbeiterauswahl.Left := 511;
    labelMitarbeiterauswahl.Top := 398;
    labelMitarbeiterauswahl.Width := 227;
    labelMitarbeiterauswahl.Height := 15;
    labelMitarbeiterauswahl.Caption := 'oder klicken Sie auf den Mitarbeiter-Button';
    labelMitarbeiterauswahl.ElementClassName := 'h6';
    labelMitarbeiterauswahl.ElementFont := efCSS;
    labelMitarbeiterauswahl.ElementPosition := epIgnore;
    labelMitarbeiterauswahl.HeightStyle := ssAuto;
    labelMitarbeiterauswahl.HeightPercent := 100.000000000000000000;
    labelMitarbeiterauswahl.WidthPercent := 100.000000000000000000;
    LabelLetzteAktion.SetParentComponent(Self);
    LabelLetzteAktion.Name := 'LabelLetzteAktion';
    LabelLetzteAktion.Left := 8;
    LabelLetzteAktion.Top := 243;
    LabelLetzteAktion.Width := 94;
    LabelLetzteAktion.Height := 15;
    LabelLetzteAktion.Caption := 'LabelLetzteAktion';
    LabelLetzteAktion.ElementClassName := 'h6 center text-info';
    LabelLetzteAktion.ElementFont := efCSS;
    LabelLetzteAktion.HeightStyle := ssAuto;
    LabelLetzteAktion.HeightPercent := 100.000000000000000000;
    LabelLetzteAktion.WordWrap := True;
    LabelLetzteAktion.WidthStyle := ssAuto;
    LabelLetzteAktion.WidthPercent := 100.000000000000000000;
    LabelMitarbeiter.SetParentComponent(Self);
    LabelMitarbeiter.Name := 'LabelMitarbeiter';
    LabelMitarbeiter.Left := 560;
    LabelMitarbeiter.Top := 214;
    LabelMitarbeiter.Width := 86;
    LabelMitarbeiter.Height := 15;
    LabelMitarbeiter.Caption := 'LabelMitarbeiter';
    LabelMitarbeiter.ElementClassName := 'h5 center text-success';
    LabelMitarbeiter.ElementFont := efCSS;
    LabelMitarbeiter.HeightStyle := ssAuto;
    LabelMitarbeiter.HeightPercent := 100.000000000000000000;
    LabelMitarbeiter.WordWrap := True;
    LabelMitarbeiter.WidthStyle := ssAuto;
    LabelMitarbeiter.WidthPercent := 100.000000000000000000;
    LabelZeitabweichung.SetParentComponent(Self);
    LabelZeitabweichung.Name := 'LabelZeitabweichung';
    LabelZeitabweichung.Left := 592;
    LabelZeitabweichung.Top := 248;
    LabelZeitabweichung.Width := 113;
    LabelZeitabweichung.Height := 15;
    LabelZeitabweichung.Caption := 'LabelZeitabweichung';
    LabelZeitabweichung.ElementClassName := 'h6 small m-2';
    LabelZeitabweichung.ElementFont := efCSS;
    LabelZeitabweichung.ElementPosition := epIgnore;
    LabelZeitabweichung.HeightStyle := ssAuto;
    LabelZeitabweichung.HeightPercent := 100.000000000000000000;
    LabelZeitabweichung.WidthStyle := ssAuto;
    LabelZeitabweichung.WidthPercent := 100.000000000000000000;
    LabelScanAlternativ.SetParentComponent(Self);
    LabelScanAlternativ.Name := 'LabelScanAlternativ';
    LabelScanAlternativ.Left := 536;
    LabelScanAlternativ.Top := 475;
    LabelScanAlternativ.Width := 209;
    LabelScanAlternativ.Height := 15;
    LabelScanAlternativ.Caption := 'Scannen Sie: Aktion, Objekt, Stundenart';
    LabelScanAlternativ.ElementClassName := 'h6 m-3';
    LabelScanAlternativ.ElementFont := efCSS;
    LabelScanAlternativ.ElementPosition := epIgnore;
    LabelScanAlternativ.HeightStyle := ssAuto;
    LabelScanAlternativ.HeightPercent := 100.000000000000000000;
    LabelScanAlternativ.WidthPercent := 100.000000000000000000;
    lblCadiaKundennummer.SetParentComponent(Self);
    lblCadiaKundennummer.Name := 'lblCadiaKundennummer';
    lblCadiaKundennummer.Left := 8;
    lblCadiaKundennummer.Top := 472;
    lblCadiaKundennummer.Width := 87;
    lblCadiaKundennummer.Height := 15;
    lblCadiaKundennummer.Caption := 'Kundennummer';
    lblCadiaKundennummer.ElementClassName := 'h6 small m-2';
    lblCadiaKundennummer.ElementFont := efCSS;
    lblCadiaKundennummer.ElementPosition := epIgnore;
    lblCadiaKundennummer.HeightStyle := ssAuto;
    lblCadiaKundennummer.HeightPercent := 100.000000000000000000;
    lblCadiaKundennummer.WordWrap := True;
    lblCadiaKundennummer.WidthStyle := ssAuto;
    lblCadiaKundennummer.WidthPercent := 100.000000000000000000;
    Container1.SetParentComponent(Self);
    Container1.Name := 'Container1';
    Container1.Left := 0;
    Container1.Top := 0;
    Container1.Width := 169;
    Container1.Height := 41;
    Container1.HeightStyle := ssAuto;
    Container1.WidthStyle := ssPercent;
    Container1.ChildOrder := 1;
    Container1.ElementFont := efCSS;
    Container1.ElementPosition := epIgnore;
    Container1.ScrollStyle := ssVertical;
    Container2.SetParentComponent(Self);
    Container2.Name := 'Container2';
    Container2.Left := 8;
    Container2.Top := 47;
    Container2.Width := 169;
    Container2.Height := 41;
    Container2.ElementClassName := 'col d-flex justify-content-center';
    Container2.HeightStyle := ssAuto;
    Container2.WidthStyle := ssAuto;
    Container2.ChildOrder := 5;
    Container2.ElementFont := efCSS;
    Container2.ElementPosition := epIgnore;
    Container2.ScrollStyle := ssNone;
    Container3.SetParentComponent(Self);
    Container3.Name := 'Container3';
    Container3.Left := 8;
    Container3.Top := 94;
    Container3.Width := 169;
    Container3.Height := 41;
    Container3.ElementClassName := 'justify-content-center';
    Container3.HeightStyle := ssAuto;
    Container3.WidthStyle := ssPercent;
    Container3.ChildOrder := 5;
    Container3.ElementFont := efCSS;
    Container3.ElementPosition := epIgnore;
    Container3.ScrollStyle := ssNone;
    Container4.SetParentComponent(Self);
    Container4.Name := 'Container4';
    Container4.Left := 8;
    Container4.Top := 318;
    Container4.Width := 169;
    Container4.Height := 41;
    Container4.ElementClassName := 'container-fluid m-1';
    Container4.HeightStyle := ssAuto;
    Container4.WidthStyle := ssPercent;
    Container4.ChildOrder := 5;
    Container4.ElementFont := efCSS;
    Container4.ElementPosition := epIgnore;
    Container4.ScrollStyle := ssNone;
    Container5.SetParentComponent(Self);
    Container5.Name := 'Container5';
    Container5.Left := 8;
    Container5.Top := 365;
    Container5.Width := 169;
    Container5.Height := 41;
    Container5.ElementClassName := 'container-fluid row-align-items-center';
    Container5.HeightStyle := ssAuto;
    Container5.WidthStyle := ssPercent;
    Container5.ChildOrder := 5;
    Container5.ElementFont := efCSS;
    Container5.ElementPosition := epIgnore;
    Container5.ScrollStyle := ssNone;
    panelfunktionen.SetParentComponent(Self);
    panelfunktionen.Name := 'panelfunktionen';
    panelfunktionen.Left := 216;
    panelfunktionen.Top := 1;
    panelfunktionen.Width := 314;
    panelfunktionen.Height := 685;
    panelfunktionen.ElementClassName := 'card m-1 border-info';
    panelfunktionen.HeightStyle := ssAuto;
    panelfunktionen.WidthStyle := ssPercent;
    panelfunktionen.Caption := 'panelfunktionen';
    panelfunktionen.ChildOrder := 9;
    panelfunktionen.Color := 8340248;
    panelfunktionen.ElementBodyClassName := 'card-body';
    panelfunktionen.ElementFont := efCSS;
    panelfunktionen.ElementPosition := epIgnore;
    panelfunktionen.ShowCaption := False;
    panelfunktionen.TabOrder := 5;
    btnAnmelden.SetParentComponent(panelfunktionen);
    btnAnmelden.Name := 'btnAnmelden';
    btnAnmelden.AlignWithMargins := True;
    btnAnmelden.Left := 3;
    btnAnmelden.Top := 3;
    btnAnmelden.Width := 308;
    btnAnmelden.Height := 40;
    btnAnmelden.Align := alTop;
    btnAnmelden.Caption := 'Anmelden';
    btnAnmelden.ChildOrder := 7;
    btnAnmelden.ElementClassName := 'btn btn-info btn-sm text-center m-1';
    btnAnmelden.ElementFont := efCSS;
    btnAnmelden.ElementPosition := epIgnore;
    btnAnmelden.HeightStyle := ssAuto;
    btnAnmelden.HeightPercent := 100.000000000000000000;
    btnAnmelden.WidthStyle := ssAuto;
    btnAnmelden.WidthPercent := 100.000000000000000000;
    SetEvent(btnAnmelden, Self, 'OnClick', 'btnAnmeldenClick');
    btnPauseBeginn.SetParentComponent(panelfunktionen);
    btnPauseBeginn.Name := 'btnPauseBeginn';
    btnPauseBeginn.AlignWithMargins := True;
    btnPauseBeginn.Left := 3;
    btnPauseBeginn.Top := 95;
    btnPauseBeginn.Width := 308;
    btnPauseBeginn.Height := 40;
    btnPauseBeginn.Align := alTop;
    btnPauseBeginn.Caption := 'Pause';
    btnPauseBeginn.ChildOrder := 9;
    btnPauseBeginn.ElementClassName := 'btn btn-info btn-sm text-center m-1';
    btnPauseBeginn.ElementFont := efCSS;
    btnPauseBeginn.ElementPosition := epIgnore;
    btnPauseBeginn.HeightStyle := ssAuto;
    btnPauseBeginn.HeightPercent := 100.000000000000000000;
    btnPauseBeginn.WidthStyle := ssAuto;
    btnPauseBeginn.WidthPercent := 100.000000000000000000;
    SetEvent(btnPauseBeginn, Self, 'OnClick', 'btnPauseBeginnClick');
    btnPauseEnde.SetParentComponent(panelfunktionen);
    btnPauseEnde.Name := 'btnPauseEnde';
    btnPauseEnde.AlignWithMargins := True;
    btnPauseEnde.Left := 3;
    btnPauseEnde.Top := 141;
    btnPauseEnde.Width := 308;
    btnPauseEnde.Height := 40;
    btnPauseEnde.Align := alTop;
    btnPauseEnde.Caption := 'Pause Ende';
    btnPauseEnde.ChildOrder := 10;
    btnPauseEnde.ElementClassName := 'btn btn-info btn-sm text-center m-1';
    btnPauseEnde.ElementFont := efCSS;
    btnPauseEnde.ElementPosition := epIgnore;
    btnPauseEnde.HeightStyle := ssAuto;
    btnPauseEnde.HeightPercent := 100.000000000000000000;
    btnPauseEnde.WidthStyle := ssAuto;
    btnPauseEnde.WidthPercent := 100.000000000000000000;
    SetEvent(btnPauseEnde, Self, 'OnClick', 'btnPauseEndeClick');
    btnAbmelden.SetParentComponent(panelfunktionen);
    btnAbmelden.Name := 'btnAbmelden';
    btnAbmelden.AlignWithMargins := True;
    btnAbmelden.Left := 3;
    btnAbmelden.Top := 531;
    btnAbmelden.Width := 308;
    btnAbmelden.Height := 40;
    btnAbmelden.Align := alTop;
    btnAbmelden.Caption := 'Abmelden';
    btnAbmelden.ChildOrder := 11;
    btnAbmelden.ElementClassName := 'btn btn-info btn-sm text-center m-1';
    btnAbmelden.ElementFont := efCSS;
    btnAbmelden.ElementPosition := epIgnore;
    btnAbmelden.HeightStyle := ssAuto;
    btnAbmelden.HeightPercent := 100.000000000000000000;
    btnAbmelden.WidthStyle := ssAuto;
    btnAbmelden.WidthPercent := 100.000000000000000000;
    SetEvent(btnAbmelden, Self, 'OnClick', 'btnAbmeldenClick');
    btnObjektBeginn.SetParentComponent(panelfunktionen);
    btnObjektBeginn.Name := 'btnObjektBeginn';
    btnObjektBeginn.AlignWithMargins := True;
    btnObjektBeginn.Left := 3;
    btnObjektBeginn.Top := 187;
    btnObjektBeginn.Width := 308;
    btnObjektBeginn.Height := 40;
    btnObjektBeginn.Align := alTop;
    btnObjektBeginn.Caption := 'Objekt';
    btnObjektBeginn.ChildOrder := 13;
    btnObjektBeginn.ElementClassName := 'btn btn-info btn-sm text-center m-1';
    btnObjektBeginn.ElementFont := efCSS;
    btnObjektBeginn.ElementPosition := epIgnore;
    btnObjektBeginn.HeightStyle := ssAuto;
    btnObjektBeginn.HeightPercent := 100.000000000000000000;
    btnObjektBeginn.WidthStyle := ssAuto;
    btnObjektBeginn.WidthPercent := 100.000000000000000000;
    SetEvent(btnObjektBeginn, Self, 'OnClick', 'btnObjektBeginnClick');
    btnObjektEnde.SetParentComponent(panelfunktionen);
    btnObjektEnde.Name := 'btnObjektEnde';
    btnObjektEnde.AlignWithMargins := True;
    btnObjektEnde.Left := 3;
    btnObjektEnde.Top := 509;
    btnObjektEnde.Width := 308;
    btnObjektEnde.Height := 16;
    btnObjektEnde.Align := alTop;
    btnObjektEnde.Caption := 'Objekt Ende';
    btnObjektEnde.ChildOrder := 14;
    btnObjektEnde.ElementClassName := 'btn btn-info btn-sm text-center m-1';
    btnObjektEnde.ElementFont := efCSS;
    btnObjektEnde.ElementPosition := epIgnore;
    btnObjektEnde.HeightStyle := ssAuto;
    btnObjektEnde.HeightPercent := 100.000000000000000000;
    btnObjektEnde.WidthStyle := ssAuto;
    btnObjektEnde.WidthPercent := 100.000000000000000000;
    SetEvent(btnObjektEnde, Self, 'OnClick', 'btnObjektEndeClick');
    btnErneutAnmelden.SetParentComponent(panelfunktionen);
    btnErneutAnmelden.Name := 'btnErneutAnmelden';
    btnErneutAnmelden.AlignWithMargins := True;
    btnErneutAnmelden.Left := 3;
    btnErneutAnmelden.Top := 577;
    btnErneutAnmelden.Width := 308;
    btnErneutAnmelden.Height := 40;
    btnErneutAnmelden.Align := alTop;
    btnErneutAnmelden.Caption := 'erneut anmelden';
    btnErneutAnmelden.ChildOrder := 12;
    btnErneutAnmelden.ElementClassName := 'btn btn-info btn-sm text-center m-1';
    btnErneutAnmelden.ElementFont := efCSS;
    btnErneutAnmelden.ElementPosition := epIgnore;
    btnErneutAnmelden.HeightStyle := ssAuto;
    btnErneutAnmelden.HeightPercent := 100.000000000000000000;
    btnErneutAnmelden.WidthStyle := ssAuto;
    btnErneutAnmelden.WidthPercent := 100.000000000000000000;
    SetEvent(btnErneutAnmelden, Self, 'OnClick', 'btnErneutAnmeldenClick');
    btnKontaktBeginn.SetParentComponent(panelfunktionen);
    btnKontaktBeginn.Name := 'btnKontaktBeginn';
    btnKontaktBeginn.AlignWithMargins := True;
    btnKontaktBeginn.Left := 3;
    btnKontaktBeginn.Top := 233;
    btnKontaktBeginn.Width := 308;
    btnKontaktBeginn.Height := 40;
    btnKontaktBeginn.Align := alTop;
    btnKontaktBeginn.Caption := 'Kontakt';
    btnKontaktBeginn.ChildOrder := 13;
    btnKontaktBeginn.ElementClassName := 'btn btn-info btn-sm text-center m-1';
    btnKontaktBeginn.ElementFont := efCSS;
    btnKontaktBeginn.ElementPosition := epIgnore;
    btnKontaktBeginn.HeightStyle := ssAuto;
    btnKontaktBeginn.HeightPercent := 100.000000000000000000;
    btnKontaktBeginn.WidthStyle := ssAuto;
    btnKontaktBeginn.WidthPercent := 100.000000000000000000;
    SetEvent(btnKontaktBeginn, Self, 'OnClick', 'btnKontaktBeginnClick');
    btnKontaktEnde.SetParentComponent(panelfunktionen);
    btnKontaktEnde.Name := 'btnKontaktEnde';
    btnKontaktEnde.AlignWithMargins := True;
    btnKontaktEnde.Left := 3;
    btnKontaktEnde.Top := 463;
    btnKontaktEnde.Width := 308;
    btnKontaktEnde.Height := 40;
    btnKontaktEnde.Align := alTop;
    btnKontaktEnde.Caption := 'Kontakt Ende';
    btnKontaktEnde.ChildOrder := 14;
    btnKontaktEnde.ElementClassName := 'btn btn-info btn-sm text-center m-1';
    btnKontaktEnde.ElementFont := efCSS;
    btnKontaktEnde.ElementPosition := epIgnore;
    btnKontaktEnde.HeightStyle := ssAuto;
    btnKontaktEnde.HeightPercent := 100.000000000000000000;
    btnKontaktEnde.WidthStyle := ssAuto;
    btnKontaktEnde.WidthPercent := 100.000000000000000000;
    SetEvent(btnKontaktEnde, Self, 'OnClick', 'btnKontaktEndeClick');
    btnAuftragBeginn.SetParentComponent(panelfunktionen);
    btnAuftragBeginn.Name := 'btnAuftragBeginn';
    btnAuftragBeginn.AlignWithMargins := True;
    btnAuftragBeginn.Left := 3;
    btnAuftragBeginn.Top := 279;
    btnAuftragBeginn.Width := 308;
    btnAuftragBeginn.Height := 40;
    btnAuftragBeginn.Align := alTop;
    btnAuftragBeginn.Caption := 'Auftrag';
    btnAuftragBeginn.ChildOrder := 13;
    btnAuftragBeginn.ElementClassName := 'btn btn-info btn-sm text-center m-1';
    btnAuftragBeginn.ElementFont := efCSS;
    btnAuftragBeginn.ElementPosition := epIgnore;
    btnAuftragBeginn.HeightStyle := ssAuto;
    btnAuftragBeginn.HeightPercent := 100.000000000000000000;
    btnAuftragBeginn.WidthStyle := ssAuto;
    btnAuftragBeginn.WidthPercent := 100.000000000000000000;
    SetEvent(btnAuftragBeginn, Self, 'OnClick', 'btnAuftragBeginnClick');
    btnAuftragEnde.SetParentComponent(panelfunktionen);
    btnAuftragEnde.Name := 'btnAuftragEnde';
    btnAuftragEnde.AlignWithMargins := True;
    btnAuftragEnde.Left := 3;
    btnAuftragEnde.Top := 417;
    btnAuftragEnde.Width := 308;
    btnAuftragEnde.Height := 40;
    btnAuftragEnde.Align := alTop;
    btnAuftragEnde.Caption := 'Auftrag Ende';
    btnAuftragEnde.ChildOrder := 14;
    btnAuftragEnde.ElementClassName := 'btn btn-info btn-sm text-center m-1';
    btnAuftragEnde.ElementFont := efCSS;
    btnAuftragEnde.ElementPosition := epIgnore;
    btnAuftragEnde.HeightStyle := ssAuto;
    btnAuftragEnde.HeightPercent := 100.000000000000000000;
    btnAuftragEnde.WidthStyle := ssAuto;
    btnAuftragEnde.WidthPercent := 100.000000000000000000;
    SetEvent(btnAuftragEnde, Self, 'OnClick', 'btnAuftragEndeClick');
    btnProduktionBeginn.SetParentComponent(panelfunktionen);
    btnProduktionBeginn.Name := 'btnProduktionBeginn';
    btnProduktionBeginn.AlignWithMargins := True;
    btnProduktionBeginn.Left := 3;
    btnProduktionBeginn.Top := 325;
    btnProduktionBeginn.Width := 308;
    btnProduktionBeginn.Height := 40;
    btnProduktionBeginn.Align := alTop;
    btnProduktionBeginn.Caption := 'Produktion';
    btnProduktionBeginn.ChildOrder := 13;
    btnProduktionBeginn.ElementClassName := 'btn btn-info btn-sm text-center m-1';
    btnProduktionBeginn.ElementFont := efCSS;
    btnProduktionBeginn.ElementPosition := epIgnore;
    btnProduktionBeginn.HeightStyle := ssAuto;
    btnProduktionBeginn.HeightPercent := 100.000000000000000000;
    btnProduktionBeginn.WidthStyle := ssAuto;
    btnProduktionBeginn.WidthPercent := 100.000000000000000000;
    SetEvent(btnProduktionBeginn, Self, 'OnClick', 'btnProduktionBeginnClick');
    btnProduktionEnde.SetParentComponent(panelfunktionen);
    btnProduktionEnde.Name := 'btnProduktionEnde';
    btnProduktionEnde.AlignWithMargins := True;
    btnProduktionEnde.Left := 3;
    btnProduktionEnde.Top := 371;
    btnProduktionEnde.Width := 308;
    btnProduktionEnde.Height := 40;
    btnProduktionEnde.Align := alTop;
    btnProduktionEnde.Caption := 'Produktion Ende';
    btnProduktionEnde.ChildOrder := 14;
    btnProduktionEnde.ElementClassName := 'btn btn-info btn-sm text-center m-1';
    btnProduktionEnde.ElementFont := efCSS;
    btnProduktionEnde.ElementPosition := epIgnore;
    btnProduktionEnde.HeightStyle := ssAuto;
    btnProduktionEnde.HeightPercent := 100.000000000000000000;
    btnProduktionEnde.WidthStyle := ssAuto;
    btnProduktionEnde.WidthPercent := 100.000000000000000000;
    SetEvent(btnProduktionEnde, Self, 'OnClick', 'btnProduktionEndeClick');
    btnPauseVorgabe.SetParentComponent(panelfunktionen);
    btnPauseVorgabe.Name := 'btnPauseVorgabe';
    btnPauseVorgabe.AlignWithMargins := True;
    btnPauseVorgabe.Left := 3;
    btnPauseVorgabe.Top := 49;
    btnPauseVorgabe.Width := 308;
    btnPauseVorgabe.Height := 40;
    btnPauseVorgabe.Align := alTop;
    btnPauseVorgabe.Caption := 'Pause';
    btnPauseVorgabe.ChildOrder := 9;
    btnPauseVorgabe.ElementClassName := 'btn btn-info btn-sm text-center m-1';
    btnPauseVorgabe.ElementFont := efCSS;
    btnPauseVorgabe.ElementPosition := epIgnore;
    btnPauseVorgabe.HeightStyle := ssAuto;
    btnPauseVorgabe.HeightPercent := 100.000000000000000000;
    btnPauseVorgabe.WidthStyle := ssAuto;
    btnPauseVorgabe.WidthPercent := 100.000000000000000000;
    SetEvent(btnPauseVorgabe, Self, 'OnClick', 'btnPauseVorgabeClick');
    TC.SetParentComponent(Self);
    TC.Name := 'TC';
    TC.Left := 271;
    TC.Top := 392;
    TC.Width := 247;
    TC.Height := 81;
    TC.ElementClassName := 'table table-sm table-hover table-bordered table-striped';
    TC.HeightStyle := ssAuto;
    TC.WidthStyle := ssPercent;
    TC.BorderColor := clSilver;
    TC.ChildOrder := 2;
    TC.ColHeader := False;
    TC.ElementFont := efCSS;
    TC.ElementHeaderClassName := 'table-info';
    TC.ElementPosition := epIgnore;
    TC.ElementTableClassName := 'table table-sm table-hover table-bordered table-striped';
    TC.Options.ScrollVertical := True;
    TC.ColCount := 2;
    panelstundenart.SetParentComponent(Self);
    panelstundenart.Name := 'panelstundenart';
    panelstundenart.Left := 8;
    panelstundenart.Top := 510;
    panelstundenart.Width := 241;
    panelstundenart.Height := 195;
    panelstundenart.ElementClassName := 'card m-1 border-info';
    panelstundenart.HeightStyle := ssAuto;
    panelstundenart.Caption := 'panelArbeitsart';
    panelstundenart.ChildOrder := 8;
    panelstundenart.ElementBodyClassName := 'card-body';
    panelstundenart.ElementFont := efCSS;
    panelstundenart.ElementPosition := epIgnore;
    panelstundenart.ShowCaption := False;
    panelstundenart.TabOrder := 7;
    lblauswahlobjekt.SetParentComponent(panelstundenart);
    lblauswahlobjekt.Name := 'lblauswahlobjekt';
    lblauswahlobjekt.Left := 16;
    lblauswahlobjekt.Top := 8;
    lblauswahlobjekt.Width := 77;
    lblauswahlobjekt.Height := 15;
    lblauswahlobjekt.Caption := 'lblauswahlinfo';
    lblauswahlobjekt.ElementLabelClassName := 'h6';
    lblauswahlobjekt.ElementFont := efCSS;
    lblauswahlobjekt.ElementPosition := epIgnore;
    lblauswahlobjekt.HeightStyle := ssAuto;
    lblauswahlobjekt.HeightPercent := 100.000000000000000000;
    lblauswahlobjekt.WordWrap := True;
    lblauswahlobjekt.WidthStyle := ssAuto;
    lblauswahlobjekt.WidthPercent := 100.000000000000000000;
    btnObjektOK.SetParentComponent(panelstundenart);
    btnObjektOK.Name := 'btnObjektOK';
    btnObjektOK.Left := 136;
    btnObjektOK.Top := 160;
    btnObjektOK.Width := 96;
    btnObjektOK.Height := 25;
    btnObjektOK.Caption := 'OK';
    btnObjektOK.ChildOrder := 3;
    btnObjektOK.ElementClassName := 'btn btn-info btn-sm m-2 text-center';
    btnObjektOK.ElementFont := efCSS;
    btnObjektOK.ElementPosition := epIgnore;
    btnObjektOK.HeightStyle := ssAuto;
    btnObjektOK.HeightPercent := 100.000000000000000000;
    btnObjektOK.WidthStyle := ssAuto;
    btnObjektOK.WidthPercent := 100.000000000000000000;
    SetEvent(btnObjektOK, Self, 'OnClick', 'btnObjektOKClick');
    btnObjektAbbrechen.SetParentComponent(panelstundenart);
    btnObjektAbbrechen.Name := 'btnObjektAbbrechen';
    btnObjektAbbrechen.Left := 16;
    btnObjektAbbrechen.Top := 160;
    btnObjektAbbrechen.Width := 96;
    btnObjektAbbrechen.Height := 25;
    btnObjektAbbrechen.Caption := 'Abbrechen';
    btnObjektAbbrechen.ChildOrder := 2;
    btnObjektAbbrechen.ElementClassName := 'btn btn-info btn-sm m-2 text-center';
    btnObjektAbbrechen.ElementFont := efCSS;
    btnObjektAbbrechen.ElementPosition := epIgnore;
    btnObjektAbbrechen.HeightStyle := ssAuto;
    btnObjektAbbrechen.HeightPercent := 100.000000000000000000;
    btnObjektAbbrechen.WidthStyle := ssAuto;
    btnObjektAbbrechen.WidthPercent := 100.000000000000000000;
    lookupstundenart.SetParentComponent(panelstundenart);
    lookupstundenart.Name := 'lookupstundenart';
    lookupstundenart.Left := 40;
    lookupstundenart.Top := 56;
    lookupstundenart.Width := 177;
    lookupstundenart.Height := 23;
    lookupstundenart.ChildOrder := 1;
    lookupstundenart.ElementClassName := 'form-control w-75 m-1';
    lookupstundenart.ElementFont := efCSS;
    lookupstundenart.ElementPosition := epIgnore;
    lookupstundenart.HeightStyle := ssAuto;
    lookupstundenart.HeightPercent := 100.000000000000000000;
    lookupstundenart.Text := 'lookupstundenart';
    lookupstundenart.WidthPercent := 100.000000000000000000;
    lookupstundenart.ItemIndex := -1;
    panelArbeitsart.SetParentComponent(Self);
    panelArbeitsart.Name := 'panelArbeitsart';
    panelArbeitsart.Left := 520;
    panelArbeitsart.Top := 512;
    panelArbeitsart.Width := 241;
    panelArbeitsart.Height := 195;
    panelArbeitsart.ElementClassName := 'card m-1 border-info';
    panelArbeitsart.HeightStyle := ssAuto;
    panelArbeitsart.Caption := 'panelArbeitsart';
    panelArbeitsart.ChildOrder := 8;
    panelArbeitsart.ElementBodyClassName := 'card-body';
    panelArbeitsart.ElementFont := efCSS;
    panelArbeitsart.ElementPosition := epIgnore;
    panelArbeitsart.ShowCaption := False;
    panelArbeitsart.TabOrder := 8;
    lblauswahlinfo.SetParentComponent(panelArbeitsart);
    lblauswahlinfo.Name := 'lblauswahlinfo';
    lblauswahlinfo.Left := 16;
    lblauswahlinfo.Top := 8;
    lblauswahlinfo.Width := 77;
    lblauswahlinfo.Height := 15;
    lblauswahlinfo.Caption := 'lblauswahlinfo';
    lblauswahlinfo.ElementLabelClassName := 'h6';
    lblauswahlinfo.ElementFont := efCSS;
    lblauswahlinfo.ElementPosition := epIgnore;
    lblauswahlinfo.HeightStyle := ssAuto;
    lblauswahlinfo.HeightPercent := 100.000000000000000000;
    lblauswahlinfo.WordWrap := True;
    lblauswahlinfo.WidthStyle := ssAuto;
    lblauswahlinfo.WidthPercent := 100.000000000000000000;
    radioarbeitsart.SetParentComponent(panelArbeitsart);
    radioarbeitsart.Name := 'radioarbeitsart';
    radioarbeitsart.Left := 40;
    radioarbeitsart.Top := 32;
    radioarbeitsart.Width := 160;
    radioarbeitsart.Height := 122;
    radioarbeitsart.ElementClassName := 'form-check';
    radioarbeitsart.HeightStyle := ssAuto;
    radioarbeitsart.WidthStyle := ssAuto;
    radioarbeitsart.Caption := 'Arbeitsart';
    radioarbeitsart.ChildOrder := 1;
    radioarbeitsart.Columns := 1;
    radioarbeitsart.ControlPosition := epIgnore;
    radioarbeitsart.ElementButtonClassName := 'form-check-input type=radio';
    radioarbeitsart.ElementGroupClassName := 'form-check type=radio';
    radioarbeitsart.ElementLabelClassName := 'form-check-label';
    radioarbeitsart.ElementLegendClassName := 'h6';
    radioarbeitsart.ElementFont := efCSS;
    radioarbeitsart.ElementPosition := epIgnore;
    radioarbeitsart.ItemIndex := 0;
    radioarbeitsart.Items.BeginUpdate;
    try
      radioarbeitsart.Items.Clear;
      radioarbeitsart.Items.Add('[-]');
      radioarbeitsart.Items.Add('Arbeitszeit');
      radioarbeitsart.Items.Add('Fahrzeit');
    finally
      radioarbeitsart.Items.EndUpdate;
    end;
    radioarbeitsart.Role := '';
    radioarbeitsart.TabOrder := 0;
    btnOK.SetParentComponent(panelArbeitsart);
    btnOK.Name := 'btnOK';
    btnOK.Left := 136;
    btnOK.Top := 160;
    btnOK.Width := 96;
    btnOK.Height := 25;
    btnOK.Caption := 'OK';
    btnOK.ChildOrder := 3;
    btnOK.ElementClassName := 'btn btn-info btn-sm m-2 text-center';
    btnOK.ElementFont := efCSS;
    btnOK.ElementPosition := epIgnore;
    btnOK.HeightStyle := ssAuto;
    btnOK.HeightPercent := 100.000000000000000000;
    btnOK.WidthStyle := ssAuto;
    btnOK.WidthPercent := 100.000000000000000000;
    SetEvent(btnOK, Self, 'OnClick', 'btnOKClick');
    btnAbbrechen.SetParentComponent(panelArbeitsart);
    btnAbbrechen.Name := 'btnAbbrechen';
    btnAbbrechen.Left := 16;
    btnAbbrechen.Top := 160;
    btnAbbrechen.Width := 96;
    btnAbbrechen.Height := 25;
    btnAbbrechen.Caption := 'Abbrechen';
    btnAbbrechen.ChildOrder := 2;
    btnAbbrechen.ElementClassName := 'btn btn-info btn-sm m-2 text-center';
    btnAbbrechen.ElementFont := efCSS;
    btnAbbrechen.ElementPosition := epIgnore;
    btnAbbrechen.HeightStyle := ssAuto;
    btnAbbrechen.HeightPercent := 100.000000000000000000;
    btnAbbrechen.WidthStyle := ssAuto;
    btnAbbrechen.WidthPercent := 100.000000000000000000;
    SetEvent(btnAbbrechen, Self, 'OnClick', 'btnAbbrechenClick');
    ContainerMitarbeiterausweis.SetParentComponent(Self);
    ContainerMitarbeiterausweis.Name := 'ContainerMitarbeiterausweis';
    ContainerMitarbeiterausweis.Left := 24;
    ContainerMitarbeiterausweis.Top := 141;
    ContainerMitarbeiterausweis.Width := 169;
    ContainerMitarbeiterausweis.Height := 41;
    ContainerMitarbeiterausweis.ElementClassName := 'co d-flex justify-content-center border border-1 border-secondary m-1';
    ContainerMitarbeiterausweis.HeightStyle := ssAuto;
    ContainerMitarbeiterausweis.WidthStyle := ssAuto;
    ContainerMitarbeiterausweis.ChildOrder := 5;
    ContainerMitarbeiterausweis.ElementFont := efCSS;
    ContainerMitarbeiterausweis.ElementPosition := epIgnore;
    ContainerMitarbeiterausweis.ScrollStyle := ssNone;
    edtSuchbegriff.SetParentComponent(Self);
    edtSuchbegriff.Name := 'edtSuchbegriff';
    edtSuchbegriff.Left := 511;
    edtSuchbegriff.Top := 337;
    edtSuchbegriff.Width := 180;
    edtSuchbegriff.Height := 22;
    edtSuchbegriff.AutoCompletion := acNone;
    edtSuchbegriff.ChildOrder := 40;
    edtSuchbegriff.ElementClassName := 'form-control input-sm m-1';
    edtSuchbegriff.ElementFont := efCSS;
    edtSuchbegriff.ElementPosition := epIgnore;
    edtSuchbegriff.HeightStyle := ssAuto;
    edtSuchbegriff.HeightPercent := 100.000000000000000000;
    edtSuchbegriff.ShowHint := True;
    edtSuchbegriff.SpellCheck := False;
    edtSuchbegriff.TextHint := 'Suchbegriff eingeben';
    edtSuchbegriff.WidthPercent := 60.000000000000000000;
    SetEvent(edtSuchbegriff, Self, 'OnChange', 'edtSuchbegriffChange');
    SetEvent(edtSuchbegriff, Self, 'OnKeyDown', 'edtSuchbegriffKeyDown');
    ContainerLabelMitarbeiterAuswahl.SetParentComponent(Self);
    ContainerLabelMitarbeiterAuswahl.Name := 'ContainerLabelMitarbeiterAuswahl';
    ContainerLabelMitarbeiterAuswahl.Left := 24;
    ContainerLabelMitarbeiterAuswahl.Top := 188;
    ContainerLabelMitarbeiterAuswahl.Width := 169;
    ContainerLabelMitarbeiterAuswahl.Height := 41;
    ContainerLabelMitarbeiterAuswahl.ElementClassName := 'col d-flex justify-content-center';
    ContainerLabelMitarbeiterAuswahl.HeightStyle := ssAuto;
    ContainerLabelMitarbeiterAuswahl.WidthStyle := ssAuto;
    ContainerLabelMitarbeiterAuswahl.ChildOrder := 5;
    ContainerLabelMitarbeiterAuswahl.ElementFont := efCSS;
    ContainerLabelMitarbeiterAuswahl.ElementPosition := epIgnore;
    ContainerLabelMitarbeiterAuswahl.ScrollStyle := ssNone;
    ContainerModus.SetParentComponent(Self);
    ContainerModus.Name := 'ContainerModus';
    ContainerModus.Left := 96;
    ContainerModus.Top := 432;
    ContainerModus.Width := 169;
    ContainerModus.Height := 41;
    ContainerModus.ElementClassName := 'col d-flex justify-content-center';
    ContainerModus.HeightStyle := ssAuto;
    ContainerModus.WidthStyle := ssPercent;
    ContainerModus.ChildOrder := 5;
    ContainerModus.ElementFont := efCSS;
    ContainerModus.ElementPosition := epIgnore;
    ContainerModus.ScrollStyle := ssNone;
    ContainerLetzteAktion.SetParentComponent(Self);
    ContainerLetzteAktion.Name := 'ContainerLetzteAktion';
    ContainerLetzteAktion.Left := 95;
    ContainerLetzteAktion.Top := 475;
    ContainerLetzteAktion.Width := 169;
    ContainerLetzteAktion.Height := 41;
    ContainerLetzteAktion.ElementClassName := 'col d-flex justify-content-center';
    ContainerLetzteAktion.HeightStyle := ssAuto;
    ContainerLetzteAktion.WidthStyle := ssPercent;
    ContainerLetzteAktion.ChildOrder := 5;
    ContainerLetzteAktion.ElementFont := efCSS;
    ContainerLetzteAktion.ElementPosition := epIgnore;
    ContainerLetzteAktion.ScrollStyle := ssNone;
    ContainerStatus.SetParentComponent(Self);
    ContainerStatus.Name := 'ContainerStatus';
    ContainerStatus.Left := 96;
    ContainerStatus.Top := 522;
    ContainerStatus.Width := 169;
    ContainerStatus.Height := 41;
    ContainerStatus.ElementClassName := 'col d-flex justify-content-center';
    ContainerStatus.HeightStyle := ssAuto;
    ContainerStatus.WidthStyle := ssPercent;
    ContainerStatus.ChildOrder := 5;
    ContainerStatus.ElementFont := efCSS;
    ContainerStatus.ElementPosition := epIgnore;
    ContainerStatus.ScrollStyle := ssNone;
    ContainerMitarbeiter.SetParentComponent(Self);
    ContainerMitarbeiter.Name := 'ContainerMitarbeiter';
    ContainerMitarbeiter.Left := 120;
    ContainerMitarbeiter.Top := 259;
    ContainerMitarbeiter.Width := 169;
    ContainerMitarbeiter.Height := 41;
    ContainerMitarbeiter.ElementClassName := 'col d-flex justify-content-center';
    ContainerMitarbeiter.HeightStyle := ssAuto;
    ContainerMitarbeiter.WidthStyle := ssPercent;
    ContainerMitarbeiter.ChildOrder := 5;
    ContainerMitarbeiter.ElementFont := efCSS;
    ContainerMitarbeiter.ElementPosition := epIgnore;
    ContainerMitarbeiter.ScrollStyle := ssNone;
    ContainerTable.SetParentComponent(Self);
    ContainerTable.Name := 'ContainerTable';
    ContainerTable.Left := 24;
    ContainerTable.Top := 381;
    ContainerTable.Width := 169;
    ContainerTable.Height := 41;
    ContainerTable.ElementClassName := 'container-fluid row-align-items-center';
    ContainerTable.HeightStyle := ssAuto;
    ContainerTable.WidthStyle := ssPercent;
    ContainerTable.ChildOrder := 5;
    ContainerTable.ElementFont := efCSS;
    ContainerTable.ElementPosition := epIgnore;
    ContainerTable.ScrollStyle := ssNone;
    WebProgressBar1.SetParentComponent(Self);
    WebProgressBar1.Name := 'WebProgressBar1';
    WebProgressBar1.Left := 613;
    WebProgressBar1.Top := 434;
    WebProgressBar1.Width := 148;
    WebProgressBar1.Height := 24;
    WebProgressBar1.ElementClassName := 'progress';
    WebProgressBar1.HeightStyle := ssAuto;
    WebProgressBar1.WidthStyle := ssPercent;
    WebProgressBar1.WidthPercent := 80.000000000000000000;
    WebProgressBar1.ChildOrder := 26;
    WebProgressBar1.ElementBarClassName := 'progress-bar';
    WebProgressBar1.ElementPosition := epIgnore;
    WebProgressBar1.Max := 15;
    WebProgressBar1.Position := 10;
    WebProgressBar1.Style := pbstDiv;
    ContainerProgress.SetParentComponent(Self);
    ContainerProgress.Name := 'ContainerProgress';
    ContainerProgress.Left := 560;
    ContainerProgress.Top := 279;
    ContainerProgress.Width := 169;
    ContainerProgress.Height := 41;
    ContainerProgress.ElementClassName := 'container-fluid row-align-items-center';
    ContainerProgress.HeightStyle := ssAuto;
    ContainerProgress.WidthStyle := ssPercent;
    ContainerProgress.ChildOrder := 5;
    ContainerProgress.ElementFont := efCSS;
    ContainerProgress.ElementPosition := epIgnore;
    ContainerProgress.ScrollStyle := ssNone;
    ContainerZusatz.SetParentComponent(Self);
    ContainerZusatz.Name := 'ContainerZusatz';
    ContainerZusatz.Left := 624;
    ContainerZusatz.Top := 326;
    ContainerZusatz.Width := 169;
    ContainerZusatz.Height := 41;
    ContainerZusatz.ElementClassName := 'col d-flex justify-content-center';
    ContainerZusatz.HeightStyle := ssAuto;
    ContainerZusatz.WidthStyle := ssPercent;
    ContainerZusatz.ChildOrder := 5;
    ContainerZusatz.ElementFont := efCSS;
    ContainerZusatz.ElementPosition := epIgnore;
    ContainerZusatz.ScrollStyle := ssNone;
    WClient.SetParentComponent(Self);
    WClient.Name := 'WClient';
    WClient.Connection := AuthConnection;
    WClient.Left := 448;
    WClient.Top := 8;
    AuthConnection.SetParentComponent(Self);
    AuthConnection.Name := 'AuthConnection';
    AuthConnection.URL := 'https://langwald-edv.net/cadiaserverauth';
    SetEvent(AuthConnection, Self, 'OnConnect', 'AuthConnectionConnect');
    AuthConnection.Left := 240;
    AuthConnection.Top := 8;
    WebHttpRequest1.SetParentComponent(Self);
    WebHttpRequest1.Name := 'WebHttpRequest1';
    WebHttpRequest1.Headers.BeginUpdate;
    try
      WebHttpRequest1.Headers.Clear;
      WebHttpRequest1.Headers.Add('Cache-Control=no-cache, no-store, must-revalidate');
    finally
      WebHttpRequest1.Headers.EndUpdate;
    end;
    WebHttpRequest1.URL := './config/CadiaWebConfig.cnf';
    SetEvent(WebHttpRequest1, Self, 'OnResponse', 'WebHttpRequest1Response');
    WebHttpRequest1.Left := 352;
    WebHttpRequest1.Top := 8;
    WebLocalStorage1.SetParentComponent(Self);
    WebLocalStorage1.Name := 'WebLocalStorage1';
    WebLocalStorage1.Left := 528;
    WebLocalStorage1.Top := 8;
    xdsCadiaServerSettings.SetParentComponent(Self);
    xdsCadiaServerSettings.Name := 'xdsCadiaServerSettings';
    xdsCadiaServerSettings.AfterOpen := xdsCadiaServerSettingsAfterOpen;
    xdsCadiaServerSettings.EntitySetName := 'CadiaServerSettings';
    xdsCadiaServerSettings.Connection := DM2.XDataWebConnection1;
    xdsCadiaServerSettings.Left := 664;
    xdsCadiaServerSettings.Top := 8;
    xdsCadiaServerSettingsLS_MANDANT.SetParentComponent(xdsCadiaServerSettings);
    xdsCadiaServerSettingsLS_MANDANT.Name := 'xdsCadiaServerSettingsLS_MANDANT';
    xdsCadiaServerSettingsLS_MANDANT.FieldName := 'LS_MANDANT';
    xdsCadiaServerSettingsLS_MANDANT.Required := True;
    xdsCadiaServerSettingsLS_MANDANT.Size := 50;
    xdsCadiaServerSettingsLS_HTTPS.SetParentComponent(xdsCadiaServerSettings);
    xdsCadiaServerSettingsLS_HTTPS.Name := 'xdsCadiaServerSettingsLS_HTTPS';
    xdsCadiaServerSettingsLS_HTTPS.FieldName := 'LS_HTTPS';
    xdsCadiaServerSettingsLS_HTTPS.Required := True;
    xdsCadiaServerSettingsLS_PORT.SetParentComponent(xdsCadiaServerSettings);
    xdsCadiaServerSettingsLS_PORT.Name := 'xdsCadiaServerSettingsLS_PORT';
    xdsCadiaServerSettingsLS_PORT.FieldName := 'LS_PORT';
    xdsCadiaServerSettingsLS_PORT.Required := True;
    xdsCadiaServerSettingsLS_XDATA.SetParentComponent(xdsCadiaServerSettings);
    xdsCadiaServerSettingsLS_XDATA.Name := 'xdsCadiaServerSettingsLS_XDATA';
    xdsCadiaServerSettingsLS_XDATA.FieldName := 'LS_XDATA';
    xdsCadiaServerSettingsLS_XDATA.Required := True;
    xdsCadiaServerSettingsLS_REMOTEDB.SetParentComponent(xdsCadiaServerSettings);
    xdsCadiaServerSettingsLS_REMOTEDB.Name := 'xdsCadiaServerSettingsLS_REMOTEDB';
    xdsCadiaServerSettingsLS_REMOTEDB.FieldName := 'LS_REMOTEDB';
    xdsCadiaServerSettingsLS_REMOTEDB.Required := True;
    xdsCadiaServerSettingsLS_JWT.SetParentComponent(xdsCadiaServerSettings);
    xdsCadiaServerSettingsLS_JWT.Name := 'xdsCadiaServerSettingsLS_JWT';
    xdsCadiaServerSettingsLS_JWT.FieldName := 'LS_JWT';
    xdsCadiaServerSettingsLS_JWT.Required := True;
    xdsCadiaServerSettingsLS_SUPERSECRETKEY.SetParentComponent(xdsCadiaServerSettings);
    xdsCadiaServerSettingsLS_SUPERSECRETKEY.Name := 'xdsCadiaServerSettingsLS_SUPERSECRETKEY';
    xdsCadiaServerSettingsLS_SUPERSECRETKEY.FieldName := 'LS_SUPERSECRETKEY';
    xdsCadiaServerSettingsLS_SUPERSECRETKEY.Size := 100;
    xdsCadiaServerSettingsLS_DBBENUTZER.SetParentComponent(xdsCadiaServerSettings);
    xdsCadiaServerSettingsLS_DBBENUTZER.Name := 'xdsCadiaServerSettingsLS_DBBENUTZER';
    xdsCadiaServerSettingsLS_DBBENUTZER.FieldName := 'LS_DBBENUTZER';
    xdsCadiaServerSettingsLS_DBBENUTZER.Required := True;
    xdsCadiaServerSettingsLS_DBBENUTZER.Size := 50;
    xdsCadiaServerSettingsLS_DBPASSWORT.SetParentComponent(xdsCadiaServerSettings);
    xdsCadiaServerSettingsLS_DBPASSWORT.Name := 'xdsCadiaServerSettingsLS_DBPASSWORT';
    xdsCadiaServerSettingsLS_DBPASSWORT.FieldName := 'LS_DBPASSWORT';
    xdsCadiaServerSettingsLS_DBPASSWORT.Required := True;
    xdsCadiaServerSettingsLS_DBPASSWORT.Size := 50;
    xdsCadiaServerSettingsLS_CB_Personalnummer.SetParentComponent(xdsCadiaServerSettings);
    xdsCadiaServerSettingsLS_CB_Personalnummer.Name := 'xdsCadiaServerSettingsLS_CB_Personalnummer';
    xdsCadiaServerSettingsLS_CB_Personalnummer.FieldName := 'LS_CB_Personalnummer';
    xdsCadiaServerSettingsLS_CB_LoginName.SetParentComponent(xdsCadiaServerSettings);
    xdsCadiaServerSettingsLS_CB_LoginName.Name := 'xdsCadiaServerSettingsLS_CB_LoginName';
    xdsCadiaServerSettingsLS_CB_LoginName.FieldName := 'LS_CB_LoginName';
    xdsCadiaServerSettingsLS_CB_LoginName.Size := 50;
    xdsCadiaServerSettingsLS_CB_LoginPassword.SetParentComponent(xdsCadiaServerSettings);
    xdsCadiaServerSettingsLS_CB_LoginPassword.Name := 'xdsCadiaServerSettingsLS_CB_LoginPassword';
    xdsCadiaServerSettingsLS_CB_LoginPassword.FieldName := 'LS_CB_LoginPassword';
    xdsCadiaServerSettingsLS_CB_LoginPassword.Size := 50;
    xdsPersonal.SetParentComponent(Self);
    xdsPersonal.Name := 'xdsPersonal';
    xdsPersonal.AfterOpen := xdsPersonalAfterOpen;
    xdsPersonal.EntitySetName := 'Personal';
    xdsPersonal.Connection := DM2.XDataWebConnection1;
    xdsPersonal.Left := 635;
    xdsPersonal.Top := 75;
    xdsPersonalPersonalnummer.SetParentComponent(xdsPersonal);
    xdsPersonalPersonalnummer.Name := 'xdsPersonalPersonalnummer';
    xdsPersonalPersonalnummer.FieldName := 'Personalnummer';
    xdsPersonalPersonalnummer.Required := True;
    xdsPersonalNachname.SetParentComponent(xdsPersonal);
    xdsPersonalNachname.Name := 'xdsPersonalNachname';
    xdsPersonalNachname.FieldName := 'Nachname';
    xdsPersonalNachname.Size := 40;
    xdsPersonalVorname.SetParentComponent(xdsPersonal);
    xdsPersonalVorname.Name := 'xdsPersonalVorname';
    xdsPersonalVorname.FieldName := 'Vorname';
    xdsPersonalVorname.Size := 40;
    xdsPersonalSchreibzeichen.SetParentComponent(xdsPersonal);
    xdsPersonalSchreibzeichen.Name := 'xdsPersonalSchreibzeichen';
    xdsPersonalSchreibzeichen.FieldName := 'Schreibzeichen';
    xdsPersonalSchreibzeichen.Size := 10;
    xdsPersonalLoginName.SetParentComponent(xdsPersonal);
    xdsPersonalLoginName.Name := 'xdsPersonalLoginName';
    xdsPersonalLoginName.FieldName := 'LoginName';
    xdsPersonalLoginName.Size := 50;
    xdsPersonalPassword.SetParentComponent(xdsPersonal);
    xdsPersonalPassword.Name := 'xdsPersonalPassword';
    xdsPersonalPassword.FieldName := 'Password';
    xdsPersonalPassword.Size := 50;
    xdsPersonalEnabled.SetParentComponent(xdsPersonal);
    xdsPersonalEnabled.Name := 'xdsPersonalEnabled';
    xdsPersonalEnabled.FieldName := 'Enabled';
    xdsPersonalEmail.SetParentComponent(xdsPersonal);
    xdsPersonalEmail.Name := 'xdsPersonalEmail';
    xdsPersonalEmail.FieldName := 'Email';
    xdsPersonalEmail.Size := 50;
    xdsPersonalFarbe.SetParentComponent(xdsPersonal);
    xdsPersonalFarbe.Name := 'xdsPersonalFarbe';
    xdsPersonalFarbe.FieldName := 'Farbe';
    xdsPersonalPersonalGUID.SetParentComponent(xdsPersonal);
    xdsPersonalPersonalGUID.Name := 'xdsPersonalPersonalGUID';
    xdsPersonalPersonalGUID.FieldName := 'PersonalGUID';
    xdsPersonalPersonalGUID.Size := 38;
    xdsPersonalRechteCadiaWEB.SetParentComponent(xdsPersonal);
    xdsPersonalRechteCadiaWEB.Name := 'xdsPersonalRechteCadiaWEB';
    xdsPersonalRechteCadiaWEB.FieldName := 'RechteCadiaWEB';
    xdsPersonalRechteCadiaWEB.Size := 255;
    xdsPersonalStundensatzIntern.SetParentComponent(xdsPersonal);
    xdsPersonalStundensatzIntern.Name := 'xdsPersonalStundensatzIntern';
    xdsPersonalStundensatzIntern.FieldName := 'StundensatzIntern';
    xdsMA.SetParentComponent(Self);
    xdsMA.Name := 'xdsMA';
    xdsMA.AfterOpen := xdsMAAfterOpen;
    xdsMA.EntitySetName := 'Personal';
    xdsMA.Connection := DM2.XDataWebConnection1;
    xdsMA.QueryString := '$orderby=Nachname, Vorname';
    xdsMA.Left := 667;
    xdsMA.Top := 139;
    xdsMAPersonalnummer.SetParentComponent(xdsMA);
    xdsMAPersonalnummer.Name := 'xdsMAPersonalnummer';
    xdsMAPersonalnummer.FieldName := 'Personalnummer';
    xdsMAPersonalnummer.Required := True;
    xdsMANachname.SetParentComponent(xdsMA);
    xdsMANachname.Name := 'xdsMANachname';
    xdsMANachname.FieldName := 'Nachname';
    xdsMANachname.Required := True;
    xdsMANachname.Size := 40;
    xdsMAVorname.SetParentComponent(xdsMA);
    xdsMAVorname.Name := 'xdsMAVorname';
    xdsMAVorname.FieldName := 'Vorname';
    xdsMAVorname.Size := 40;
    xdsMARechteCadiaWEB.SetParentComponent(xdsMA);
    xdsMARechteCadiaWEB.Name := 'xdsMARechteCadiaWEB';
    xdsMARechteCadiaWEB.FieldName := 'RechteCadiaWEB';
    xdsMARechteCadiaWEB.Size := 255;
    xdsMAEintrittsdatum.SetParentComponent(xdsMA);
    xdsMAEintrittsdatum.Name := 'xdsMAEintrittsdatum';
    xdsMAEintrittsdatum.FieldName := 'Eintrittsdatum';
    xdsMAAustrittsdatum.SetParentComponent(xdsMA);
    xdsMAAustrittsdatum.Name := 'xdsMAAustrittsdatum';
    xdsMAAustrittsdatum.FieldName := 'Austrittsdatum';
    xdsSingleArbeitszeit.SetParentComponent(Self);
    xdsSingleArbeitszeit.Name := 'xdsSingleArbeitszeit';
    xdsSingleArbeitszeit.AfterOpen := xdsSingleArbeitszeitAfterOpen;
    xdsSingleArbeitszeit.EntitySetName := 'PZE_Arbeitszeiten';
    xdsSingleArbeitszeit.Connection := DM2.XDataWebConnection1;
    xdsSingleArbeitszeit.Left := 384;
    xdsSingleArbeitszeit.Top := 72;
    xdsSingleArbeitszeitID.SetParentComponent(xdsSingleArbeitszeit);
    xdsSingleArbeitszeitID.Name := 'xdsSingleArbeitszeitID';
    xdsSingleArbeitszeitID.FieldName := 'ID';
    xdsSingleArbeitszeitID.Size := 38;
    xdsSingleArbeitszeitPersonalnummer.SetParentComponent(xdsSingleArbeitszeit);
    xdsSingleArbeitszeitPersonalnummer.Name := 'xdsSingleArbeitszeitPersonalnummer';
    xdsSingleArbeitszeitPersonalnummer.FieldName := 'Personalnummer';
    xdsSingleArbeitszeitPersonalnummer.Required := True;
    xdsSingleArbeitszeitDatum.SetParentComponent(xdsSingleArbeitszeit);
    xdsSingleArbeitszeitDatum.Name := 'xdsSingleArbeitszeitDatum';
    xdsSingleArbeitszeitDatum.FieldName := 'Datum';
    xdsSingleArbeitszeitDatum.Required := True;
    xdsSingleArbeitszeitDatum.DisplayFormat := 'DDD DD.MM.YYYY';
    xdsSingleArbeitszeitEintragsArt.SetParentComponent(xdsSingleArbeitszeit);
    xdsSingleArbeitszeitEintragsArt.Name := 'xdsSingleArbeitszeitEintragsArt';
    xdsSingleArbeitszeitEintragsArt.FieldName := 'EintragsArt';
    xdsSingleArbeitszeitEintragsArt.Required := True;
    xdsSingleArbeitszeitSollPause.SetParentComponent(xdsSingleArbeitszeit);
    xdsSingleArbeitszeitSollPause.Name := 'xdsSingleArbeitszeitSollPause';
    xdsSingleArbeitszeitSollPause.FieldName := 'SollPause';
    sourceSingleArbeitszeit.SetParentComponent(Self);
    sourceSingleArbeitszeit.Name := 'sourceSingleArbeitszeit';
    sourceSingleArbeitszeit.DataSet := xdsSingleArbeitszeit;
    sourceSingleArbeitszeit.Left := 240;
    sourceSingleArbeitszeit.Top := 72;
    xdsScan.SetParentComponent(Self);
    xdsScan.Name := 'xdsScan';
    xdsScan.AfterApplyUpdates := xdsScanAfterApplyUpdates;
    xdsScan.AfterOpen := xdsScanAfterOpen;
    xdsScan.AfterPost := xdsScanAfterPost;
    SetEvent(xdsScan, Self, 'OnNewRecord', 'xdsScanNewRecord');
    xdsScan.EntitySetName := 'PZE_ArbeitszeitenScan';
    xdsScan.Connection := DM2.XDataWebConnection1;
    xdsScan.Left := 384;
    xdsScan.Top := 136;
    xdsScanPersonalnummer.SetParentComponent(xdsScan);
    xdsScanPersonalnummer.Name := 'xdsScanPersonalnummer';
    xdsScanPersonalnummer.FieldName := 'Personalnummer';
    xdsScanScanDatumZeit.SetParentComponent(xdsScan);
    xdsScanScanDatumZeit.Name := 'xdsScanScanDatumZeit';
    xdsScanScanDatumZeit.FieldName := 'ScanDatumZeit';
    xdsScanScanDatumZeit.DisplayFormat := 'DD.MM.YYYY hh.mm.ss';
    xdsScanDatum.SetParentComponent(xdsScan);
    xdsScanDatum.Name := 'xdsScanDatum';
    xdsScanDatum.FieldName := 'Datum';
    xdsScanScanArt.SetParentComponent(xdsScan);
    xdsScanScanArt.Name := 'xdsScanScanArt';
    xdsScanScanArt.FieldName := 'ScanArt';
    xdsScanObjektreferenz.SetParentComponent(xdsScan);
    xdsScanObjektreferenz.Name := 'xdsScanObjektreferenz';
    xdsScanObjektreferenz.FieldName := 'Objektreferenz';
    xdsScanObjektreferenz.Size := 13;
    xdsScanScanBegin.SetParentComponent(xdsScan);
    xdsScanScanBegin.Name := 'xdsScanScanBegin';
    xdsScanScanBegin.FieldName := 'ScanBegin';
    xdsScanScanBegin.DisplayFormat := 'hh:mm';
    xdsScanScanEnde.SetParentComponent(xdsScan);
    xdsScanScanEnde.Name := 'xdsScanScanEnde';
    xdsScanScanEnde.FieldName := 'ScanEnde';
    xdsScanScanEnde.DisplayFormat := 'hh:mm';
    xdsScanausgewertet.SetParentComponent(xdsScan);
    xdsScanausgewertet.Name := 'xdsScanausgewertet';
    xdsScanausgewertet.FieldName := 'ausgewertet';
    xdsScanAMS.SetParentComponent(xdsScan);
    xdsScanAMS.Name := 'xdsScanAMS';
    xdsScanAMS.FieldName := 'AMS';
    xdsScanStundenArt.SetParentComponent(xdsScan);
    xdsScanStundenArt.Name := 'xdsScanStundenArt';
    xdsScanStundenArt.FieldName := 'StundenArt';
    xdsScanStundenArt.Size := 50;
    xdsScanFAID.SetParentComponent(xdsScan);
    xdsScanFAID.Name := 'xdsScanFAID';
    xdsScanFAID.FieldName := 'FAID';
    xdsScanID.SetParentComponent(xdsScan);
    xdsScanID.Name := 'xdsScanID';
    xdsScanID.FieldName := 'ID';
    xdsScanID.Size := 38;
    xdsScanKundennummer.SetParentComponent(xdsScan);
    xdsScanKundennummer.Name := 'xdsScanKundennummer';
    xdsScanKundennummer.FieldName := 'Kundennummer';
    xdsScanKundennummer.Size := 13;
    xdsScanAuftrag.SetParentComponent(xdsScan);
    xdsScanAuftrag.Name := 'xdsScanAuftrag';
    xdsScanAuftrag.FieldName := 'Auftrag';
    xdsScanAuftrag.Size := 10;
    xdsScanPAuftrag.SetParentComponent(xdsScan);
    xdsScanPAuftrag.Name := 'xdsScanPAuftrag';
    xdsScanPAuftrag.FieldName := 'PAuftrag';
    xdsScanPAuftrag.Size := 10;
    xdsScanArbeitArt.SetParentComponent(xdsScan);
    xdsScanArbeitArt.Name := 'xdsScanArbeitArt';
    xdsScanArbeitArt.FieldName := 'ArbeitArt';
    xdsScanInfos.SetParentComponent(xdsScan);
    xdsScanInfos.Name := 'xdsScanInfos';
    xdsScanInfos.FieldName := 'Infos';
    xdsScanInfos.Size := 255;
    xdsScanDauerMinuten.SetParentComponent(xdsScan);
    xdsScanDauerMinuten.Name := 'xdsScanDauerMinuten';
    xdsScanDauerMinuten.FieldName := 'DauerMinuten';
    xdsScanKalkStundensatz.SetParentComponent(xdsScan);
    xdsScanKalkStundensatz.Name := 'xdsScanKalkStundensatz';
    xdsScanKalkStundensatz.FieldName := 'KalkStundensatz';
    xdsScanKalkKosten.SetParentComponent(xdsScan);
    xdsScanKalkKosten.Name := 'xdsScanKalkKosten';
    xdsScanKalkKosten.FieldName := 'KalkKosten';
    sourceScan.SetParentComponent(Self);
    sourceScan.Name := 'sourceScan';
    sourceScan.DataSet := xdsScan;
    sourceScan.Left := 240;
    sourceScan.Top := 136;
    xdsPauseFix.SetParentComponent(Self);
    xdsPauseFix.Name := 'xdsPauseFix';
    xdsPauseFix.AfterApplyUpdates := xdsPauseFixAfterApplyUpdates;
    xdsPauseFix.AfterOpen := xdsPauseFixAfterOpen;
    xdsPauseFix.AfterPost := xdsPauseFixAfterPost;
    xdsPauseFix.EntitySetName := 'PZE_ArbeitszeitenScan';
    xdsPauseFix.Connection := DM2.XDataWebConnection1;
    xdsPauseFix.Left := 512;
    xdsPauseFix.Top := 72;
    xdsPauseFixFAID.SetParentComponent(xdsPauseFix);
    xdsPauseFixFAID.Name := 'xdsPauseFixFAID';
    xdsPauseFixFAID.FieldName := 'FAID';
    xdsPauseFixID.SetParentComponent(xdsPauseFix);
    xdsPauseFixID.Name := 'xdsPauseFixID';
    xdsPauseFixID.FieldName := 'ID';
    xdsPauseFixID.Size := 38;
    xdsPauseFixPersonalnummer.SetParentComponent(xdsPauseFix);
    xdsPauseFixPersonalnummer.Name := 'xdsPauseFixPersonalnummer';
    xdsPauseFixPersonalnummer.FieldName := 'Personalnummer';
    xdsPauseFixPersonalnummer.Required := True;
    xdsPauseFixScanDatumZeit.SetParentComponent(xdsPauseFix);
    xdsPauseFixScanDatumZeit.Name := 'xdsPauseFixScanDatumZeit';
    xdsPauseFixScanDatumZeit.FieldName := 'ScanDatumZeit';
    xdsPauseFixDatum.SetParentComponent(xdsPauseFix);
    xdsPauseFixDatum.Name := 'xdsPauseFixDatum';
    xdsPauseFixDatum.FieldName := 'Datum';
    xdsPauseFixDatum.Required := True;
    xdsPauseFixScanArt.SetParentComponent(xdsPauseFix);
    xdsPauseFixScanArt.Name := 'xdsPauseFixScanArt';
    xdsPauseFixScanArt.FieldName := 'ScanArt';
    xdsPauseFixObjektreferenz.SetParentComponent(xdsPauseFix);
    xdsPauseFixObjektreferenz.Name := 'xdsPauseFixObjektreferenz';
    xdsPauseFixObjektreferenz.FieldName := 'Objektreferenz';
    xdsPauseFixObjektreferenz.Size := 13;
    xdsPauseFixScanBegin.SetParentComponent(xdsPauseFix);
    xdsPauseFixScanBegin.Name := 'xdsPauseFixScanBegin';
    xdsPauseFixScanBegin.FieldName := 'ScanBegin';
    xdsPauseFixScanEnde.SetParentComponent(xdsPauseFix);
    xdsPauseFixScanEnde.Name := 'xdsPauseFixScanEnde';
    xdsPauseFixScanEnde.FieldName := 'ScanEnde';
    xdsPauseFixausgewertet.SetParentComponent(xdsPauseFix);
    xdsPauseFixausgewertet.Name := 'xdsPauseFixausgewertet';
    xdsPauseFixausgewertet.FieldName := 'ausgewertet';
    xdsPauseFixAMS.SetParentComponent(xdsPauseFix);
    xdsPauseFixAMS.Name := 'xdsPauseFixAMS';
    xdsPauseFixAMS.FieldName := 'AMS';
    xdsPauseFixStundenArt.SetParentComponent(xdsPauseFix);
    xdsPauseFixStundenArt.Name := 'xdsPauseFixStundenArt';
    xdsPauseFixStundenArt.FieldName := 'StundenArt';
    xdsPauseFixStundenArt.Size := 50;
    xdsPauseFixKundennummer.SetParentComponent(xdsPauseFix);
    xdsPauseFixKundennummer.Name := 'xdsPauseFixKundennummer';
    xdsPauseFixKundennummer.FieldName := 'Kundennummer';
    xdsPauseFixKundennummer.Size := 13;
    xdsPauseFixAuftrag.SetParentComponent(xdsPauseFix);
    xdsPauseFixAuftrag.Name := 'xdsPauseFixAuftrag';
    xdsPauseFixAuftrag.FieldName := 'Auftrag';
    xdsPauseFixAuftrag.Size := 10;
    xdsPauseFixPAuftrag.SetParentComponent(xdsPauseFix);
    xdsPauseFixPAuftrag.Name := 'xdsPauseFixPAuftrag';
    xdsPauseFixPAuftrag.FieldName := 'PAuftrag';
    xdsPauseFixPAuftrag.Size := 10;
    xdsPauseFixArbeitArt.SetParentComponent(xdsPauseFix);
    xdsPauseFixArbeitArt.Name := 'xdsPauseFixArbeitArt';
    xdsPauseFixArbeitArt.FieldName := 'ArbeitArt';
    xdsPauseFixInfos.SetParentComponent(xdsPauseFix);
    xdsPauseFixInfos.Name := 'xdsPauseFixInfos';
    xdsPauseFixInfos.FieldName := 'Infos';
    xdsPauseFixInfos.Size := 255;
    xdsPauseFixDauerMinuten.SetParentComponent(xdsPauseFix);
    xdsPauseFixDauerMinuten.Name := 'xdsPauseFixDauerMinuten';
    xdsPauseFixDauerMinuten.FieldName := 'DauerMinuten';
    xdsPauseFixKalkStundensatz.SetParentComponent(xdsPauseFix);
    xdsPauseFixKalkStundensatz.Name := 'xdsPauseFixKalkStundensatz';
    xdsPauseFixKalkStundensatz.FieldName := 'KalkStundensatz';
    xdsPauseFixKalkKosten.SetParentComponent(xdsPauseFix);
    xdsPauseFixKalkKosten.Name := 'xdsPauseFixKalkKosten';
    xdsPauseFixKalkKosten.FieldName := 'KalkKosten';
    xdsStundenart.SetParentComponent(Self);
    xdsStundenart.Name := 'xdsStundenart';
    xdsStundenart.AfterOpen := xdsStundenartAfterOpen;
    xdsStundenart.EntitySetName := 'ObjekteStundenarten';
    xdsStundenart.Connection := DM2.XDataWebConnection1;
    xdsStundenart.Left := 576;
    xdsStundenart.Top := 136;
    xdsStundenartStundenArt.SetParentComponent(xdsStundenart);
    xdsStundenartStundenArt.Name := 'xdsStundenartStundenArt';
    xdsStundenartStundenArt.FieldName := 'StundenArt';
    xdsStundenartStundenArt.Required := True;
    xdsStundenartStundenArt.Size := 50;
    xdsStundenartSTDNR.SetParentComponent(xdsStundenart);
    xdsStundenartSTDNR.Name := 'xdsStundenartSTDNR';
    xdsStundenartSTDNR.FieldName := 'STDNR';
    xdsStundenartSTDNR.Required := True;
    sourceStundenart.SetParentComponent(Self);
    sourceStundenart.Name := 'sourceStundenart';
    sourceStundenart.DataSet := xdsStundenart;
    sourceStundenart.Left := 496;
    sourceStundenart.Top := 136;
    xdsPZEEinstellungen.SetParentComponent(Self);
    xdsPZEEinstellungen.Name := 'xdsPZEEinstellungen';
    xdsPZEEinstellungen.AfterOpen := xdsPZEEinstellungenAfterOpen;
    xdsPZEEinstellungen.EntitySetName := 'PZE_Einstellungen';
    xdsPZEEinstellungen.Connection := DM2.XDataWebConnection1;
    xdsPZEEinstellungen.Left := 744;
    xdsPZEEinstellungen.Top := 80;
    xdsPZEEinstellungenZuordnungObjekt.SetParentComponent(xdsPZEEinstellungen);
    xdsPZEEinstellungenZuordnungObjekt.Name := 'xdsPZEEinstellungenZuordnungObjekt';
    xdsPZEEinstellungenZuordnungObjekt.FieldName := 'ZuordnungObjekt';
    xdsPZEEinstellungenZuordnungKontakt.SetParentComponent(xdsPZEEinstellungen);
    xdsPZEEinstellungenZuordnungKontakt.Name := 'xdsPZEEinstellungenZuordnungKontakt';
    xdsPZEEinstellungenZuordnungKontakt.FieldName := 'ZuordnungKontakt';
    xdsPZEEinstellungenZuordnungAuftrag.SetParentComponent(xdsPZEEinstellungen);
    xdsPZEEinstellungenZuordnungAuftrag.Name := 'xdsPZEEinstellungenZuordnungAuftrag';
    xdsPZEEinstellungenZuordnungAuftrag.FieldName := 'ZuordnungAuftrag';
    xdsPZEEinstellungenZuordnungProduktion.SetParentComponent(xdsPZEEinstellungen);
    xdsPZEEinstellungenZuordnungProduktion.Name := 'xdsPZEEinstellungenZuordnungProduktion';
    xdsPZEEinstellungenZuordnungProduktion.FieldName := 'ZuordnungProduktion';
    xdsPZEEinstellungenAuswahlNurKontaktnummer.SetParentComponent(xdsPZEEinstellungen);
    xdsPZEEinstellungenAuswahlNurKontaktnummer.Name := 'xdsPZEEinstellungenAuswahlNurKontaktnummer';
    xdsPZEEinstellungenAuswahlNurKontaktnummer.FieldName := 'AuswahlNurKontaktnummer';
    xdsPZEEinstellungenPauseVorgabe.SetParentComponent(xdsPZEEinstellungen);
    xdsPZEEinstellungenPauseVorgabe.Name := 'xdsPZEEinstellungenPauseVorgabe';
    xdsPZEEinstellungenPauseVorgabe.FieldName := 'PauseVorgabe';
    xdsPZEEinstellungenCadiaPZEWebModus.SetParentComponent(xdsPZEEinstellungen);
    xdsPZEEinstellungenCadiaPZEWebModus.Name := 'xdsPZEEinstellungenCadiaPZEWebModus';
    xdsPZEEinstellungenCadiaPZEWebModus.FieldName := 'CadiaPZEWebModus';
    WebTimer1.SetParentComponent(Self);
    WebTimer1.Name := 'WebTimer1';
    WebTimer1.Enabled := False;
    SetEvent(WebTimer1, Self, 'OnTimer', 'WebTimer1Timer');
    WebTimer1.Left := 720;
    WebTimer1.Top := 224;
    WClientServerZeit.SetParentComponent(Self);
    WClientServerZeit.Name := 'WClientServerZeit';
    WClientServerZeit.Connection := DM2.XDataWebConnection1;
    WClientServerZeit.Left := 744;
    WClientServerZeit.Top := 144;
    xdsCheckObjekt.SetParentComponent(Self);
    xdsCheckObjekt.Name := 'xdsCheckObjekt';
    xdsCheckObjekt.AfterOpen := xdsCheckObjektAfterOpen;
    xdsCheckObjekt.EntitySetName := 'Objekte';
    xdsCheckObjekt.Connection := DM2.XDataWebConnection1;
    xdsCheckObjekt.QueryTop := 1;
    xdsCheckObjekt.Left := 664;
    xdsCheckObjekt.Top := 200;
    xdsCheckObjektObjektReferenz.SetParentComponent(xdsCheckObjekt);
    xdsCheckObjektObjektReferenz.Name := 'xdsCheckObjektObjektReferenz';
    xdsCheckObjektObjektReferenz.FieldName := 'ObjektReferenz';
    xdsCheckObjektObjektReferenz.Required := True;
    xdsCheckObjektObjektReferenz.Size := 13;
    xdsCheckObjektKurzbezeichnung.SetParentComponent(xdsCheckObjekt);
    xdsCheckObjektKurzbezeichnung.Name := 'xdsCheckObjektKurzbezeichnung';
    xdsCheckObjektKurzbezeichnung.FieldName := 'Kurzbezeichnung';
    xdsCheckObjektKurzbezeichnung.Size := 25;
    xdsCheckObjektBezeichnung.SetParentComponent(xdsCheckObjekt);
    xdsCheckObjektBezeichnung.Name := 'xdsCheckObjektBezeichnung';
    xdsCheckObjektBezeichnung.FieldName := 'Bezeichnung';
    xdsCheckObjektBezeichnung.Size := 255;
    xdsCheckObjektObjektnummer.SetParentComponent(xdsCheckObjekt);
    xdsCheckObjektObjektnummer.Name := 'xdsCheckObjektObjektnummer';
    xdsCheckObjektObjektnummer.FieldName := 'Objektnummer';
    xdsCheckObjektObjektnummer.Size := 25;
    xdsCheckAuftrag.SetParentComponent(Self);
    xdsCheckAuftrag.Name := 'xdsCheckAuftrag';
    xdsCheckAuftrag.AfterOpen := xdsCheckAuftragAfterOpen;
    xdsCheckAuftrag.EntitySetName := 'Auftrag';
    xdsCheckAuftrag.Connection := DM2.XDataWebConnection1;
    xdsCheckAuftrag.QueryTop := 1;
    xdsCheckAuftrag.Left := 560;
    xdsCheckAuftrag.Top := 232;
    xdsCheckAuftragNummerkomplett.SetParentComponent(xdsCheckAuftrag);
    xdsCheckAuftragNummerkomplett.Name := 'xdsCheckAuftragNummerkomplett';
    xdsCheckAuftragNummerkomplett.FieldName := 'Nummerkomplett';
    xdsCheckAuftragNummerkomplett.Required := True;
    xdsCheckAuftragNummerkomplett.Size := 10;
    xdsCheckAuftragAuftragsbezeichnung.SetParentComponent(xdsCheckAuftrag);
    xdsCheckAuftragAuftragsbezeichnung.Name := 'xdsCheckAuftragAuftragsbezeichnung';
    xdsCheckAuftragAuftragsbezeichnung.FieldName := 'Auftragsbezeichnung';
    xdsCheckAuftragAuftragsbezeichnung.Size := 255;
    xdsCheckProduktion.SetParentComponent(Self);
    xdsCheckProduktion.Name := 'xdsCheckProduktion';
    xdsCheckProduktion.AfterOpen := xdsCheckProduktionAfterOpen;
    xdsCheckProduktion.EntitySetName := 'Produktion';
    xdsCheckProduktion.Connection := DM2.XDataWebConnection1;
    xdsCheckProduktion.QueryTop := 1;
    xdsCheckProduktion.Left := 560;
    xdsCheckProduktion.Top := 296;
    xdsCheckProduktionNummerkomplett.SetParentComponent(xdsCheckProduktion);
    xdsCheckProduktionNummerkomplett.Name := 'xdsCheckProduktionNummerkomplett';
    xdsCheckProduktionNummerkomplett.FieldName := 'Nummerkomplett';
    xdsCheckProduktionNummerkomplett.Required := True;
    xdsCheckProduktionNummerkomplett.Size := 10;
    xdsCheckProduktionAuftragsbezeichnung.SetParentComponent(xdsCheckProduktion);
    xdsCheckProduktionAuftragsbezeichnung.Name := 'xdsCheckProduktionAuftragsbezeichnung';
    xdsCheckProduktionAuftragsbezeichnung.FieldName := 'Auftragsbezeichnung';
    xdsCheckProduktionAuftragsbezeichnung.Size := 255;
    xdsCheckKontakt.SetParentComponent(Self);
    xdsCheckKontakt.Name := 'xdsCheckKontakt';
    xdsCheckKontakt.AfterOpen := xdsCheckKontaktAfterOpen;
    xdsCheckKontakt.EntitySetName := 'Adressen';
    xdsCheckKontakt.Connection := DM2.XDataWebConnection1;
    xdsCheckKontakt.QueryTop := 1;
    xdsCheckKontakt.Left := 552;
    xdsCheckKontakt.Top := 424;
    xdsCheckKontaktKundennummer.SetParentComponent(xdsCheckKontakt);
    xdsCheckKontaktKundennummer.Name := 'xdsCheckKontaktKundennummer';
    xdsCheckKontaktKundennummer.FieldName := 'Kundennummer';
    xdsCheckKontaktKundennummer.Required := True;
    xdsCheckKontaktKundennummer.Size := 13;
    xdsCheckKontaktNachname.SetParentComponent(xdsCheckKontakt);
    xdsCheckKontaktNachname.Name := 'xdsCheckKontaktNachname';
    xdsCheckKontaktNachname.FieldName := 'Nachname';
    xdsCheckKontaktNachname.Size := 40;
    xdsCheckKontaktVorname.SetParentComponent(xdsCheckKontakt);
    xdsCheckKontaktVorname.Name := 'xdsCheckKontaktVorname';
    xdsCheckKontaktVorname.FieldName := 'Vorname';
    xdsCheckKontaktVorname.Size := 40;
    ScanTimer.SetParentComponent(Self);
    ScanTimer.Name := 'ScanTimer';
    ScanTimer.Enabled := False;
    ScanTimer.Interval := 100;
    SetEvent(ScanTimer, Self, 'OnTimer', 'ScanTimerTimer');
    ScanTimer.Left := 760;
    ScanTimer.Top := 384;
  finally
    labelonlinestatus.AfterLoadDFMValues;
    lblAnmeldung.AfterLoadDFMValues;
    lblchecklogin.AfterLoadDFMValues;
    lblstatus.AfterLoadDFMValues;
    LabelPZEFunktion.AfterLoadDFMValues;
    LabelScanMitarbeiterausweis.AfterLoadDFMValues;
    labelMitarbeiterauswahl.AfterLoadDFMValues;
    LabelLetzteAktion.AfterLoadDFMValues;
    LabelMitarbeiter.AfterLoadDFMValues;
    LabelZeitabweichung.AfterLoadDFMValues;
    LabelScanAlternativ.AfterLoadDFMValues;
    lblCadiaKundennummer.AfterLoadDFMValues;
    Container1.AfterLoadDFMValues;
    Container2.AfterLoadDFMValues;
    Container3.AfterLoadDFMValues;
    Container4.AfterLoadDFMValues;
    Container5.AfterLoadDFMValues;
    panelfunktionen.AfterLoadDFMValues;
    btnAnmelden.AfterLoadDFMValues;
    btnPauseBeginn.AfterLoadDFMValues;
    btnPauseEnde.AfterLoadDFMValues;
    btnAbmelden.AfterLoadDFMValues;
    btnObjektBeginn.AfterLoadDFMValues;
    btnObjektEnde.AfterLoadDFMValues;
    btnErneutAnmelden.AfterLoadDFMValues;
    btnKontaktBeginn.AfterLoadDFMValues;
    btnKontaktEnde.AfterLoadDFMValues;
    btnAuftragBeginn.AfterLoadDFMValues;
    btnAuftragEnde.AfterLoadDFMValues;
    btnProduktionBeginn.AfterLoadDFMValues;
    btnProduktionEnde.AfterLoadDFMValues;
    btnPauseVorgabe.AfterLoadDFMValues;
    TC.AfterLoadDFMValues;
    panelstundenart.AfterLoadDFMValues;
    lblauswahlobjekt.AfterLoadDFMValues;
    btnObjektOK.AfterLoadDFMValues;
    btnObjektAbbrechen.AfterLoadDFMValues;
    lookupstundenart.AfterLoadDFMValues;
    panelArbeitsart.AfterLoadDFMValues;
    lblauswahlinfo.AfterLoadDFMValues;
    radioarbeitsart.AfterLoadDFMValues;
    btnOK.AfterLoadDFMValues;
    btnAbbrechen.AfterLoadDFMValues;
    ContainerMitarbeiterausweis.AfterLoadDFMValues;
    edtSuchbegriff.AfterLoadDFMValues;
    ContainerLabelMitarbeiterAuswahl.AfterLoadDFMValues;
    ContainerModus.AfterLoadDFMValues;
    ContainerLetzteAktion.AfterLoadDFMValues;
    ContainerStatus.AfterLoadDFMValues;
    ContainerMitarbeiter.AfterLoadDFMValues;
    ContainerTable.AfterLoadDFMValues;
    WebProgressBar1.AfterLoadDFMValues;
    ContainerProgress.AfterLoadDFMValues;
    ContainerZusatz.AfterLoadDFMValues;
    WClient.AfterLoadDFMValues;
    AuthConnection.AfterLoadDFMValues;
    WebHttpRequest1.AfterLoadDFMValues;
    WebLocalStorage1.AfterLoadDFMValues;
    xdsCadiaServerSettings.AfterLoadDFMValues;
    xdsCadiaServerSettingsLS_MANDANT.AfterLoadDFMValues;
    xdsCadiaServerSettingsLS_HTTPS.AfterLoadDFMValues;
    xdsCadiaServerSettingsLS_PORT.AfterLoadDFMValues;
    xdsCadiaServerSettingsLS_XDATA.AfterLoadDFMValues;
    xdsCadiaServerSettingsLS_REMOTEDB.AfterLoadDFMValues;
    xdsCadiaServerSettingsLS_JWT.AfterLoadDFMValues;
    xdsCadiaServerSettingsLS_SUPERSECRETKEY.AfterLoadDFMValues;
    xdsCadiaServerSettingsLS_DBBENUTZER.AfterLoadDFMValues;
    xdsCadiaServerSettingsLS_DBPASSWORT.AfterLoadDFMValues;
    xdsCadiaServerSettingsLS_CB_Personalnummer.AfterLoadDFMValues;
    xdsCadiaServerSettingsLS_CB_LoginName.AfterLoadDFMValues;
    xdsCadiaServerSettingsLS_CB_LoginPassword.AfterLoadDFMValues;
    xdsPersonal.AfterLoadDFMValues;
    xdsPersonalPersonalnummer.AfterLoadDFMValues;
    xdsPersonalNachname.AfterLoadDFMValues;
    xdsPersonalVorname.AfterLoadDFMValues;
    xdsPersonalSchreibzeichen.AfterLoadDFMValues;
    xdsPersonalLoginName.AfterLoadDFMValues;
    xdsPersonalPassword.AfterLoadDFMValues;
    xdsPersonalEnabled.AfterLoadDFMValues;
    xdsPersonalEmail.AfterLoadDFMValues;
    xdsPersonalFarbe.AfterLoadDFMValues;
    xdsPersonalPersonalGUID.AfterLoadDFMValues;
    xdsPersonalRechteCadiaWEB.AfterLoadDFMValues;
    xdsPersonalStundensatzIntern.AfterLoadDFMValues;
    xdsMA.AfterLoadDFMValues;
    xdsMAPersonalnummer.AfterLoadDFMValues;
    xdsMANachname.AfterLoadDFMValues;
    xdsMAVorname.AfterLoadDFMValues;
    xdsMARechteCadiaWEB.AfterLoadDFMValues;
    xdsMAEintrittsdatum.AfterLoadDFMValues;
    xdsMAAustrittsdatum.AfterLoadDFMValues;
    xdsSingleArbeitszeit.AfterLoadDFMValues;
    xdsSingleArbeitszeitID.AfterLoadDFMValues;
    xdsSingleArbeitszeitPersonalnummer.AfterLoadDFMValues;
    xdsSingleArbeitszeitDatum.AfterLoadDFMValues;
    xdsSingleArbeitszeitEintragsArt.AfterLoadDFMValues;
    xdsSingleArbeitszeitSollPause.AfterLoadDFMValues;
    sourceSingleArbeitszeit.AfterLoadDFMValues;
    xdsScan.AfterLoadDFMValues;
    xdsScanPersonalnummer.AfterLoadDFMValues;
    xdsScanScanDatumZeit.AfterLoadDFMValues;
    xdsScanDatum.AfterLoadDFMValues;
    xdsScanScanArt.AfterLoadDFMValues;
    xdsScanObjektreferenz.AfterLoadDFMValues;
    xdsScanScanBegin.AfterLoadDFMValues;
    xdsScanScanEnde.AfterLoadDFMValues;
    xdsScanausgewertet.AfterLoadDFMValues;
    xdsScanAMS.AfterLoadDFMValues;
    xdsScanStundenArt.AfterLoadDFMValues;
    xdsScanFAID.AfterLoadDFMValues;
    xdsScanID.AfterLoadDFMValues;
    xdsScanKundennummer.AfterLoadDFMValues;
    xdsScanAuftrag.AfterLoadDFMValues;
    xdsScanPAuftrag.AfterLoadDFMValues;
    xdsScanArbeitArt.AfterLoadDFMValues;
    xdsScanInfos.AfterLoadDFMValues;
    xdsScanDauerMinuten.AfterLoadDFMValues;
    xdsScanKalkStundensatz.AfterLoadDFMValues;
    xdsScanKalkKosten.AfterLoadDFMValues;
    sourceScan.AfterLoadDFMValues;
    xdsPauseFix.AfterLoadDFMValues;
    xdsPauseFixFAID.AfterLoadDFMValues;
    xdsPauseFixID.AfterLoadDFMValues;
    xdsPauseFixPersonalnummer.AfterLoadDFMValues;
    xdsPauseFixScanDatumZeit.AfterLoadDFMValues;
    xdsPauseFixDatum.AfterLoadDFMValues;
    xdsPauseFixScanArt.AfterLoadDFMValues;
    xdsPauseFixObjektreferenz.AfterLoadDFMValues;
    xdsPauseFixScanBegin.AfterLoadDFMValues;
    xdsPauseFixScanEnde.AfterLoadDFMValues;
    xdsPauseFixausgewertet.AfterLoadDFMValues;
    xdsPauseFixAMS.AfterLoadDFMValues;
    xdsPauseFixStundenArt.AfterLoadDFMValues;
    xdsPauseFixKundennummer.AfterLoadDFMValues;
    xdsPauseFixAuftrag.AfterLoadDFMValues;
    xdsPauseFixPAuftrag.AfterLoadDFMValues;
    xdsPauseFixArbeitArt.AfterLoadDFMValues;
    xdsPauseFixInfos.AfterLoadDFMValues;
    xdsPauseFixDauerMinuten.AfterLoadDFMValues;
    xdsPauseFixKalkStundensatz.AfterLoadDFMValues;
    xdsPauseFixKalkKosten.AfterLoadDFMValues;
    xdsStundenart.AfterLoadDFMValues;
    xdsStundenartStundenArt.AfterLoadDFMValues;
    xdsStundenartSTDNR.AfterLoadDFMValues;
    sourceStundenart.AfterLoadDFMValues;
    xdsPZEEinstellungen.AfterLoadDFMValues;
    xdsPZEEinstellungenZuordnungObjekt.AfterLoadDFMValues;
    xdsPZEEinstellungenZuordnungKontakt.AfterLoadDFMValues;
    xdsPZEEinstellungenZuordnungAuftrag.AfterLoadDFMValues;
    xdsPZEEinstellungenZuordnungProduktion.AfterLoadDFMValues;
    xdsPZEEinstellungenAuswahlNurKontaktnummer.AfterLoadDFMValues;
    xdsPZEEinstellungenPauseVorgabe.AfterLoadDFMValues;
    xdsPZEEinstellungenCadiaPZEWebModus.AfterLoadDFMValues;
    WebTimer1.AfterLoadDFMValues;
    WClientServerZeit.AfterLoadDFMValues;
    xdsCheckObjekt.AfterLoadDFMValues;
    xdsCheckObjektObjektReferenz.AfterLoadDFMValues;
    xdsCheckObjektKurzbezeichnung.AfterLoadDFMValues;
    xdsCheckObjektBezeichnung.AfterLoadDFMValues;
    xdsCheckObjektObjektnummer.AfterLoadDFMValues;
    xdsCheckAuftrag.AfterLoadDFMValues;
    xdsCheckAuftragNummerkomplett.AfterLoadDFMValues;
    xdsCheckAuftragAuftragsbezeichnung.AfterLoadDFMValues;
    xdsCheckProduktion.AfterLoadDFMValues;
    xdsCheckProduktionNummerkomplett.AfterLoadDFMValues;
    xdsCheckProduktionAuftragsbezeichnung.AfterLoadDFMValues;
    xdsCheckKontakt.AfterLoadDFMValues;
    xdsCheckKontaktKundennummer.AfterLoadDFMValues;
    xdsCheckKontaktNachname.AfterLoadDFMValues;
    xdsCheckKontaktVorname.AfterLoadDFMValues;
    ScanTimer.AfterLoadDFMValues;
  end;
end;

end.